export const malay = {
    global: {
        test: "ujian",
        next: "Seterusnya",
        name: "Nama",
        email: "E-mel",
        view: "Lihat",
        edit: "Edit",
        close: "Tutup",
        Close: "Tutup",
        DOWNLOAD: "MUAT TURUN",
        submit: "Hantar",
        ADD: "TAMBAH",
        CANCEL: "BATAL",
        SAVE: "SIMPAN",
        DELETE: "PADAM",
        Delete: "Padam",
        Duplicate: "Salin",
        SHARE: "KONGSI",
        no: "Tidak",
        type: "Jenis",
        english: "Inggeris",
        thai: "Thai",
        emailEtc: "name@example.com",
        ark_for_help: "Minta bantuan",
        Search: "Cari",
        workspace: "Workspace",
        language: "Bahasa",
        logout: "Log Keluar",
        search_results: "Hasil Carian",
        Confirm: "Sahkan",
        Cancel: "Batal",
        account_switcher: {
            add_account: "Tambah Akaun",
            log_out: "Log Keluar",
            log_out_of: "Log keluar daripada",
            switch_failed: "Gagal menukar akaun",
            sign_in_plus_email: "Log masuk dengan e-mel +",
            your_accounts: "Akaun anda",
            email_address: "Alamat e-mel",
            sending: "Menghantar...",
            continue: "Teruskan",
            code_sent_to: "Kod dihantar ke",
            verification_code: "Kod pengesahan",
            four_digit_code: "Kod 4 digit",
            verifying: "Mengesahkan...",
            different_email: "E-mel lain",
        },
        Save: "Simpan",
    },
    category: {
        power_skill: {
            empathy: "Empati",
            self_awareness: "Kesedaran Diri",
            leadership: "Kepimpinan",
            initiative_making: "Mengambil Inisiatif",
            optimism: "Optimisme",
            critical_thinking: "Pemikiran Kritis",
        },
        frequency: {
            one_time: "Sekali Sahaja",
            weekly: "Mingguan",
            monthly: "Bulanan",
            quarterly: "Suku Tahunan",
            biannually: "Setiap 6 Bulan",
            yearly: "Tahunan",
        },
        day_of_week: {
            monday: "Isnin",
            tuesday: "Selasa",
            wednesday: "Rabu",
            thursday: "Khamis",
            friday: "Jumaat",
            saturday: "Sabtu",
            sunday: "Ahad",
        },
        day_of_week_m: {
            mon: "Isn",
            tue: "Sel",
            wed: "Rab",
            thu: "Kha",
            fri: "Jum",
            sat: "Sab",
            sun: "Ahd",
        },
        Talent_Types: {
            Starter: "Starter",
            Marginalized: "Marginalized",
            Latent_Potential: "Latent Potential",
            Up_and_coming: "Up-and-coming",
            Supported: "Supported",
            Underutilized: "Underutilized",
            Contributor: "Contributor",
            Rising_Star: "Rising Star",
            High_Contributor: "High Contributor",
            Activated: "Activated",
            Crowd_Favorite: "Crowd Favorite",
            Developing: "Developing",
            Community_Pillar: "Community Pillar",
            Key_Player: "Key Player",
            Respected_Expert: "Respected Expert",
            Distinguished_Talent: "Distinguished Talent",
            Engaged_Contributor: "Engaged Contributor",
            Valued_Contributor: "Valued Contributor",
            Untapped_Potential: "Untapped Potential",
            Emerging_Talent: "Emerging Talent",
            Core_Player: "Core Player",
            High_Performer: "High Performer",
            Hidden_Talent: "Hidden Talent",
            Unsung_Talent: "Unsung Talent",
            High_Potential: "High Potential",
            Solid_Performer: "Solid Performer",
            Superstar: "Superstar",
        },
        Network_type: {
            Low_Network: "Low Network",
            Medium_Inner: "Medium Inner",
            High_Inner: "High Inner",
            Super_Inner: "Super Inner",
            Medium_Outer: "Medium Outer",
            High_Outer: "High Outer",
            Super_Outer: "Super Outer",
            Medium_Network: "Medium Network",
            High_Network: "High Network",
            Super_Network: "Super Network",
        },
    },
    page: {
        awards: "Anugerah",
        awardsDescription: "Dapat pengiktirafan sebagai majikan terkemuka dengan metrik berasaskan tingkah laku",
        status: "Status",
        timeLine: "Garis Masa",
        billing: "Pengebilan",
        billing_description: "Semak caj langganan, aktiviti ganjaran dan tambah nilai kredit mengikut tempoh bil",
        happilyVillage: "Happily Village",
        happilyVillage_description: "Lihat dan urus interaksi dan pengalaman Village",
        overview: "Gambaran",
        university: "University",
        townHall: "Town Hall",
        runningTrack: "Running Track",
        battleStadium: "Battle Stadium",
        insights: "Insights",
        insights_description: "Data dan cerapan masa nyata tentang pasukan dan pekerja anda",
        skills: "Kemahiran",
        skills_description: "Kenal pasti kekuatan dan peluang untuk pembelajaran dan pembangunan",
        programs: "Program",
        programs_description: "Pengalaman berpandu berbilang minggu untuk onboarding, kepimpinan, kesejahteraan, dan pematuhan",
        dashboard: "Dashboard",
        teams: "Pasukan",
        cohorts: "Kohort",
        managers: "Pengurus",
        people: "Pekerja",
        reportCard: "Kad Laporan",
        integrations: "Integrasi",
        integrations_description: "Segerakkan data pekerja dan sambung dengan perkhidmatan lain",
        HRIS_Sync: "HRIS Sync",
        API: "API",
        members: "Ahli",
        members_description: "Urus ahli, pasukan, dan pengurus anda",
        power_up: "Power-ups",
        power_up_description: "Hantar pengiktirafan kepada orang yang hebat",
        recognition: "Pengiktirafan",
        recognition_description: "Hantar pengiktirafan kepada orang yang hebat",
        performance: "Prestasi",
        performance_description: "Jejak prestasi terhadap budaya dan matlamat serta fahami bidang fokus",
        focus_areas: "Bidang Fokus",
        goals: "Matlamat",
        coming_soon: "Akan datang...",
        create: "Cipta",
        outbox: "Peti Keluar",
        activity: "Aktiviti",
        questions: "Soalan",
        questions_description: "Urus soalan, tambah soalan anda, dan lihat jawapan",
        standard: "Pustaka Standard",
        custom: "Soalan Tersuai",
        reports: "Laporan",
        reports_description: "Pratonton dan muat turun laporan yang dijana secara automatik",
        daily: "Harian",
        weekly: "Mingguan",
        monthly: "Bulanan",
        rewards: "Ganjaran",
        rewards_description: "Urus Gift Cards dan Ganjaran Syarikat anda",
        gift_cards: "Gift Cards",
        perks: "Manfaat",
        team_building: "Pembinaan Pasukan",
        doing_good: "Berbuat Baik",
        merchandise: "Barangan",
        "%_merchandise_%": "Barangan",
        setup_wizard: "Wizard Persediaan",
        setup_wizard_description: "Mari kita mulakan persediaan! Anda hanya beberapa minit daripada tempat kerja yang lebih gembira.",
        sparks: "Sparks",
        sparks_description: "Ubah cara pekerja dan pengurus anda menangani masalah",
        micro_learning: "Micro-Learning",
        leaderboards: "Leaderboards",
        settings: "Tetapan",
        settings_description: "Urus akaun, ahli, dan pilihan anda",
        statusPage: "Halaman Status",
        statusPage_description: "Semak status langsung perkhidmatan Happily",
        documentation_dev: "Documentation(Dev)",
        login_title: "Log Masuk",
        pincode_title: "Kod PIN",
        relationship_mapping: "Pemetaan Hubungan",
        reward_message: "Mesej Ganjaran",
        user_registration: "Pendaftaran Pengguna",
        nav_groups: {
            analyze: "Analisis",
            manage: "Urus",
            develop: "Kembangkan",
            engage: "Libatkan",
            admin: "Admin",
        },
    },
    commponents: {
        years: "tahun",
        months: "bulan",
        days_ago: "hari lalu",
        joined_after: "menyertai selepas",
        joined: "Menyertai",
        daily_streak: "Daily Streak",
        achievements: "Pencapaian",
        super_feedback: "Super Feedback",
        MOST_RECENT: "TERKINI",
        power: "Kuasa",
        badges: "Badges",
        org: "Org",
        relationships: "Hubungan",
    },
    setupWizard: {
        stepOne: {
            title: "Selamat Datang",
            hi: "Hai",
            header: "Selamat datang ke Happily!",
            contentOne: "Anda hebat kerana memulakan pengalaman positif di tempat kerja anda. Dengan Happily, anda membolehkan maklum balas, pengiktirafan, pembelajaran, komuniti yang lebih baik dan banyak lagi!",
            contentTwo: "Untuk memulakan, kami perlu menyediakan pasukan anda, memilih ganjaran, dan menghantar jemputan. Mari mulakan!",
            What_are_your: "Apakah nilai teras syarikat anda?",
        },
        stepTwo: {
            title: "Cipta Pasukan",
            header: "Cipta Pasukan Anda",
            contentOne: "Happily berfungsi dalam pasukan dan pengurus berada di tengah-tengahnya. Maklum Balas, Cerapan, dan Laporan dihantar kepada pengurus pasukan pada setiap hari kerja untuk membantu mereka memahami pasukan dengan lebih baik secara masa nyata. Bantu kami sediakan pasukan anda.",
            teamName: "Nama Pasukan",
            teamNameEtc: "ACME Inc",
            managersNameEt: "Nama Pengurus",
            email: "E-mel",
            memberName: "Nama Ahli",
        },
        stepThree: {
            title: "Pilih Ganjaran",
            contentOne: "Pasukan anda boleh menggunakan Coins dan Gems yang dikumpul daripada menjawab soalan harian (dan interaksi lain) untuk menebus ganjaran! Pilih ganjaran anda di bawah. Anda juga boleh menambah ganjaran tersuai kemudian.",
            SelectOneTitle: "Manfaat Syarikat",
            SelectOneContentOne: "Mulakan dengan pilihan manfaat tempat kerja terkurasi kami yang memberi ganjaran kepada pekerja paling terlibat.",
            SelectOneContentTwo: "Ganjaran boleh dikonfigurasi daripada konsol admin anda.",
            SelectTwoTitle: "Gift Cards (tidak tersedia dalam percubaan)",
            SelectTwoContentOne: "Biarkan pasukan anda menebus Gift Cards daripada penjual tempatan dan kedai dalam talian.",
            SelectTwoContentTwo: "Beli kredit untuk mendayakan gift cards, tanpa caj tambahan.",
        },
        stepFour: {
            title: "Sahkan & Jemput",
            contentOne: "Hampir siap! Tetapkan masa anda ingin pasukan menerima soalan Daily Pulse mereka. Kami mengesyorkan memilih masa ketika pasukan anda sedang ke tempat kerja.",
            quickSettings: "TETAPAN PANTAS",
            dailyPulse: "Daily Pulse",
            whatHappensNext: "APA YANG BERLAKU SETERUSNYA",
            contentOneWhatHappensNext: "Jemputan akan dihantar kepada pasukan anda dan semua orang akan menerima set pertama soalan Daily Pulse mereka pada hari kerja seterusnya.",
            contentTwoWhatHappensNext: "Terokai konsol admin anda untuk menambah ahli, melihat cerapan, mencipta soalan & ganjaran tersuai, atau menyunting tetapan akaun anda.",
        },
    },
    fourZeroFour: {
        looks_like_somehing: "Nampaknya ada sesuatu yang tidak kena",
        the_page_you: "halaman yang anda cari tidak tersedia!",
        home_page: "Halaman Utama",
    },
    awards: {
        happily_awards: "Happily Awards",
        recognition_driven: "Dipacu Pengiktirafan",
        the_practice_of: "Amalan pengiktirafan memacu pengukuhan positif dan penting untuk memotivasikan bakat terbaik serta membina pasukan berprestasi tinggi",
        past_thirty_day_participation: "Penyertaan 30 hari lepas",
        required: "Diperlukan",
        or_higher: "atau lebih tinggi",
        open_feedback: "Maklum Balas Terbuka",
        continuous_feedback_drives: "Maklum balas berterusan memacu penambahbaikan berterusan dan menandakan persekitaran kerja dengan keselamatan psikologi yang tinggi",
        past_thirty_day_open: "Kadar maklum balas terbuka 30 hari lepas",
        active_managers: "Pengurus Aktif",
        people_managers_are: "Pengurus pekerja berada dalam kedudukan terbaik untuk secara proaktif membantu, melibatkan, dan mengekalkan bakat dalam pasukan mereka",
        past_thirty_day_activity: "Aktiviti 30 hari lepas",
        strong_company_culture: "Budaya Syarikat yang Kukuh",
        culture_is_a_byproduct: "Budaya adalah hasil sampingan daripada nilai teras dan tingkah laku. Budaya yang kukuh membolehkan anda melaksanakan strategi dengan berkesan dan berinovasi",
        most_recent_culture: "Skor Culture Index terkini",
        high_well_being: "Kesejahteraan Tinggi",
        employee_wellness_and: "Kesihatan dan kesejahteraan pekerja wajar diberi perhatian dan penjagaan, serta menyumbang secara langsung kepada daya tahan organisasi",
        most_recent_WHO_5: "Skor WHO-5 Index terkini",
        happiest_workplace: "Tempat Kerja Paling Gembira",
        a_happy_workplace: "Tempat kerja yang gembira dipacu oleh tabiat positif — pengiktirafan, maklum balas terbuka, pengurus aktif, budaya yang kukuh, dan kesejahteraan yang tinggi",
        awards_collected: "Anugerah dikumpul",
        collect_all_other: "Kumpulkan semua anugerah lain",
        share_your_award: "Kongsi anugerah anda",
        share_your_award_with: "Kongsi anugerah anda dengan orang lain. Anugerah anda telah diterbitkan dan sedia untuk dilihat di alamat web di bawah.",
        coppy: "Salin",
        embed_code: "Kod sematan",
        preview_link_in: "Pratonton pautan dalam tab baharu",
        to_embed_this: "Untuk menyematkan anugerah ini pada laman web anda, cuma salin dan tampal kod di bawah ke dalam kod HTML laman web anda.",
        all_time: "Sepanjang Masa",
        consistency: "Konsistensi",
        current_streak: "Streak Semasa",
        start_date: "Tarikh Mula",
        january_one: "1 Januari",
        today: "Hari Ini",
        highlighted_are_periods: "Yang diserlahkan ialah tempoh apabila penyertaan pengiktirafan berada pada",
        days: "hari",
        required_collect_all: "Diperlukan: Kumpulkan semua anugerah lain",
    },
    billing: {
        BILLING_SUMMARY: "RINGKASAN PENGEBILAN",
        SUBSCRIPTION: "LANGGANAN",
        REWARDS_CHARGES: "CAJ GANJARAN",
        REWARD_CREDIT_BALANCE: "BAKI KREDIT GANJARAN",
        REWARDS_PENDING: "GANJARAN MENUNGGU",
        active_members: "Ahli Aktif",
        credit_balance: "Baki Kredit",
        credit_remaining: "Kredit Berbaki",
        Date: "Tarikh",
        Category: "Kategori",
        Description: "Penerangan",
        Amount: "Jumlah",
        Status: "Status",
        seats_charged: "tempat dicaj",
        export: "Eksport",
        top_up_credits: "TAMBAH KREDIT",
        bill_sent: "Bil Dihantar",
        all: "Semua",
        copy: "Salin",
        copied_to_clipboard: "Disalin ke papan keratan!",
        no_data_to_copy: "Tiada data untuk disalin",
        failed_to_copy: "Gagal menyalin ke papan keratan",
        unable_to_load: "Data pengebilan tidak dapat dimuatkan",
        try_again: "Cuba lagi",
        account_billing: "Pengebilan akaun",
        billing_period: "Tempoh pengebilan",
        export_summary: "Eksport ringkasan",
        live_calculation_note: "Halaman ini ialah pengiraan langsung berdasarkan aktiviti yang direkodkan dan peraturan pengebilan semasa. Invois akhir anda disediakan oleh pasukan pengebilan Happily.",
        period_overview: "Gambaran keseluruhan tempoh",
        how_charges_add_up: "Cara caj anda dikira",
        pending_separate: "Komitmen ganjaran tertunda ditunjukkan secara berasingan dan tidak termasuk dalam caj dikira.",
        recorded_charges: "Caj dikira",
        charge_calculation: "Langganan ditambah ganjaran dicaj ditambah tambah nilai kredit bersamaan jumlah dikira",
        subscription_label: "Langganan",
        rewards_charged: "Ganjaran dicaj",
        credit_top_ups: "Tambah nilai kredit",
        recorded_total: "Jumlah dikira",
        available_reward_credit: "Kredit ganjaran tersedia",
        available_reward_credit_help: "Kredit yang tersedia untuk penebusan ganjaran.",
        pending_reward_commitments: "Komitmen ganjaran tertunda",
        pending_reward_commitments_help: "Nilai ganjaran yang diminta tetapi belum selesai atau dicaj.",
        no_charges: "Tiada caj dikira",
        no_charges_help: "Tiada caj langganan, ganjaran atau tambah nilai untuk tempoh ini.",
        seat_evidence: "Penggunaan ahli",
        Country: "Negara",
        member_usage_country: "Ahli aktif mengikut negara",
        country_usage_help: "Lihat taburan ahli aktif mengikut negara dalam tempoh bil ini. Caj di atas dikumpulkan mengikut mata wang pengebilan.",
        share_of_usage: "Bahagian ahli aktif",
        last_activity: "Aktiviti terakhir",
        view_members: "Lihat ahli",
        no_member_activity: "Tiada aktiviti ahli",
        no_member_activity_help: "Tiada ahli aktif direkodkan dalam tempoh pengebilan ini.",
        charge_details: "Butiran caj",
        billing_activity: "Aktiviti pengebilan",
        billing_activity_help: "Lihat entri di sebalik pengiraan tempoh ini, dikumpulkan mengikut jenis caj.",
        subscription_charges: "Caj langganan",
        subscription_charges_help: "Caj keahlian berdasarkan ahli aktif dan sebarang komitmen tempat minimum.",
        reward_credit_topups: "Tambah nilai kredit ganjaran",
        reward_credit_topups_help: "Kredit yang ditambahkan ke dompet ganjaran anda dalam tempoh bil ini.",
        reward_redemptions: "Penebusan ganjaran",
        reward_redemptions_help: "Permintaan ganjaran ahli, termasuk entri dicaj, belum selesai dan dibatalkan. Hanya entri yang dicaj termasuk dalam jumlah dikira di atas.",
        member_subscription: "Langganan ahli",
        reward_credit_topup: "Tambah nilai kredit ganjaran",
        reward_redemption: "Penebusan ganjaran",
        other_billing_activity: "Aktiviti pengebilan lain",
        other_billing_activity_help: "Entri pengebilan tambahan yang tidak sepadan dengan kategori langganan, tambah nilai atau penebusan standard.",
        less_than_one_percent: "<1%",
        entry: "entri",
        entries: "entri",
        no_activity: "Tiada aktiviti pengebilan",
        no_activity_help: "Tiada entri pengebilan untuk tempoh ini.",
        copy_list: "Salin senarai",
        download_csv: "Muat turun CSV",
        current_period: "Tempoh semasa",
        period_range_pending: "Julat pengebilan akan dipaparkan selepas aktiviti dimuatkan.",
        calculating: "Mengira",
        finalised: "Dimuktamadkan",
        in_progress: "Sedang berjalan",
        waiting_for_activity: "Menunggu aktiviti pengebilan",
        updated_at: "Dikemas kini",
        all_countries: "Semua negara",
        billable_member_activity: "Aktiviti ahli",
        not_available: "Tidak tersedia",
        pending: "Tertunda",
        charged: "Dicaj",
        paid: "Dibayar",
        canceled: "Dibatalkan",
        allow_popups: "Benarkan pop timbul untuk membuka eksport pengebilan.",
        load_error_help: "Muat semula data atau cuba lagi sebentar lagi.",
    },
    happilyVillage: {
        reels: {
            reel: "Reel", reels: "Reel", posts: "Siaran", townhall_content: "Kandungan Town Hall",
            new_reel: "Reel baharu", close: "Tutup editor", back_to_reels: "Kembali ke reel", starter: "Templat HR", upload_video: "Muat naik video", build_reel: "Bina reel",
            templates: { company_update: "Kemas kini syarikat", welcome_team: "Sambut ahli pasukan baharu", recognition: "Penghargaan atau pencapaian", leadership_message: "Mesej kepimpinan", event: "Peringatan atau sorotan acara", policy: "Polisi atau tarikh akhir", blank: "Reel kosong" },
            storyboard: "Papan cerita", scenes: "Babak", preview: "Pratonton", edit: "Sunting", editor_sections: "Bahagian editor reel",
            drag_scene: "Seret babak {n}", move_up: "Alih ke atas", move_down: "Alih ke bawah", duplicate_scene: "Duplikasi babak", delete_scene: "Padam babak", add_scene: "Tambah babak", untitled_scene: "Babak tanpa tajuk", one_scene_required: "Reel memerlukan sekurang-kurangnya satu babak.", scene_moved: "{title} dialih ke kedudukan {n} daripada {total}.", editing_scene: "Menyunting babak {n}, {title}.", scene_of: "Babak {current} daripada {total}", scene_type: "Jenis babak",
            total_duration: "Jumlah tempoh", recommended_duration: "Disyorkan 30–60 saat", preview_reel: "Pratonton · Reel", preview_hint: "Beginilah rupanya dalam aplikasi mudah alih.", preview_title_fallback: "Kongsi sesuatu yang penting dengan pasukan", top_safe_zone: "Zon selamat atas", bottom_safe_zone: "Zon selamat bawah", play: "Main", pause: "Jeda", mute: "Senyap", live_preview: "Pratonton langsung", scene_label: "Babak", preview_scenes: "Babak pratonton", unmute: "Hidupkan bunyi", scene_content: "Mesej", look_and_timing: "Gaya & masa",
            text: "Teks", photo: "Foto", video: "Video", media: "Media", no_media: "Tiada media dipilih", choose: "Pilih", replace: "Ganti", headline: "Tajuk utama", supporting_text: "Teks sokongan", visual_style: "Gaya visual", layout: "Susun atur", styles: { brand: "Jenama", midnight: "Tengah malam", spotlight: "Sorotan", fresh: "Segar", paper: "Kertas" }, layouts: { statement: "Pernyataan", center: "Tengah", lower_third: "Bahagian bawah", editorial: "Editorial" }, text_effect: "Kesan teks", text_effects: { none: "Statik", "soft-rise": "Naik lembut", "side-reveal": "Dedah sisi", focus: "Fokus", stagger: "Berturutan", highlight: "Sorotan" }, text_effect_descriptions: { none: "Sentiasa kelihatan tanpa gerakan.", "soft-rise": "Menaikkan mesej dengan lembut.", "side-reveal": "Meluncur masuk dengan permulaan yakin.", focus: "Membesar perlahan untuk penekanan.", stagger: "Memaparkan tajuk, kemudian butiran.", highlight: "Melukis garis aksen sebelum mesej." }, effect: "Kesan media", effects: { natural: "Semula jadi", studio: "Studio", cinematic: "Sinematik", sunlit: "Cahaya hangat", vibrant: "Bertenaga", mono: "Monokrom" }, effect_descriptions: { natural: "Tanpa rawatan tambahan", studio: "Bersih dan digilap lembut", cinematic: "Kontras dalam, zum perlahan", sunlit: "Cahaya hangat, gerak lembut", vibrant: "Warna kaya, naik perlahan", mono: "Hitam putih yang abadi" }, effect_hint: "Setiap pratetap menggabungkan tona dan gerakan. Tekan main untuk pratonton.", duration: "Tempoh", fit: "Paparan", contain: "Paparkan penuh", cover: "Penuhi bingkai", focal_point: "Titik fokus", horizontal: "Mendatar", vertical: "Menegak", focal_point_help: "Pilih bahagian yang mesti kekal kelihatan apabila media memenuhi bingkai.", poster_frame: "Bingkai poster", poster_auto: "Automatik", poster_choose_frame: "Pilih bingkai", poster_at: "Bingkai pada", transition: "Peralihan", crossfade: "Silang pudar", none: "Tiada",
            finished_video: "Video siap", upload_finished_video: "Muat naik reel yang telah siap", upload_limits: "MP4 atau MOV · sehingga 500 MB dan 3 minit", choose_video: "Pilih video", video_too_large: "Pilih video yang lebih kecil daripada 500 MB.", video_too_long: "Pilih video sepanjang 3 minit atau kurang.",
            global_audio: "Audio keseluruhan", clip_audio: "Audio klip", optional_track: "Muzik atau narasi pilihan", choose_audio: "Pilih audio", reel_details: "Butiran reel", title: "Tajuk", caption: "Kapsyen", tags: "Tag", add_tag: "Tambah tag", subtitles_accessibility: "Sari kata & kebolehcapaian", subtitle_help: "Jika reel mengandungi pertuturan, tambah fail SRT atau VTT. Sari kata diletakkan di atas zon selamat mudah alih.", choose_subtitles: "Pilih fail sari kata",
            audience: "Khalayak", all_employees: "Semua pekerja", selected_groups: "Kumpulan terpilih", notification: "Pemberitahuan", push: "Pemberitahuan tolak", push_notice: "Ini akan menghantar pemberitahuan tolak", push_notice_help: "Orang akan dimaklumkan apabila reel disiarkan.", publish_when: "Masa terbit", now: "Sekarang", schedule: "Jadualkan", pick_date: "Pilih tarikh dan masa", save_close: "Simpan & tutup", publish_reel: "Terbitkan reel", schedule_reel: "Jadualkan reel",
            draft: "Draf", saving: "Menyimpan…", draft_saved: "Draf disimpan", save_failed: "Tidak dapat disimpan", retry: "Cuba lagi", save_changes: "Simpan perubahan?", close_prompt: "Simpan reel ini sebagai draf atau buang suntingan?", discard: "Buang", fix_before_publish: "Baiki perkara ini sebelum menerbitkan:", template_applied: "Templat digunakan. Semuanya boleh disunting.", published_success: "Reel anda telah disiarkan.", scheduled_success: "Reel anda telah dijadualkan.", publish_failed: "Reel tidak dapat diterbitkan. Sila cuba lagi.", unpublished: "Ditarik balik",
            filter_reels: "Tapis reel", filters: { all: "Semua", draft: "Draf", rendering: "Diproses", scheduled: "Dijadualkan", published: "Diterbitkan", failed: "Perlu perhatian", archived: "Diarkibkan" }, search_reels: "Cari reel atau #tag", no_reels: "Belum ada reel", no_reels_help: "Buat kemas kini syarikat, sambut ahli baharu atau muat naik video siap.", create_first: "Buat reel pertama", untitled_reel: "Reel tanpa tajuk", no_caption: "Belum ada kapsyen", reel_actions: "Tindakan reel", retry_render: "Proses semula", cancel_render: "Batalkan pemprosesan", cancel_render_prompt: "Hentikan penyediaan reel ini? Draf dan media yang dimuat naik akan disimpan.", cancel_schedule: "Batalkan jadual", unpublish: "Tarik balik", unpublish_reel: "Tarik balik reel", unpublish_prompt: "Alih keluar reel ini daripada Town Hall? Sejarah penglibatan akan disimpan dan anda boleh menyunting atau menerbitkannya semula.", archive: "Arkibkan", archive_reel: "Arkibkan reel", archive_prompt: "Alihkan reel ini ke Arkib? Jika sedang disiarkan, reel akan dialih keluar daripada Town Hall. Sejarah penglibatan akan disimpan.", archived_help: "Reel ini telah diarkibkan dan disembunyikan daripada senarai aktif. Sejarah penglibatan masih tersedia.", restore: "Pulihkan", view_engagement: "Lihat penglibatan", refresh_metrics: "Segar semula metrik", metrics_failed: "Metrik penglibatan tidak dapat disegar semula.", scheduled_for: "Dijadualkan untuk", render_failed_help: "Reel ini tidak dapat disediakan. Draf dan media anda selamat.", rendering_help: "Video mudah alih sedang disediakan. Anda boleh meninggalkan halaman ini.", select_reel: "Pilih reel", select_reel_help: "Pilih reel untuk pratonton dan urus penerbitan.", updated: "Dikemas kini", not_set: "Belum ditetapkan", performance: "Prestasi", engagement_summary: "Ringkasan penglibatan", mobile_activity: "Aktiviti mudah alih", views: "Tontonan", completions: "Selesai", reactions: "Reaksi", completion_rate: "Kadar selesai", finish_publish: "Semak & terbitkan", review_schedule: "Semak jadual", duplicate_reel: "Duplikasi reel",
            delete_reel: "Padam reel", delete_prompt: "Padam reel dan media draf ini? Tindakan ini tidak boleh dibuat asal.", deleted: "Reel dipadam.", load_failed: "Reel tidak dapat dimuatkan. Sila cuba lagi.", action_failed: "Reel tidak dapat dikemas kini. Sila cuba lagi.", actions: { duplicate: "Reel diduplikasi.", retry: "Pemprosesan dimulakan semula.", cancel_render: "Pemprosesan dibatalkan.", cancel_schedule: "Jadual dibatalkan.", unpublish: "Reel ditarik balik.", archive: "Reel diarkibkan.", restore: "Reel dipulihkan." },
            errors: { title_required: "Tambah tajuk reel.", caption_required: "Tambah kapsyen ringkas supaya kemas kini difahami tanpa bunyi.", title_too_long: "Pastikan tajuk 80 aksara atau kurang.", caption_too_long: "Pastikan kapsyen 280 aksara atau kurang.", upload_required: "Muat naik video yang telah siap.", scenes_required: "Tambah sekurang-kurangnya satu babak.", too_many_scenes: "Reel boleh mempunyai sehingga 10 babak.", too_long: "Reel binaan boleh mencapai 90 saat sahaja.", scene_media_required: "Tambah foto atau video yang hilang pada babak {scenes}, atau tukar kepada babak teks." },
            starter_prompt: "Menggunakan templat lain akan menggantikan babak semasa anda. Teruskan?", apply_starter: "Guna templat", video_unsupported: "Fail video ini tidak dapat dibaca. Pilih fail MP4 atau MOV.",
            motion_effects: "Gerakan & kesan", soundtrack: "Muzik latar", your_audio: "Audio anda", music_hint: "Muzik latar akan digabungkan semasa video mudah alih disediakan.",
            tracks: { none: "Tiada muzik", uplift: "Ceria", calm: "Tenang", energy: "Bertenaga", warm: "Mesra", focus: "Minimalis" },
            track_descriptions: { none: "Suara dan audio klip sahaja", uplift: "Ceria dan optimistik", calm: "Lembut dan stabil", energy: "Pantas dan berani", warm: "Mesra dan mudah didekati", focus: "Minimal dan moden" },
            show_branding: "Penjenamaan syarikat", show_branding_help: "Papar logo dan nama syarikat pada reel."
        },
        Session_Type: "Jenis",
        Live: "Langsung",
        Video: "Video",
        Mission_Entries: "Entri Misi",
        Mission: "Misi",
        add_mission: "tambah misi",
        Order: "Susunan",
        Mission_Name_and: "Nama & Penerangan Misi",
        Entries: "Entri",
        Winner: "Pemenang",
        Status: "Status",
        Week: "Minggu",
        entries: "entri",
        Live: "Langsung",
        Completed: "Selesai",
        Unskip_Mission: "Batal Langkau Misi",
        Skip_Mission: "Langkau Misi",
        Edit: "Edit",
        Delete: "Padam",
        Upcoming: "Akan Datang",
        View_Details: "Lihat Butiran",
        Preview_on_Mobile: "Pratonton pada Susun Atur Mudah Alih",
        New_Mission: "Misi Baru",
        Exntry_XP: "XP Entri",
        PLAY: "MAIN",
        VOTE: "UNDI",
        Name_of_Mission: "Nama Misi",
        Please_input_Name: "Sila masukkan Nama",
        Name_of_your_Mission: "Nama Misi anda (cth., Ambil swafoto kumpulan terbaik)",
        Name_of_your_Mission_th: "Nama Misi anda (Thai)",
        Description: "Penerangan",
        A_sentence_or_two: "Satu atau dua ayat mengenai topik ini",
        Please_input_Description: "Sila masukkan Penerangan",
        Please_input_Session_Minimum: "Sila masukkan Sesi Minimum",
        A_sentence_or_two_th: "Satu atau dua ayat menerangkan butiran misi (Thai)",
        Mission_Type: "Jenis Misi",
        Please_input_Mission_Type: "Sila masukkan Jenis Misi",
        Entry_Bonus_XP: "Bonus Entri (XP)",
        Please_input_Entry_Bonus: "Sila masukkan Bonus Entri",
        Please_input_Order: "Sila masukkan Susunan",
        Select: "Pilih",
        Please_input_Status: "Sila masukkan Status",
        CREATE_MISSION: "CIPTA MISI",
        SAVE_MISSION: "CIPTA MISI",
        HAPPILY_HOUSES: "HAPPILY HOUSES",
        THIS_WEEK: "MINGGU INI",
        This_Week: "Minggu Ini",
        This_Month: "Bulan Ini",
        Last_Week: "Minggu Lepas",
        Last_Month: "Bulan Lepas",
        All_time: "Sepanjang Masa",
        Level: "Tahap",
        total_members: "jumlah ahli",
        House_XP: "XP House",
        XP: "XP",
        person: "orang",
        Distance: "Jarak",
        km: "km",
        km_per_person: "km / orang",
        participation: "Penyertaan",
        university: "Happily University",
        A_count_of_how_many_learning: "Kiraan bilangan interaksi pembelajaran dan aktiviti yang dicipta daripada sesi Happily University",
        Learning_and_Activity: "Interaksi Pembelajaran & Aktiviti",
        See_more: "Lihat lagi",
        town_hall: "Town Hall",
        A_count_of_how_many_comments: "Kiraan bilangan komen dan balasan yang dimulakan melalui topik dan undian di Town Hall",
        Knowledge_Sharing_Interactions: "Interaksi Perkongsian Pengetahuan",
        running_track: "trek larian",
        A_count_of_distance_traveled: "Kiraan jarak yang dilalui melalui berjalan dan berlari di Running Track, termasuk kesan Boosters",
        km_Distance_Traveled: "km Jarak Dilalui",
        BATTLE_STADIUM: "BATTLE STADIUM",
        A_count_of_how_many_entries: "Kiraan bilangan entri yang dihantar untuk misi mingguan di Battle Stadium",
        House_of: "House of",
        members: "ahli",
        making_up: "merangkumi",
        of_Happily_Village: "daripada Happily Village",
        Distance_Traveled: "Jarak Dilalui",
        Running_Track_Leaderboard: "Leaderboard Running Track",
        Today: "Hari Ini",
        Rank: "Kedudukan",
        Name: "Nama",
        results_from: "hasil daripada",
        results: "hasil",
        This_week: "Minggu ini",
        No_Active_Boosters: "Tiada Boosters Aktif",
        This_month: "Bulan ini",
        Quick_ranges: "Quick ranges",
        Specific_month: "Specific month",
        Export_this_view: "Export this view",
        Export_complete: "Export complete.",
        months_short: {
          jan: "Jan", feb: "Feb", mar: "Mar", apr: "Apr",
          may: "May", jun: "Jun", jul: "Jul", aug: "Aug",
          sep: "Sep", oct: "Oct", nov: "Nov", dec: "Dec",
        },
        Town_Hall_Topics: "Topik Town Hall, Undian, & Senarai Semak Kumpulan",
        Create: "Cipta",
        New_Topic: "Topik Baru",
        New_Poll: "Undian Baru",
        New_Checklist: "Senarai Semak Baru",
        Creator: "Pencipta",
        Type: "Jenis",
        View: "Lihat",
        Views: "Tontonan",
        Engagement: "Penglibatan",
        Date_and_Time: "Tarikh & Masa",
        Duplicate: "Duplikasi",
        comment: "komen",
        comments: "komen",
        votes: "undian",
        By: "Oleh",
        Topic_Creator: "Pencipta Topik",
        Share_with: "Kongsi dengan",
        Huddle_selection_is: "Pemilihan Huddle kini hanya tersedia dalam aplikasi mudah alih.",
        Coming_soon_to: "Akan datang pada konsol My Happily.",
        Team_or_Name: "Pasukan atau Nama Penerima",
        Title_of_Topic: "Tajuk Topik",
        Title_of_Poll: "Tajuk Undian",
        Short_but_descriptive: "Pendek tetapi deskriptif",
        A_sentence_or_two_poll: "Satu atau dua ayat mengenai undian ini",
        Item_label: "Label item",
        Comments_enabled: "Komen didayakan",
        UPLOAD_MEDIA: "MUAT NAIK MEDIA",
        Save_Changes: "Simpan",
        CREATE_TOPIC: "CIPTA TOPIK",
        by: "oleh",
        Summary: "Ringkasan",
        items: "item",
        You_are_completed: "Anda telah selesai",
        Weekly_reminders_to: "Peringatan mingguan untuk mengemaskini kemajuan anda dihidupkan",
        Group_Checklist_Creator: "Pencipta Senarai Semak Kumpulan",
        Select_Creator: "Pilih Pencipta",
        Title_of_Checklist: "Tajuk Senarai Semak",
        Please_input_title: "Sila masukkan tajuk",
        Checklist_Item: "Item Senarai Semak",
        Description_of_Checklist: "Description",
        Checklist_item_type: "Item type",
        Item_type_simple: "Simple",
        Item_type_acknowledge: "Acknowledge",
        Item_type_link: "Link",
        Item_required: "Required",
        Acknowledge_what: "What should they acknowledge?",
        Link_placeholder: "https://...",
        Due_date: "Due date (optional)",
        Remind_7_days_before: "Remind 7 days before",
        Remind_1_day_before: "Remind 1 day before",
        Tags: "Tags",
        Add_tag: "Add a tag",
        ADD_OPTION: "TAMBAH PILIHAN",
        Show_respondents_in_results: "Tunjukkan responden dalam hasil",
        Weekly_Reminders_off: "Peringatan Mingguan dimatikan",
        Every_week_on: "Setiap minggu pada",
        at: "pada",
        if_checklist_is: "jika senarai semak belum selesai, hantar notifikasi peringatan",
        CREATE_CHECKLIST: "CIPTA SENARAI SEMAK",
        CREATE_POLL: "CIPTA UNDIAN",
        Poll_Creator: "Pencipta Undian",
        Poll_Title: "Tajuk Undian",
        Option: "Pilihan",
        Option_label: "Label pilihan",
        Search: "Cari",
        learning_and_activity_interactions: "interaksi pembelajaran & aktiviti",
        University_Sessions: "Sesi Happily University",
        add_session: "tambah sesi",
        campaigns: "Kempen",
        Create_Campaign: "Cipta Kempen",
        Campaign_Title: "Tajuk Kempen",
        Icon: "Ikon",
        Theme: "Tema",
        Input_Type: "Jenis Input",
        Timing: "Masa",
        Goal: "Matlamat",
        Reward: "Ganjaran",
        Entry_Cost: "Kos Penyertaan",
        Daily: "Harian",
        Weekly: "Mingguan",
        Instant_Coins: "Coins Segera",
        Charged_Coins_On_Completion: "Coins Dicaj Apabila Selesai",
        Prize_Pool_Split_At_End: "Kumpulan Hadiah (Dibahagi di Penghujung)",
        Individual_Goal: "Matlamat Individu",
        Group_Goal: "Matlamat Kumpulan",
        Start_Date: "Tarikh Mula",
        End_Date: "Tarikh Tamat",
        Participants: "Peserta",
        All: "Semua",
        Sign_ups: "Pendaftaran",
        name: "nama",
        Topic: "Topik",
        Price: "Harga",
        coins: "Coins",
        Free: "Percuma",
        Led_by: "Dipimpin oleh",
        SIGN_UPS: "PENDAFTARAN",
        spots_available: "tempat tersedia",
        PRICE: "HARGA",
        Coming_soon_to_the: "Akan datang pada konsol My Happily.",
        Name_of_Session: "Nama Sesi",
        Short_but_descriptive_eg: "Pendek tetapi deskriptif (cth. Excel Analysis 101)",
        A_sentence_or_two_about: "Satu atau dua ayat mengenai sesi ini",
        When: "Bila",
        Please_input_Date: "Sila masukkan Tarikh & Masa",
        Duration_minutes: "Tempoh (minit)",
        How_long: "Berapa lama?",
        Please_input_Duration: "Sila masukkan Tempoh",
        Location: "Lokasi",
        Please_input_Location: "Sila masukkan Lokasi",
        Session_Limit: "Had Sesi",
        Where: "Di mana",
        How_many: "Berapa banyak?",
        Please_input_Session_Limit: "Sila masukkan Had Sesi",
        Price_coins: "Harga (Coins)",
        Please_input_rice: "Sila masukkan Harga",
        How_much: "Berapa?",
        Add_to_Topic: "Tambah ke Topik",
        Comment_Permissions: "Kebenaran Komen",
        CREATE_SESSION: "CIPTA SESI",
        Created_by: "Dicipta oleh",
        sign_ups_of: "pendaftaran daripada",
        available_spots: "tempat tersedia",
        No_one_sign_up: "Tiada pendaftaran.",
        campaign_form: {
            preview_notice: "Ciri mungkin berubah sebelum pelancaran rasmi.",
            content_language: "Bahasa Kandungan",
            translation_mode_title: "Hanya medan yang boleh diterjemah ditunjukkan di bawah.",
            translation_mode_hint: "Tukar ke Bahasa Inggeris untuk edit semua tetapan kempen.",
            use_english_empty: "Guna Bahasa Inggeris untuk Medan Kosong",
            use_english: "Guna Bahasa Inggeris",
            live_lock_title: "Suntingan kempen langsung adalah terhad.",
            live_lock_body: "Anda masih boleh mengemaskini medan paparan seperti kategori, tajuk, penerangan, ikon, tema, dan kebenaran komen. Masa, matlamat, ganjaran, audien, tetapan penyertaan, dan kandungan aktiviti dikunci selepas kempen bermula.",
            translatable_content: "Kandungan Boleh Diterjemah",
            campaign_overview: "Gambaran Keseluruhan Kempen",
            category: "Kategori",
            category_placeholder: "cth., PENGETAHUAN PRODUK, KESEJAHTERAAN",
            activity_type: "Jenis Aktiviti",
            activity_type_placeholder: "Pilih jenis aktiviti",
            title: "Tajuk",
            title_placeholder: "Masukkan tajuk atau soalan kempen",
            description: "Penerangan",
            description_placeholder: "Terangkan apa kempen ini dan apa yang peserta akan lakukan...",
            description_hint: "Penerangan ini akan ditunjukkan kepada peserta apabila mereka menyertai kempen",
            translation_required: "Terjemahan diperlukan",
            validation_category: "Sila masukkan kategori kempen",
            validation_title: "Sila masukkan tajuk kempen",
            validation_icon: "Sila pilih ikon",
            color_theme: "Tema Warna",
            activity_settings: "Tetapan Aktiviti",
            locked_after_start: "Dikunci selepas kempen bermula.",
            success_answer: "Jawapan Berjaya",
            yes_is_correct: "Ya adalah jawapan yang betul",
            no_is_correct: "Tidak adalah jawapan yang betul",
            input_settings: "Tetapan Input",
            allow_decimals: "Benarkan nilai perpuluhan",
            allow_decimals_hint: "Dayakan untuk berat, jarak, atau metrik lain yang memerlukan ketepatan (cth., 1.5, 0.8)",
            tracking_mode: "Mod Penjejakan",
            incremental: "Tokokan",
            incremental_hint: "Setiap entri adalah bebas (cth., \"1.5 paun turun minggu ini\")",
            cumulative: "Kumulatif",
            cumulative_hint: "Setiap entri adalah jumlah dari mula kempen (cth., \"5 paun turun keseluruhan\")",
            campaign_duration: "Tempoh Kempen",
            duration_locked: "Masa mula dan tamat dikunci selepas kempen bermula.",
            select_frequency: "Pilih kekerapan",
            day_of_week: "Hari dalam Minggu",
            select_day: "Pilih hari",
            select_start_date: "Pilih tarikh mula",
            number_of_days: "Bilangan Hari",
            number_of_weeks: "Bilangan Minggu",
            ends: "Tamat",
            unit_translation: "Terjemahan Unit",
            unit_of_measurement: "Unit Pengukuran",
            unit_placeholder: "cth., item, langkah, minit",
            unit_hint: "Unit ini akan dipaparkan dengan semua matlamat (cth., \"10 item\", \"1000 langkah\")",
            goals: "Matlamat",
            goals_locked: "Tetapan matlamat dikunci selepas kempen bermula.",
            limit: "Had",
            required: "Wajib",
            optional: "Pilihan",
            target: "Sasaran",
            max_allowed: "Maksimum dibenarkan",
            max_total: "Jumlah maksimum",
            target_total: "Jumlah sasaran",
            max_combined: "Gabungan maksimum",
            target_combined: "Gabungan sasaran",
            individual_overall_goal: "Matlamat Keseluruhan Individu",
            individual_overall_limit: "Had Keseluruhan Individu",
            group_overall_goal: "Matlamat Keseluruhan Kumpulan",
            group_overall_limit: "Had Keseluruhan Kumpulan",
            recommended: "Disyorkan",
            weeks: "Minggu",
            days: "Hari",
            yesno_desc_daily: "Peserta berjaya dengan menjawab dengan betul setiap hari",
            yesno_desc_weekly: "Peserta berjaya dengan menjawab dengan betul setiap minggu",
            reward_locked: "Mekanik ganjaran dikunci selepas kempen bermula untuk melindungi logik bayaran.",
            earn_per_item: "Dapat per item selesai apabila matlamat harian dicapai",
            earn_on_daily_goal: "Dapat hanya apabila matlamat harian dicapai",
            charged_coins: "Coins Dicaj",
            prize_pool: "Kumpulan Hadiah",
            prize_pool_description: "Kos penyertaan + coins dicaj membentuk kumpulan, dibahagi sama rata antara pemenang",
            access_participation: "Akses & Penyertaan",
            access_locked: "Tetapan audien dan penyertaan dikunci selepas kempen bermula.",
            audience: "Audien",
            select_commenter: "Pilih siapa boleh komen",
            who_can_comment: "Siapa boleh tinggalkan komen",
            coins_to_join: "Coins untuk sertai",
            entry_limit: "Had Penyertaan",
            no_limit: "Tiada had",
            set_participant_limit: "Tetapkan had peserta",
            checklist_items: "Item Senarai Semak",
            add_checklist_hint: "Tambah item yang boleh ditandakan oleh peserta",
            translate_checklist_hint: "Terjemah setiap item senarai semak",
            enter_checklist_item: "Masukkan item senarai semak",
            add_first_item: "Tambah Item Pertama",
            add_another_item: "Tambah Item Lain",
            no_checklist_to_translate: "Tiada item senarai semak untuk diterjemah. Tambah item dalam Bahasa Inggeris dahulu.",
            quiz_questions: "Soalan Kuiz",
            translate_quiz_hint: "Terjemah setiap soalan dan pilihan jawapannya",
            question: "Soalan",
            remove: "Buang",
            enter_question: "Masukkan soalan anda",
            no_quiz_to_translate: "Tiada soalan kuiz untuk diterjemah. Tambah soalan dalam Bahasa Inggeris dahulu.",
            add_question: "Tambah Soalan",
            add_first_question: "Tambah Soalan Pertama Anda",
            update_campaign: "Simpan Perubahan",
            create_campaign: "Cipta Kempen",
            launch: "Lancar",
            launch_now: "Lancar sekarang",
            launch_now_sub: "Aktif sebaik sahaja disimpan",
            schedule_later: "Jadualkan kemudian",
            schedule_later_sub: "Pilih tarikh dan masa",
            launch_datetime: "Tarikh & masa pelancaran",
            pick_datetime: "Pilih tarikh dan masa",
            scheduled_must_be_future: "Masa yang dijadualkan mesti pada masa hadapan",
            launch_locked: "Masa pelancaran tidak boleh diubah setelah kempen bermula",
            launch_campaign: "Lancarkan Kempen",
            schedule_campaign: "Jadualkan Kempen",
        },
        Actions: "Tindakan",
        Topic_actions: "Tindakan topik",
        Session_actions: "Tindakan sesi",
        No_topics_or_polls: "Tiada topik atau undian",
        No_results_found: "Tiada hasil dijumpai...",
        No_sessions: "Tiada sesi",
        No_session_found: "Tiada sesi dijumpai...",
        Caption: "Kapsyen",
        Download_Results: "Muat Turun Hasil",
        Be_the_first_to_comment: "Jadi yang pertama mengomen dalam utas ini",
        Reply: "Balas",
        Likes: "Suka",
        Reply_here: "Balas di sini...",
        Comment_here: "Komen di sini...",
        Sessions_tab: "Sesi",
        Campaigns_tab: "Kempen",
        Session_Minimum: "Sesi Minimum",
        Session_Maximum: "Sesi Maksimum",
        one_coin: "1 coin",
        no_signups_yet: "Belum ada pendaftaran",
        signups_empty_hint: "Pengguna akan muncul di sini setelah mendaftar untuk kempen ini",
        signed_up_count: "mendaftar",
        signed_up_badge: "Mendaftar",
        signed_up_label: "Telah Mendaftar",
        no_participants_yet: "Belum ada peserta",
        participants_empty_hint: "Peserta akan muncul di sini setelah menyertai kempen",
        achieved_goal: "mencapai matlamat",
        Achieved_Goal: "Mencapai Matlamat",
        coins_awarded: "coins dianugerahkan",
        starts_tomorrow: "Mula esok",
        starts_in: "Mula dalam",
        days: "hari",
        days_left: "hari berbaki",
        last_day: "Hari terakhir",
        no_data_yet: "Belum ada data",
        summary_empty_hint: "Ringkasan akan muncul setelah peserta menyertai kempen",
        investment_and_impact: "Pelaburan & Impak",
        per_active_participant: "per peserta aktif",
        via: "melalui",
        daily_goals_lower: "matlamat harian",
        entry_fees_collected: "Yuran penyertaan dikutip",
        free_entry: "Penyertaan percuma",
        coins_distributed: "Coins diedarkan",
        coins_committed: "Coins dikomitkan",
        in_escrow: "dalam escrow",
        returned_to_system: "Dikembalikan ke sistem",
        didnt_meet_goal: "tidak mencapai matlamat",
        daily_goals_hit: "Matlamat Harian Dicapai",
        total_actions: "Jumlah Tindakan",
        limited_data_notice: "Data terhad — unjuran akan bertambah baik apabila kempen berjalan",
        projected_total_investment: "Jumlah pelaburan diunjurkan:",
        Active: "Aktif",
        achievement_rate_lower: "kadar pencapaian",
        reward_breakdown: "Pecahan Ganjaran",
        coins_per_daily_goal: "Coins per matlamat harian",
        daily_target: "Sasaran harian",
        daily_goals_achieved: "Matlamat harian dicapai",
        total_actions_recorded: "Jumlah tindakan direkod",
        total_coins_invested: "Jumlah coins dilabur",
        total_coins_committed: "Jumlah coins dikomitkan",
        earned_by: "Diperoleh oleh",
        who_met_goal: "yang mencapai matlamat",
        returned_from: "Dikembalikan dari",
        who_didnt: "yang tidak mencapai",
        in_escrow_until_end: "Dalam escrow sehingga kempen tamat",
        total_pool_size: "Saiz kumpulan keseluruhan",
        current_winners: "Pemenang semasa",
        prize_per_winner: "Hadiah per pemenang",
        no_winners_yet: "Belum ada pemenang",
        campaign_results: "Keputusan Kempen",
        progress: "Kemajuan",
        achievement_rate: "Kadar Pencapaian",
        avg_score: "Skor Purata",
        participation_rate: "Kadar Penyertaan",
        drop_off: "Cicir",
        view_leaderboard: "Lihat Leaderboard",
        Close: "Tutup",
        coins_committed_to_behavior: "coins dikomitkan untuk perubahan tingkah laku",
        coins_earned_through_behavior: "coins diperoleh melalui perubahan tingkah laku",
        type_quiz: "Kuiz",
        type_count: "Kiraan",
        type_auto_sync: "Auto Sync",
        type_steps: "Langkah",
        type_sleep: "Tidur",
        type_screen_time: "Masa Skrin",
        type_exercise: "Senaman",
        type_distance: "Jarak",
        type_multiple_selection: "Pemilihan Berbilang",
        type_yes_no: "Ya/Tidak",
        status_active: "Aktif",
        status_upcoming: "Akan Datang",
        status_scheduled: "Dijadualkan",
        status_ended: "Tamat",
        status_archived: "Diarkib",
        challenge_default: "CABARAN",
        preview_day: "Hari",
        preview_streak: "Streak",
        preview_select_answer: "Pilih jawapan yang betul",
        preview_todays_activity: "Kiraan aktiviti hari ini",
        preview_daily_goal: "Matlamat Harian",
        preview_keep_going: "Teruskan! Anda melakukannya dengan hebat!",
        preview_submit_count: "Hantar Kiraan",
        preview_goal_label: "Matlamat",
        preview_last_sync: "Sync terakhir: 2m lepas",
        preview_manually_edit: "Edit Manual",
        preview_continue: "Teruskan",
        preview_morning_routine: "Selesaikan rutin pagi anda",
        preview_done_for_now: "Saya sudah selesai buat masa ini",
        preview_yesno_question: "Adakah anda mencapai matlamat hari ini?",
        preview_charging: "Mengecas",
        early_preview: "Pratonton Awal",
        early_preview_hint: "Anda mempunyai akses awal! Ciri ini akan datang kepada semua orang tidak lama lagi.",
        no_campaigns: "Tiada kempen",
        period: "Tempoh",
        campaign_actions: "Tindakan kempen",
        archive: "Arkib",
        delete_disabled_hint: "Padam (Hanya tiada peserta)",
    },
    insights: {
        HAPPINESS_VS_RISK_RATE: "Kegembiraan lwn. Risiko & Aktiviti",
        Duration: "Tempoh",
        Last_30_days: "30 Hari Lepas",
        Last_60_days: "60 Hari Lepas",
        Last_13_weeks: "13 Minggu Lepas",
        Last_26_weeks: "26 Minggu Lepas",
        Last_52_weeks: "52 Minggu Lepas",
        Last_24_months: "24 Bulan Lepas",
        HAPPINESS: "KEGEMBIRAAN",
        RISK: "RISIKO",
        ACTIVE_USERS: "PENGGUNA AKTIF",
        COHORT_STATUS: "Status Kohort",
        Sort_by: "Susun mengikut",
        Cohorts: "Kohort",
        Satisfaction: "Kepuasan",
        Co_Alignment: "Co. Alignment",
        Score_Distribution: "Taburan Skor",
        Engagement_and_Impact: "Penglibatan & Impak",
        Highlighting_key_engagement_metrics: "Memaparkan metrik penglibatan utama seperti skor eNPS, NPS, Wellness, Culture, dan Employee Resilience Index serta gambaran keseluruhan impak individu dan aktiviti pengurus.",
        high_impact: "impak tinggi",
        contributors: "penyumbang",
        People: "Pekerja",
        managers: "pengurus",
        non_active: "tidak aktif",
        active: "aktif",
        Managers: "Pengurus",
        eNPS: "eNPS",
        Report_Card: "Kad Laporan",
        Promoters: "Promoters",
        Passives: "Passives",
        Detractors: "Detractors",
        Excellent: "Cemerlang",
        Fair: "Sederhana",
        Critical: "Kritikal",
        Poor: "Lemah",
        point_same_benchmark: "mata sama dengan penanda aras",
        points: "mata",
        above_benchmark: "atas penanda aras",
        below_benchmark: "bawah penanda aras",
        Happiness_Rate: "Kadar Kegembiraan",
        Risk_Rate: "Kadar Risiko",
        View_by_team: "Lihat ikut pasukan",
        Open_ended_Feedback: "Maklum Balas Terbuka",
        How_would_you_like: "Bagaimana anda mahu",
        manager_to_be_more: "pengurus anda lebih terlibat?",
        Activity: "Aktiviti",
        Adoption: "Penggunaan",
        Members: "Ahli",
        Monthly_Active_Users: "Pengguna Aktif Bulanan",
        Weekly_Active_Users: "Pengguna Aktif Mingguan",
        ACTIVITY_THIS_WEEK: "AKTIVITI MINGGU INI",
        WEEKLY_ACTIVE_USERS: "PENGGUNA AKTIF MINGGUAN",
        HAPPINESS_RATE: "KADAR KEGEMBIRAAN",
        RISK_RATE: "KADAR RISIKO",
        FEEDBACK_RESPONSE_RATE: "KADAR RESPONS MAKLUM BALAS",
        By_Job_Tenure: "Ikut Tempoh Kerja",
        Engagement_Trend: "Trend Penglibatan",
        Engagement_Trend_Desc: "Perubahan penglibatan sepanjang tempoh 3 bulan diukur oleh Dynamic Engagement Behavioral Index (DEBI) untuk keseluruhan syarikat, pengurus, dan pemimpin anda.",
        A_breakdown_of_your: "Pecahan aktiviti dan kadar anda mengikut tempoh kerja, iaitu jangka masa seseorang pekerja telah bekerja di syarikat anda",
        Real_time_Activity: "Aktiviti Masa Nyata",
        PAST_12_HOURS: "12 JAM LEPAS",
        BY_HOUR: "MENGIKUT JAM",
        TOP_ACTIVITIES: "AKTIVITI TERATAS",
        TIMES: "KALI",
        Interactions_caption: "interaksi",
        No_activity_yet: "Tiada aktiviti dalam 12 jam lepas",
        Key_Teams_and_Cohorts: "Pasukan & Kohort Utama",
        Highlighting_key_groups: "Memaparkan kumpulan utama yang menunjukkan skor tinggi atau rendah dalam kegembiraan, risiko, kadar maklum balas, atau aktiviti",
        TONE_ANALYZER: "Tone Analyzer",
        BETA: "BETA",
        TALKING_POINTS: "Topik Perbincangan",
        show_timeline: "papar garis masa",
        Success_Score: "Skor Kejayaan",
        Dimension: "Dimensi",
        Status_no_teams: "Kesihatan pasukan",
        teams_below_healthy: "pasukan di bawah tahap sihat",
        no_team_data: "Tiada data pasukan lagi",
        Critical_teams: "Pasukan kritikal",
        No_critical_teams: "Tiada pasukan kritikal dalam dimensi ini",
        Loading_teams: "Memuatkan pasukan…",
        responses: "maklum balas",
        Positive: "Positif",
        Neutral: "Neutral",
        Close: "Tutup",
        ENGAGEMENT_BREAKDOWN_BY_TEAM: "Penglibatan mengikut dimensi",
        Most_teams_red: "Paling banyak pasukan kritikal",
        Biggest_drop: "Penurunan terbesar",
        Lowest_Success_Score: "Skor Kejayaan Terendah",
        Highest_Success_Score: "Skor Kejayaan Tertinggi",
        DIMENSION_DETAILS: "Butiran Dimensi",
        Lowest_Happiness: "Kegembiraan Terendah",
        Highest_Happiness: "Kegembiraan Tertinggi",
        Lowest_Risk: "Risiko Terendah",
        Highest_Risk: "Risiko Tertinggi",
        ACTIVITY_OVERVIEW: "Gambaran Aktiviti",
        ACTIVE: "Responsif",
        PASSIVE: "Sederhana",
        INACTIVE: "Minimum",
        DAILY_INSIGHTS_OPENED: "INSIGHTS HARIAN DIBUKA",
        WEEKLY_INSIGHTS_OPENED: "INSIGHTS MINGGUAN DIBUKA",
        FEEDBACK_REPLY_RATE: "KADAR BALASAN MAKLUM BALAS",
        BY_MANAGER: "Interaksi Pengurus",
        Managers_activity_in: "Aktiviti pengurus dalam membuka insights dan membalas maklum balas pasukan dalam tempoh 30 hari lepas",
        Insights_Open_Rate: "Kadar Buka Insights",
        Team_Size: "Saiz Pasukan",
        Feedback_Reply_Rate: "Kadar Balasan Maklum Balas",
        All_Activity_Types: "Semua Jenis Aktiviti",
        Active: "Responsif",
        Passive: "Sederhana",
        Inactive: "Minimum",
        Insights_Opened: "Insights Dibuka",
        Feedback: "Maklum Balas",
        Relational: "Hubungan",
        Team_Challenges: "Cabaran Pasukan",
        Date: "Tarikh",
        Score: "Skor",
        Challenge: "Cabaran",
        Status: "Status",
        Profile: "Profil",
        Daily: "Harian",
        Weekly: "Mingguan",
        Reply: "Balas",
        Super: "Super",
        Talent_Type: "Jenis Bakat",
        Excels_At: "Cemerlang Dalam",
        Network_Type: "Jenis Rangkaian",
        Critical_Areas: "Bidang Kritikal",
        critical_area: "bidang kritikal",
        results_from: "hasil daripada",
        results: "hasil",
        Lower: "Bawah",
        Upper: "Atas",
        SAVE: "SIMPAN",
        CANCEL: "BATAL",
        Select_all: "Pilih semua",
        Clear: "Kosongkan",
        Talent_Types_are_tagged: "Jenis Bakat ditanda mengikut penarafan low, rising, high, atau super bagi keberkesanan rangkaian (sumbangan kolaboratif individu kepada organisasi) dan penarafan individu (penilaian prestasi daripada pengurus)",
        Cancel: "Batal",
        Okay: "OK",
        Power_Skills: "Power Skills",
        OUTER_NETWORK: "RANGKAIAN LUAR",
        NETWORK_EFFECTIVENESS: "Keberkesanan Rangkaian",
        PEOPLE_INTELLIGENCE: "People Intelligence",
        INDIVIDUAL_PERFORMANCE: "Prestasi Individu",
        INNER_NETWORK: "RANGKAIAN DALAM",
        Sort_By: "Susun Ikut",
        Highest_Risk_Level: "Tahap Risiko Tertinggi",
        Lowest_Risk_Level: "Tahap Risiko Terendah",
        Highest_Star_Count: "Bilangan Bintang Tertinggi",
        Lowest_Star_Count: "Bilangan Bintang Terendah",
        Highest_Impact_Rating: "Penarafan Impak Tertinggi",
        Lowest_Impact_Rating: "Penarafan Impak Terendah",
        Super_Network_Effectiveness: "⬆️ Super Network Effectiveness ",
        Rising_Network_Effectiveness: "⏫ Rising Network Effectiveness",
        High_Network_Effectiveness: "🔼 High Network Effectiveness",
        Low_Network_Effectiveness: "🔽 Low Network Effectiveness",
        Super_Individual_Rating: "⬆️ Super Individual Rating",
        Rising_Individual_Rating: "⏫ Rising Individual Rating",
        High_Individual_Rating: "🔼 High Individual Rating",
        Low_Individual_Rating: "🔽 Low Individual Rating",
        No_Description: "Tiada Penerangan",
        Problem_Areas: "Bidang Bermasalah",
        People_Impact_and: "Impak Pekerja & Trend Risiko",
        RISK_LEVELS: "Tahap Risiko",
        AVG_IMPACT_RATING: "Purata Penarafan Impak",
        view_list: "lihat senarai",
        Excels_at: "Cemerlang dalam",
        profiles: "profil",
        were_tagged_by: "telah ditanda oleh rakan sekerja untuk sifat ini",
        Name_Team_and: "Nama, Pasukan, dan Kegembiraan",
        Talent_is_classified: "Bakat diklasifikasikan mengikut kekerapan dan kualiti pengiktirafan",
        coins_and_gems: "(coins dan gems) diterima. Coins adalah ukuran bagi",
        Network: "Rangkaian",
        Effectiveness: "Keberkesanan",
        Gems_are_a_measure: "Gems adalah ukuran bagi",
        Individual_Performance: "Prestasi Individu",
        Low: "Rendah",
        Low_frequency: "Kekerapan rendah",
        Uptake: "Peningkatan",
        A_recent_increase_in: "Peningkatan kekerapan baru-baru ini",
        High: "Tinggi",
        High_frequency: "Kekerapan tinggi",
        High_frequency_and_high: "Kekerapan tinggi dan kualiti tinggi",
        Read_more_here: "Baca lebih lanjut di sini",
        Impact_Rating: "Penarafan Impak",
        Based_on_manager_and: "Berdasarkan pengiktirafan daripada pengurus dan rakan sekerja dalam tempoh 6 bulan lepas.",
        Based_on_connections_created: "Berdasarkan hubungan yang dibentuk melalui peer feedback, pengiktirafan, dan interaksi pemberian hadiah dalam tempoh 6 bulan lepas.",
        Engagement_Group: "Kumpulan Penglibatan",
        Based_on_the_quality_and: "Berdasarkan kualiti dan usaha tingkah laku penglibatan utama pada bulan lepas.",
        Truly_Outstanding: "Truly Outstanding",
        Truly_Outstanding_ratings: "Penarafan Truly Outstanding daripada Peer Feedback yang diterima dalam tempoh 6 bulan lepas.",
        Medals: "Pingat",
        Medals_received_in_the: "Pingat yang diterima dalam tempoh 6 bulan lepas.",
        Star_Performer: "Star Performer",
        Number_of_weeks_qualified: "Jumlah minggu layak sebagai Star Performer dalam tempoh 6 bulan lepas.",
        Talent_is_classified_by: "Bakat diklasifikasikan mengikut bilangan hubungan dalaman dan luaran",
        connections_as_determined: "hubungan (seperti yang ditentukan oleh struktur organisasi) daripada",
        recognition_and_peer: "data pengiktirafan dan peer feedback",
        Low_Network: "Rangkaian Rendah",
        Low_inner_and_outer: "Hubungan dalaman dan luaran yang rendah",
        High_Inner: "Dalaman Tinggi",
        High_Inner_but_low: "Hubungan dalaman tinggi tetapi luaran rendah",
        High_Outer: "Luaran Tinggi",
        Low_inner_but_high: "Hubungan dalaman rendah tetapi luaran tinggi",
        High_Network: "Hubungan dalaman dan luaran yang tinggi",
        Achievements: "Pencapaian",
        Risk_Level: "Tahap Risiko",
        Talent_that_are_retention: "Bakat yang merupakan risiko pengekalan, dikesan daripada kekerapan",
        of_Not_Great_and: "jawapan “Not Great” dan “Unhappy” berkaitan “How are",
        you_feeling_today: "you feeling today?”",
        Twice_last_week: "Dua kali minggu lepas",
        Medium: "Sederhana",
        More_than_twice: "Lebih daripada dua kali minggu lepas",
        More_than_twice_last_and: "Lebih daripada dua kali minggu lepas dan minggu sebelumnya",
        Highlighting_key_accomplishments: "Memaparkan pencapaian utama dalam penglibatan dan pengiktirafan daripada rakan sekerja dan pengurus",
        Highly_Moderately_Somewhat_Under: "Kumpulan penglibatan Highly, Engaged, Somewhat, Under Engaged, atau In-active ditetapkan berdasarkan metrik tingkah laku.",
        Recognized_with_a_Leadership: "Diiktiraf dengan Leadership Medal of Excellence.",
        Recognized_as_Truly_Outstanding: "Diiktiraf sebagai Truly Outstanding daripada interaksi Peer Feedback.",
        A_star_is_earned: "Bintang diperoleh apabila layak sebagai Star Performer, dengan berada di kedudukan Top 15% penerima pengiktirafan pada mana-mana minggu.",
        A_score_that_represents: "Skor yang mewakili impak individu terhadap organisasi dan orang di sekelilingnya, ditentukan oleh",
        TEAMS: "PASUKAN",
        COHORTS: "KOHORT",
        REPORT_CARD_BY_TEAM: "Kad Laporan mengikut Pasukan",
        REPORT_CARD_BY_COHORTS: "Kad Laporan mengikut Kohort",
        Highest_Scores: "Skor Tertinggi",
        Lowest_Score: "Skor Terendah",
        Scores_are_updated_on: "Skor dikemaskini setiap suku tahun, dan boleh dilihat berbanding skor sebelumnya",
        SCORE_HISTORY: "SEJARAH SKOR",
        Max_Change: "Perubahan Maks",
        Most_Recent: "Terkini",
        NPS: "NPS",
        NPS_Details: "Butiran NPS",
        WHO_5: "WHO-5",
        eRes: "eRes",
        Culture: "Budaya",
        DEBI: "DEBI",
        Index: "Indeks",
        Alignment: "Keselarasan",
        Variance: "Perpaduan",
        Net_Promoter_Score_c_NPS: "Net Promoter Score ® (NPS)",
        Engagement_Score: "Skor Penglibatan",
        Engagement_Score_is: "Dynamic Engagement Behavioral Index (DEBI) ialah pendekatan holistik untuk mengukur penglibatan pekerja, melangkaui data laporan kendiri kepada penilaian yang lebih berasaskan tingkah laku.",
        Strategic_Alignment: "Strategic Alignment",
        Strategic_Alignment_is: "Strategic Alignment Index mengukur sejauh mana pasukan memahami dan melaksanakan keutamaan merentasi empat dimensi utama: Understanding & Clarity, Execution & Confidence, Resource & Support, dan Impact & Contribution. Skor yang lebih tinggi (0-100) menunjukkan keselarasan yang lebih kukuh antara kerja harian dengan objektif organisasi. Consistency Score pula mencerminkan sejauh mana pemahaman ini dikongsi secara seragam dalam kalangan ahli pasukan, dengan skor yang lebih tinggi menunjukkan keselarasan strategik yang lebih konsisten.",
        DEBI_report_card_label: "Dynamic Engagement Behavior Index yang mengukur penglibatan sebenar",
        Culture_Resilience_Well: "Indeks Budaya, Daya Tahan, dan Kesejahteraan",
        Net_Promotor_Score_is: "Net Promoter Score ialah pengiraan berdasarkan promoters, passives, dan detractors serta berada dalam julat -100 hingga +100.",
        Net_Promoter_Net_Promoter: "Net Promoter, Net Promoter System, Net Promoter Score, NPS dan emotikon berkaitan NPS adalah tanda dagangan berdaftar Bain & Company, Inc., Fred Reichheld dan Satmetrix Systems, Inc.",
        A_collection_of_indexes: "Koleksi indeks yang memberi pemahaman lebih baik tentang budaya, daya tahan, dan kesejahteraan organisasi anda.",
        The_Culture_Index_is: "Culture Index berdasarkan pengukuran tingkah laku yang menunjukkan kekuatan budaya organisasi.",
        The_Employee_Resilience_Index: "Employee Resilience Index memberi petunjuk keupayaan untuk bangkit semula daripada kemunduran dan bertindak balas terhadap cabaran.",
        The_WHO_5_Index_from: "Indeks WHO-5, daripada Pertubuhan Kesihatan Sedunia, ialah pengukuran sejagat untuk kesejahteraan.",
        Loyal_employees_who_are: "Pekerja setia yang bangga bekerja dengan anda ialah aset terbesar dalam menarik bakat yang lebih baik dan membantu mengharungi cabaran semasa krisis.",
        Company_alignment_provides: "Company alignment membolehkan pengurus dan pemimpin memahami sejauh mana pekerja mereka mampu menyumbang kepada objektif syarikat. Sebarang ketidakselarasan merupakan penggunaan sumber yang tidak optimum yang menghalang pertumbuhan, perkembangan, dan penglibatan pekerja yang terlibat.",
        Feedback_has_significant: "Maklum balas mempunyai potensi besar untuk memberi manfaat kepada pekerja dari segi prestasi individu dan pasukan. Pekerja memerlukan pemahaman yang jelas tentang bagaimana mereka boleh bertambah baik. Komunikasi berterusan adalah kritikal",
        Recent_studies: "Kajian terkini",
        focus_on_how_mindset: "memberi tumpuan kepada bagaimana pemikiran (mindset) memainkan peranan penting dalam melepaskan potensi penglibatan pekerja.",
        Social_educational_and: "Psikologi sosial, pendidikan, dan organisasi menunjukkan bagaimana pemikiran ialah sumber peribadi yang boleh mempengaruhi penglibatan pekerja melalui kegairahan untuk pembangunan, tafsiran usaha, tumpuan perhatian, persepsi terhadap halangan, dan interaksi antara individu.",
        Managers_play_an_importan: "Pengurus memainkan peranan penting dalam menguruskan dan membentuk pemikiran pasukan mereka.",
        Employees_need_to_feel_that_they_are: "Pekerja perlu merasakan bahawa mereka sentiasa berkembang dan belajar, baik dari segi peribadi mahupun profesional. Pengurus boleh memainkan peranan sebagai jurulatih dan mengarahkan peluang pembelajaran kepada pasukan mereka. Mereka juga perlu memastikan peluang pembangunan kerjaya jelas dan telus.",
        Employees_need_to_feel_taht_their_work: "Pekerja perlu merasakan bahawa kerja mereka dilihat oleh orang lain dan usaha mereka mendapat pengiktirafan yang sewajarnya. Pengiktirafan telah dikenal pasti sebagai 1 daripada 5 aktiviti utama yang terbukti menjadi peramal penglibatan pekerja.",
        The_support_that_employees: "Sokongan yang diterima oleh pekerja daripada rakan sekerja berkait rapat dengan sejauh mana mereka dapat menguruskan tekanan (wellness).",
        Studies: "Kajian",
        show_that_satisfaction_with: "menunjukkan bahawa kepuasan terhadap rakan sekerja mempunyai hubungan yang signifikan dengan penglibatan.",
        The: "Semakin",
        more_embedded_a_person: "seseorang itu terikat",
        is_in_their_job: "dengan pekerjaan mereka, semakin kurang kemungkinan mereka untuk berhenti. Jika terdapat konflik atau isu antara rakan sekerja dan ahli pasukan, pengurus dan pemimpin perlu dapat bertindak segera.",
        Managers_set_standards_for: "Pengurus menetapkan standard untuk pasukan mereka. Dan laporan terus mereka mahu memberi kesan kepada mereka! Untuk hubungan yang berkesan, pengurus perlu mempunyai interaksi yang bermakna dengan setiap laporan terus sekurang-kurangnya sekali setiap 2 minggu. Pekerja yang mempunyai mesyuarat tetap dengan pengurus mereka adalah tiga kali lebih berkemungkinan berasa terlibat dengan syarikat dan cemerlang dalam pekerjaan mereka.",
        Apart_from_pay_challenging: "Selain gaji, kerja yang mencabar telah dikenal pasti sebagai motivasi utama bagi pekerja. Pekerja perlu merasakan bahawa mereka menjalani kerjaya yang memuaskan dan melakukan kerja yang mempunyai tahap cabaran yang sesuai, seperti yang dijelaskan dalam teori Flow - The Psychology of Optimal Experience oleh Mihaly Csikszentmihalyi.",
        Employees_need_work_life: "Pekerja memerlukan keseimbangan kerja-kehidupan untuk kekal produktif dan terlibat dalam kerja. Kajian menunjukkan bahawa tekanan di tempat kerja dan burnout memberi kesan perantara terhadap penglibatan pekerja. Kesihatan fizikal dan mental dipertimbangkan.",
        Before: "Sebelum",
        After: "Selepas",
        Compare: "Banding",
        There_is_no_happiness: "Tiada data kegembiraan, risiko, atau aktiviti untuk dipaparkan (buat masa ini). Sila semak semula esok!",
        SPOTLIGHT: "Spotlight",
        Most_Engaged: "Paling Terlibat",
        Teams_with_highest_engagement: "Pasukan dengan skor penglibatan tertinggi. Skor ini mewakili nilai agregat daripada 9 dimensi penglibatan.",
        No_most_engaged_at: "Tiada pasukan paling terlibat pada masa ini",
        Retention_Risks: "Risiko Pengekalan",
        Teams_with_highest_retention: "Pasukan dengan skor risiko pengekalan tertinggi. Skor ini mewakili agregat daripada dimensi yang berkaitan dengan kadar perletakan jawatan.",
        No_retention_risks_at: "Tiada risiko pengekalan pada masa ini",
        Teams_that_show_the_most: "Pasukan yang menunjukkan peningkatan paling banyak dalam tempoh 2 minggu lepas. Skor ini mewakili peningkatan skor penglibatan.",
        No_most_improved_at: "Tiada pasukan paling meningkat pada masa ini",
        Most_Critical: "Paling Kritikal",
        Teams_that_are_most_critical: "Pasukan yang paling kritikal dalam tempoh 2 minggu lepas. Skor ini mewakili penurunan skor penglibatan.",
        Most_Improved: "Paling Meningkat",
        No_most_critical: "Tiada pasukan paling kritikal pada masa ini",
        TEAM_STATUS: "Status Pasukan",
        Team: "Pasukan",
        Happi_Rate: "Kadar Gembira",
        Wellness: "Wellness",
        Rel_Manager: "Hub. Pengurus",
        Recognition: "Pengiktirafan",
        Ambassadorship: "Ambassadorship",
        Rel_Colleagues: "Hub. Rakan Sekerja",
        Personal_Growth: "Perkembangan Peribadi",
        Strategic_Alignment_Details: "Butiran Strategic Alignment",
        Strategic_Alignment_Breakdown: "Pecahan Strategic Alignment",
        Strongly_Agree: "Sangat Setuju",
        Agree: "Setuju",
        Disagree: "Tidak Setuju",
        Strongly_Disagree: "Sangat Tidak Setuju",
        WHO_5_Breakdown: "Pecahan WHO-5",
        WHO_5_Details: "Butiran WHO-5",
        Culture_Index_Details: "Butiran Culture Index",
        Culture_Index_Breakdown: "Pecahan Culture Index",
        Scoped: "Terhad",
        Global: "Global",
        Current_Filtered_List: "Senarai Ditapis Semasa",
        Entire_Company: "Seluruh Syarikat",
        people_impact: "Impak Pekerja",
        workplace_culture_impact: "Impak Budaya Tempat Kerja",
        people_impact_tooltip_desc: "Berdasarkan analitik tingkah laku dan sumbangan individu terhadap budaya tempat kerja",
        high_impact_label: "Impak Tinggi",
        high_impact_desc: "Secara aktif memacu budaya positif, mengiktiraf orang lain, konsisten dalam penglibatan",
        moderate_impact_label: "Impak Sederhana",
        moderate_impact_desc: "Penyumbang yang stabil, menyertai secara kerap, menyokong orang lain",
        low_impact_label: "Impak Rendah",
        low_impact_desc: "Penglibatan terhad, mungkin memerlukan sokongan tambahan",
        people_impact_target: "Sasaran: ≥70% gabungan impak tinggi + sederhana untuk prestasi optimum",
        manager_activity: "Aktiviti Pengurus",
        manager_feedback_responsiveness: "Responsif Maklum Balas Pengurus",
        manager_activity_tooltip_desc: "Berdasarkan kadar balasan maklum balas kepada pasukan mereka",
        manager_responsive_label: "Responsif",
        manager_responsive_desc: "Konsisten membalas maklum balas pasukan untuk mengekalkan penglibatan pasukan",
        manager_moderate_label: "Sederhana",
        manager_moderate_desc: "Balasan yang kerap tetapi mungkin terlepas sebahagian maklum balas",
        manager_minimal_label: "Minimum",
        manager_minimal_desc: "Balasan jarang, mungkin memerlukan bimbingan dalam memberi maklum balas",
        manager_activity_target: "Sasaran: ≥80% kadar balasan pengurus untuk prestasi optimum",
        focus_and_goal_alignment: "Focus & Goal Alignment",
        focus_alignment_tooltip: "Jejak sejauh mana fokus pasukan selari dengan matlamat syarikat.",
        focus_coverage_tooltip_bullet: "• Focus Coverage: Gambaran masa nyata",
        goal_alignment_tooltip_bullet: "• Goal Alignment: 90 hari lepas",
        learning_section_title: "Pembelajaran",
        learning_tooltip: "Jejak kemajuan pembelajaran dan pembangunan kemahiran pasukan.",
        learning_progress_tooltip_bullet: "• Learning Progress: 6 bulan lepas",
        focus_coverage: "Focus Coverage",
        focus_areas: "Focus Areas",
        last_week: "Minggu lepas",
        people_with_focus_connector: "daripada",
        people_with_focus_suffix: "orang mempunyai fokus",
        goal_alignment: "Goal Alignment",
        goals_label: "Matlamat",
        aligned_suffix: "selari",
        unaligned_suffix: "tidak selari",
        unknown_label: "Tidak diketahui",
        unknown_suffix: "penjajaran tidak diketahui",
        setup_goals_empty_state: "Sediakan matlamat untuk menjejak keselarasan",
        alignment_not_available: "Data fokus belum mencukupi untuk menilai penjajaran",
        learning_progress: "Learning Progress",
        learning_journeys: "Learning Journeys",
        members_upskilling: "ahli sedang meningkatkan kemahiran",
        completed_label: "selesai",
        tenure_empty_state: "Cerapan tempoh kerja anda akan muncul selepas hari pertama anda dengan Happily. Ini membantu kami memaparkan corak pasukan yang bermakna.",
        overall_label: "Keseluruhan",
        leadership_label: "Kepimpinan",
        pending_data: "Data Tertangguh",
        communication_health: "Kesihatan Komunikasi",
        show_all_teams_prefix: "Papar semua",
        show_all_teams_suffix: "pasukan",
        show_less: "Papar kurang",
        Select: "Pilih",
        All_Cohorts: "Semua Kohort",
        All_Teams: "Semua Pasukan",
        Search_cohorts_placeholder: "Cari kohort...",
        No_data_for_time_period: "Tiada data untuk dipaparkan bagi tempoh masa semasa.",
        Happiness_Rate_tooltip: "Kadar respons \"Very Happy\" atau \"Pretty Good\" kepada soalan daily pulse \"How do you feel today?\"",
        Risk_Rate_tooltip: "Kadar respons \"Not Great\" atau \"Terrible\" kepada soalan daily pulse \"How do you feel today?\"",
        Avg_Impact: "Purata Impak",
        Avg_Impact_tooltip: "Skor penarafan impak purata ahli kohort, dikira sebagai jumlah skor impak individu dibahagikan dengan bilangan ahli",
        DEBI_Score: "Skor DEBI",
        DEBI_Score_tooltip: "Dynamic Engagement Behavioral Index (DEBI) bagi setiap kohort ditentukan oleh beberapa faktor: kekerapan check-in dan respons ahli kohort, kualiti maklum balas mereka, aktiviti dalam mengiktiraf rakan sekerja, dan keselarasan dengan nilai teras organisasi.",
        ENGAGEMENT_SCORE: "SKOR PENGLIBATAN",
        DEBI_by_role: "Dynamic Engagement Behavioral Index mengikut peranan",
        Manager: "Pengurus",
        Leader: "Pemimpin",
        Six_mo_Retention: "Pengekalan 6-bln",
        Six_mo_Retention_tooltip: "Kadar pengekalan 6 bulan, dikira sebagai peratusan ahli kohort yang masih bekerja. Formula: Saiz Kohort Semasa ÷ (Saiz Kohort Semasa + Pekerja Diarkibkan dalam 6 Bulan Lepas) × 100",
        ARCHIVED_MEMBERS_HISTORY: "SEJARAH AHLI DIARKIBKAN",
        Number_of_archived_by_month: "Jumlah ahli diarkibkan mengikut bulan",
        Terminated: "Ditamatkan",
        Resigned: "Meletak Jawatan",
        Preparing_cohort_data: "Menyediakan data kohort, sila tunggu...",
        Organizational_Network: "Rangkaian Organisasi",
        Organizational_Network_desc: "Memvisualisasikan hubungan yang terbentuk melalui pengiktirafan rakan/pengurus, pertukaran maklum balas, dan interaksi bermakna dalam tempoh 6 bulan lepas",
        Focusing: "Memfokus",
        Nodes: "Nodes",
        Attribute: "Atribut",
        Links: "Pautan",
        Relationships: "Hubungan",
        Relationship_Attributes: "Atribut Hubungan",
        Relationship_Power: "Kuasa Hubungan",
        Filter_by_power_rating: "Tapis mengikut kumpulan klasifikasi penarafan kuasa",
        Signature: "Signature",
        Filter_by_signature: "Tapis mengikut nilai signature yang ditanda dalam hubungan",
        Connections: "Hubungan",
        Engagement: "Penglibatan",
        Signatures: "Signatures",
        Name_Team: "Nama, Pasukan",
        No_signatures_available: "Tiada signature tersedia",
        All_Signatures: "Semua Signatures",
        more_suffix: "lagi",
        Focus_in_relationship_map: "Fokus dalam peta hubungan",
        Total: "Jumlah",
        Manager_Responsiveness: "Responsif Pengurus",
        Manager_Activity_Details: "Butiran Aktiviti Pengurus",
        Managers_play_central_role: "Pengurus memainkan peranan utama dalam menghubungkan objektif anda dengan tindakan dan hasil.",
        Performance_Metrics: "Metrik Prestasi",
        Feedback_Rate: "Kadar Maklum Balas",
        Reply_Rate: "Kadar Balasan",
        Performance_Boosts_On_Track: "Performance Boosts Ikut Jadual",
        Insights_and_Nudges: "Insights & Nudges",
        Daily_Insights: "Insights Harian",
        Weekly_Insights: "Insights Mingguan",
        Coaching_Suggestions: "Cadangan Bimbingan",
        Coaching_Suggestions_desc: "Item tindakan yang dijana AI dihantar kepada pengurus dalam laporan mingguan mereka dalam tempoh 4 minggu lepas. Cadangan yang diperibadikan ini membantu pengurus meningkatkan penglibatan dan prestasi pasukan.",
        Individual_Manager_Analysis: "Analisis Pengurus Individu",
        Manager_Scorecard: "Kad Skor Pengurus",
        Manager_Scorecard_desc: "Kad skor ini menyediakan gambaran keseluruhan aktiviti utama dan metrik prestasi bagi pengurus, dengan tumpuan pada interaksi mereka dengan laporan terus. Ia membantu memahami sejauh mana pengurus menjadi teladan tingkah laku utama, memacu prestasi, dan melibatkan pasukan mereka.",
        Manager_Scorecard_definition: "Manager effectiveness, 0–100. A weighted score of the leadership behaviors and team outcomes your company values most.",
        Scorecard_Settings: "Scorecard settings",
        Performance_reviews_enabled: "Performance reviews enabled",
        Category_Weights: "Category weights",
        Advanced_weights: "Advanced: weight individual metrics",
        Show_composite_as: "Show composite as",
        Save_settings: "Save settings",
        Reset: "Reset",
        Performance_Group: "Kumpulan Prestasi",
        All_Performance_Groups: "Semua Kumpulan Prestasi",
        Elite_Managers: "Pengurus Elite",
        High_Performers: "Prestasi Tinggi",
        Rising_Stars: "Bintang Muncul",
        Feedback_Champions: "Juara Maklum Balas",
        At_Risk_Managers: "Pengurus Berisiko",
        Ghost_Managers: "Pengurus Ghost",
        Conv_Initiated: "Perbual. Dimulakan",
        Conv_Initiated_tooltip: "Peratusan perbualan yang dimulakan oleh pengurus ini dengan pengurus mereka sendiri, menunjukkan komunikasi proaktif ke atas",
        Peer_Feedback: "Peer Feedback",
        Peer_Feedback_tooltip: "Bilangan permintaan peer feedback yang dibuat oleh pengurus ini untuk diri mereka sendiri, menunjukkan komitmen terhadap pembaikan diri",
        Boosts_On_Track: "Boosts Ikut Jadual",
        Boosts_On_Track_tooltip: "Peratusan performance boosts yang samada selesai atau belum selesai tetapi tidak tertunggak",
        Goals_Progress: "Kemajuan Matlamat",
        Goals_Progress_tooltip: "Kemajuan keseluruhan yang dibuat oleh laporan terus seperti dinilai dalam ulasan prestasi mereka",
        Culture_Contr: "Sumb. Budaya.",
        Culture_Contr_tooltip: "Sejauh mana laporan terus menyumbang kepada budaya, seperti dinilai dalam ulasan prestasi mereka",
        Reply_Rate_tooltip: "Peratusan maklum balas pasukan yang dibalas oleh pengurus dalam tempoh 30 hari lepas",
        Reply_Rate_short: "Kadar Balasan",
        Reply_Rate_line1: "Kadar",
        Reply_Rate_line2: "Balasan",
        Insights_Opened_tooltip: "Peratusan Manager Insights dibuka dari peti masuk e-mel. Nota: Mungkin tidak tepat jika penjejakan e-mel disekat",
        Insights_Opened_short: "Insights Dibuka",
        Team_DEBI: "DEBI Pasukan",
        Team_DEBI_line1: "DEBI",
        Team_DEBI_line2: "Pasukan",
        DEBI_Score_col_tooltip: "Dynamic Engagement Behavior Index untuk pasukan pengurus ini, berdasarkan laporan terus mereka. Ini ialah indeks tingkah laku DEBI, jadi ia boleh berbeza daripada skor komposit Engagement dalam People Intelligence.",
        Action_Items_line1: "Item",
        Action_Items_line2: "Tindakan",
        Manager_Coaching_Interactions: "Interaksi Bimbingan Pengurus",
        Manager_Classification_Settings: "Tetapan Klasifikasi Pengurus",
        View_detailed_breakdown: "Lihat pecahan terperinci",
        Proactivity_Rating_Breakdown: "Pecahan Penarafan Proactivity",
        Psychological_Safety_Breakdown: "Pecahan Psychological Safety",
        People_Risk_Recovery_Trends: "Trend Risiko & Pemulihan Pekerja",
        Click_any_week_for_details: "Klik mana-mana minggu untuk melihat butiran",
        Recovery: "Pemulihan",
        AVG: "PURATA",
        Percentile: "Persentil",
        Name_and_Team: "Nama dan Pasukan",
        Health_Indicator: "Penunjuk Kesihatan",
        Contributions: "Sumbangan",
        Talent_and_Network: "Bakat & Rangkaian",
        Organizational_Positioning: "Kedudukan Organisasi",
        Medals_and_Peer_Ratings: "Pingat & Penarafan Rakan Sekerja",
        Skills_and_Values: "Kemahiran & Nilai",
        Overall_Score: "Skor Keseluruhan",
        col_name_team_tooltip: "Nama pekerja, jabatan, dan status kesejahteraan semasa berdasarkan maklum balas terkini",
        col_contributions_tooltip: "Pengiktirafan daripada rakan sekerja dan penilaian prestasi oleh pengurus",
        col_talent_network_tooltip: "Klasifikasi bakat pekerja dan jangkauan rangkaian organisasi",
        col_achievements_tooltip: "Pengiktirafan yang diperoleh melalui pingat dan penarafan peer feedback yang tinggi",
        col_alignment_tooltip: "Penilaian kecekapan pekerja dalam kemahiran utama dan keselarasan dengan nilai syarikat",
        col_impact_rating_tooltip: "Skor prestasi keseluruhan dengan penunjuk perubahan mingguan",
        Support: "Sokongan",
        Performance: "Prestasi",
        Performance_subtitle: "KR atau kadar gem",
        Performance_subtitle_kr: "KR · {progress}%",
        Performance_subtitle_gem: "Kadar gem",
        Performance_dataNote_kr: "Purata kemajuan KR dan kesihatan KR untuk matlamat yang dimiliki orang ini.",
        Performance_dataNote_gem: "Kadar gem (budaya dan matlamat kedua-duanya 3+) ditimbang mengikut bilangan interaksi. Berdasarkan 6 bulan lepas.",
        Happiness: "Kebahagiaan",
        Happiness_subtitle: "Daftar masuk harian",
        Happiness_dataNote: "Corak respons kebahagiaan harian daripada daftar masuk. Mencerminkan mood terkini. Berbeza daripada Kesejahteraan (Wellbeing) yang menggunakan Indeks WHO-5.",
        Wellbeing: "Kesejahteraan",
        Wellbeing_subtitle: "Isyarat suku tahunan",
        Wellbeing_dataNote: "Isyarat kesejahteraan terkini daripada daftar masuk harian. WHO-5 (penanda aras kesejahteraan utama) muncul dalam panel yang dikembangkan apabila tersedia.",
        Impact_Rating_dataNote: "Skor komposit sumbangan keseluruhan. Menggabungkan tingkah laku komitmen dan kesan organisasi. Dikemas kini mingguan. Skor melebihi 70 menunjukkan komitmen yang kuat.",
        Flight_Risk: "Risiko Berhenti",
        Flight_Risk_subtitle: "Isyarat 90 hari",
        Flight_Risk_Low: "Rendah",
        Flight_Risk_Moderate: "Sederhana",
        Flight_Risk_High: "Tinggi",
        Flight_Risk_Safe: "Selamat",
        Flight_Risk_Watch: "Perhatikan",
        Flight_Risk_At_risk: "Berisiko",
        Engagement_subtitle: "30 hari lalu",
        Performance_subtitle_v2: "Matlamat & maklum balas",
        Peer_Trust_subtitle_v2: "Kepercayaan · rangkaian",
        Band_Excellent: "Cemerlang",
        Band_Good: "Baik",
        Band_Fair: "Sederhana",
        Band_Watch: "Perhatikan",
        Band_Poor: "Rendah",
        No_data: "Tiada data",
        Performance_no_reviews: "Tiada ulasan",
        Recognized_By: "Diiktiraf oleh",
        Recognized_as_outstanding_by: "Diiktiraf cemerlang oleh",
        Recognized_as_outstanding: "Diiktiraf cemerlang",
        Peer_single: "rakan",
        Past_6_mo: "6 bulan lepas",
        Past_6_months: "6 bulan lepas",
        Medals: "Pingat",
        Giving: "Memberi",
        Receiving: "Menerima",
        Vs_team_median_6mo: "berbanding median pasukan (6 bulan)",
        Band_top_quartile: "25% teratas",
        Band_above_median: "Atas purata",
        Band_typical: "Tipikal",
        Band_below_typical: "Bawah purata",
        Truly_Outstanding: "Sangat Cemerlang",
        Exceeding_Expectations: "Melebihi Jangkaan",
        Skill_band_developing: "Membangun",
        Skill_band_building: "Membina asas",
        Skill_band_applying: "Mengaplikasi",
        Skill_band_integrated: "Bersepadu",
        Skill_band_mastery: "Kemahiran tinggi",
        Values_band_strong: "Sangat selaras",
        Values_band_aligned: "Selaras",
        Values_band_mixed: "Bercampur",
        Values_band_emerging: "Baru muncul",
        Values_split_given_label: "Memberi",
        Values_split_received_label: "Menerima",
        Values_tooltip_intro: "Dianalisis dengan AI daripada aktiviti pengiktirafan rakan.",
        Values_tooltip_events_suffix: "peristiwa pengiktirafan (60 hari lepas)",
        Not_measured: "Belum diukur",
        More: "lagi",
        Flight_Risk_dataNote: "Berdasarkan corak daftar masuk harian merah (tidak gembira) sepanjang 90 hari lepas. Nombor lebih tinggi = risiko penurunan komitmen lebih besar.",
        Peer_Trust: "Kepercayaan Rakan Sekerja",
        Peer_Trust_subtitle_short: "Skor · rakan",
        Peer_Trust_dataNote: "Menggabungkan aktiviti maklum balas rakan, timbal balik pengiktirafan, kedalaman rangkaian, dan kualiti pengiktirafan diterima. Berdasarkan 6 bulan lepas.",
        Peers: "rakan",
        Coins: "syiling",
        Gems: "gem",
        Engagement: "Penglibatan",
        Checkin_consistency: "Ketekalan daftar masuk",
        Giving_recognition: "Memberi pengiktirafan",
        Receiving_recognition: "Menerima pengiktirafan",
        Manager_responsiveness: "Tindak balas pengurus",
        No_manager_assigned: "Tiada pengurus ditugaskan",
        Risk_reason: "Sebab risiko",
        Goals: "Matlamat",
        Power_Skills: "Kemahiran Kuasa",
        Empathy: "Empati",
        Self_Awareness: "Kesedaran Diri",
        Critical_Thinking: "Pemikiran Kritis",
        Leadership: "Kepimpinan",
        Initiative: "Inisiatif",
        Optimism: "Optimisme",
        Positioning_and_Achievements: "Kedudukan & Pencapaian",
        Engagement_and_Contributions: "Penglibatan & Sumbangan",
        Context_and_Power_Skills: "Konteks & Kemahiran Kuasa",
        Show_details_for: "Tunjuk butiran untuk {name}",
        col_happiness_tooltip: "Corak respons kebahagiaan harian daripada daftar masuk. WHO-5 sebagai penanda aras Kesejahteraan apabila tersedia.",
        col_wellbeing_tooltip: "Isyarat kesejahteraan terkini daripada daftar masuk harian. WHO-5 (penanda aras kesejahteraan utama) muncul dalam panel yang dikembangkan apabila tersedia.",
        col_engagement_tooltip: "Skor individu berdasarkan 30 hari check-in, maklum balas, pengiktirafan dan aktiviti rakan sekerja.\nPaparan DEBI lain boleh memasukkan dinamik hubungan dan rangkaian pasukan.",
        col_flight_risk_tooltip: "Kemungkinan penurunan komitmen berdasarkan corak daftar masuk dalam 90 hari lepas.",
        col_performance_tooltip: "Kemajuan KR apabila matlamat dimiliki; jika tidak, kadar gem yang dinilai rakan sekerja.",
        col_peer_trust_tooltip: "Tahap kepercayaan dan dihargai oleh rakan sekerja, serta keluasan hubungan rakan.",
        Engagement_dataNote: "Menggabungkan 6 penunjuk bulanan: daftar masuk harian (30%), maklum balas terbuka (20%), aktiviti pengiktirafan (20%), maklum balas pengurus (10%), kualiti pengiktirafan (10%), dan maklum balas rakan (10%). Berdasarkan bulan terkini.",
        Skills: "Kemahiran",
        Values: "Nilai",
        Values_Alignment: "Keselarasan Nilai",
        Talent_Group: "Kumpulan Bakat",
        All_People: "Semua Pekerja",
        risk_drilldown: {
            title: "Risk Drill-Down",
            high: "Tinggi",
            med: "Sed",
            low: "Rendah",
            recovered: "Pulih",
            recovered_lc: "pulih",
            no_change: "Tiada perubahan",
            selected: "Dipilih",
            col_name: "Nama",
            col_frequency: "Kekerapan",
            col_history: "Sejarah",
            exited: "Keluar",
            weeks_short: "/ 8 mgg",
            at_risk: "berisiko",
            week_of: "Minggu",
            recurring: "Berulang",
            first_time: "Kali Pertama",
        },
        spotlight: {
            highlighting_teams: "Memaparkan pasukan yang perlu diberi tumpuan pada minggu",
            most_engaged: "PALING TERLIBAT",
            most_engaged_desc: "Pasukan dengan skor penglibatan tertinggi. Skor ini mewakili nilai agregat daripada 9 dimensi penglibatan.",
            retention_risks: "RISIKO PENGEKALAN",
            retention_risks_desc: "Pasukan dengan skor risiko pengekalan tertinggi. Skor ini mewakili agregat daripada dimensi yang berkaitan dengan kadar perletakan jawatan.",
            most_improved: "PALING MENINGKAT",
            most_improved_desc: "Pasukan yang menunjukkan peningkatan paling banyak dalam tempoh 2 minggu lepas. Skor ini mewakili peningkatan skor penglibatan.",
            most_critical: "PALING KRITIKAL",
            most_critical_desc: "Pasukan yang paling kritikal dalam tempoh 2 minggu lepas. Skor ini mewakili penurunan skor penglibatan.",
            team: "Pasukan",
            score: "Skor",
        },
    },
    goals: {
        team_goals: "Matlamat Pasukan",
        goals_description: "Urus dan jejak matlamat untuk setiap pasukan",
        add_goals: "Tambah Matlamat",
        edit_goals: "Edit Matlamat",
        save: "Simpan",
        cancel: "Batal",
        team_name: "Pasukan",
        goals_label: "Matlamat Pasukan",
        goals_placeholder: "Masukkan matlamat dan objektif pasukan, satu setiap baris...",
        goals_hint: "Matlamat ini akan digunakan untuk menyediakan analisis dan panduan maklum balas yang disasarkan kepada pengurus dan pasukan mereka.",
        add_goals_title: "Tambah Matlamat Pasukan",
        edit_goals_title: "Edit Matlamat Pasukan",
        no_teams: "Tiada pasukan ditemui",
        no_goals: "Tiada matlamat ditetapkan",
        save_success: "Matlamat berjaya disimpan",
        save_error: "Ralat menyimpan matlamat. Sila cuba lagi.",
        kr_templates: {
            revenue_mrr_title: "Tingkatkan hasil berulang bulanan",
            revenue_mrr_reasoning: "Matlamat berfokus hasil mencadangkan penjejakan pertumbuhan kewangan sebagai hasil yang boleh diukur.",
            revenue_deals_title: "Tutup deal baharu pada suku ini",
            revenue_deals_reasoning: "Bilangan deal memberi petunjuk awal pertumbuhan hasil.",
            revenue_deal_size_title: "Tingkatkan saiz deal purata",
            revenue_deal_size_reasoning: "Deal yang lebih besar menggandakan pertumbuhan hasil tanpa perlukan peningkatan usaha berkadaran.",
            customer_nps_title: "Capai skor NPS sasaran",
            customer_nps_reasoning: "NPS mengukur kepuasan dan kesetiaan pelanggan secara langsung.",
            customer_churn_title: "Kurangkan kadar churn pelanggan",
            customer_churn_reasoning: "Churn yang lebih rendah menandakan pengalaman dan pengekalan pelanggan yang lebih baik.",
            customer_support_title: "Tingkatkan kelajuan penyelesaian tiket sokongan",
            customer_support_reasoning: "Penyelesaian yang lebih cepat memberi kesan langsung kepada kepuasan pelanggan.",
            hire_fill_title: "Isi jawatan kosong",
            hire_fill_reasoning: "Menjejak kemajuan bilangan pekerja berbanding pelan pengambilan.",
            hire_time_title: "Kurangkan masa untuk mengambil pekerja",
            hire_time_reasoning: "Pengambilan yang lebih cepat meningkatkan kelajuan pasukan dan mengurangkan kos peluang.",
            hire_retention_title: "Kadar pengekalan pekerja baharu 90 hari",
            hire_retention_reasoning: "Pengekalan awal yang tinggi menandakan onboarding yang berkesan dan kesesuaian peranan.",
            ship_features_title: "Hantar ciri yang dirancang tepat pada masanya",
            ship_features_reasoning: "Bilangan ciri dihantar menjejak pelaksanaan mengikut peta hala tuju produk.",
            ship_bugs_title: "Kurangkan kadar bug terlepas ke produksi",
            ship_bugs_reasoning: "Kadar terlepas yang lebih rendah menunjukkan kualiti yang lebih baik sebelum pelepasan.",
            ship_adoption_title: "Capai penerimaan pengguna bagi ciri baharu",
            ship_adoption_reasoning: "Penerimaan mengesahkan ciri yang dihantar menyelesaikan keperluan pengguna sebenar.",
            engage_score_title: "Tingkatkan skor penglibatan pasukan",
            engage_score_reasoning: "Skor penglibatan mencerminkan kesihatan keseluruhan dan motivasi pasukan.",
            engage_participation_title: "Tingkatkan penyertaan dalam maklum balas",
            engage_participation_reasoning: "Kadar penyertaan yang lebih tinggi menunjukkan keselamatan psikologi dan penglibatan.",
            engage_turnover_title: "Kurangkan pusing ganti secara sukarela",
            engage_turnover_reasoning: "Pusing ganti yang lebih rendah menandakan budaya dan kepuasan pekerja yang lebih baik.",
            generic_milestones_title: "Lengkapkan pencapaian utama",
            generic_milestones_reasoning: "Penjejakan pencapaian memberikan titik semak kemajuan yang jelas untuk objektif ini.",
            generic_completion_title: "Capai kadar siap sasaran",
            generic_completion_reasoning: "Peratusan siap keseluruhan memberikan pandangan tunggal kemajuan matlamat.",
            generic_improvement_title: "Hantar penambahbaikan yang boleh diukur",
            generic_improvement_reasoning: "Mengukur penambahbaikan menjadikan kemajuan kelihatan dan memberi motivasi.",
            unit_deals: " deal",
            unit_hires: " pengambilan",
            unit_days: " hari",
            unit_features: " ciri",
            unit_milestones: " pencapaian",
            unit_percent_within_sla: "% dalam SLA",
            unit_percent_of_users: "% pengguna",
        },
    },
    integrations: {
        API_DOCUMENTATION: "DOKUMENTASI API",
        Reference_and_instructional: "Panduan rujukan dan arahan bagi tindakan API yang tersedia",
        Go_to_API_Doc: "Ke Dokumen API",
        PRODUCTION_TOKEN: "PRODUCTION TOKEN",
        This_is_your_production: "Ini ialah production token anda. API token anda perlu disimpan dengan selamat seperti mana-mana kata laluan lain.",
        Generate_a_Token: "Jana Token",
        API_LOG: "LOG API",
        A_log_of_API_activity: "Log aktiviti API yang dijana oleh API token yang dikaitkan dengan akaun anda. Ia merekodkan tarikh, operasi API, status dan jenis penggunaan bagi setiap transaksi API.",
        results_from: "hasil daripada",
        results: "hasil",
        SELECT_SYNC_METHOD: "PILIH KAEDAH SYNC",
        INTEGRATION_PARAMETERS: "PARAMETER INTEGRASI",
        Webhook: "Webhook",
        Sort_by_Name: "Susun Ikut Nama",
        Token: "Token",
        Webhook_Endpoint: "Webhook Endpoint",
        Sync_Type: "Jenis Sync",
        Staged_Syncing: "Sync Berperingkat",
        Your_members_are_queued_up: "Ahli anda akan dibariskan dan disediakan untuk penambahan atau penyahaktifan. Kaedah ini memberi peluang kepada anda menyemak perubahan secara manual sebelum ia dilaksanakan",
        Normal_Syncing: "Sync Biasa",
        Users_can_be_added: "Pengguna boleh ditambah terus ke Happily, dan akan ditambah atau dinyahaktifkan secara automatik berdasarkan status mereka dalam data yang dihantar",
        Syncing: "Sedang Sync",
        All_users_who_are: "Semua pengguna yang berada dalam Happily tetapi tiada dalam data yang dihantar akan dinyahaktifkan",
        Options: "Pilihan",
        Abbreviate_Team_Name: "Singkatkan Nama Pasukan",
        Automatically_abbreviate_long_team: "Singkatkan nama pasukan yang panjang secara automatik supaya laporan dan cerapan lebih mudah dibaca",
        Enable: "Dayakan",
        Enable_web_hook: "Dayakan web hook",
        Any_data_that: "Sebarang data yang anda hantar ke web hook akan disegerakkan dengan rangkaian anda",
        Save_Changes: "Simpan",
        WEBHOOK_LOGS: "LOG WEBHOOK",
        Sync_users_using_your: "Segerakkan pengguna menggunakan HRIS anda. Senarai ini mengandungi 50 permintaan HRIS Webhook terkini. Anda boleh",
        Simulate_Changes: "Simulasi Perubahan",
        to_see_how_the: "untuk melihat bagaimana data akan mempengaruhi rangkaian anda menggunakan tetapan sync HRIS Webhook semasa",
        Date: "Tarikh",
        Webhook_Content: "Kandungan Webhook",
        Integration_Status: "Status Integrasi",
        Actions: "Tindakan",
        View_Changes: "Lihat Perubahan",
        No_webhook_activity: "Tiada aktiviti webhook direkodkan",
        Members: "Ahli",
        INTEGRATION_STATUS: "STATUS INTEGRASI",
        HRIS_Sync: "HRIS Sync",
        Sync_your_employee_data: "Segerakkan data pekerja anda dengan HRIS untuk pengurusan ahli dalam satu aliran",
        Connected: "Disambungkan",
        Setup: "Persediaan",
        Developer_API: "Developer API",
        Activate_your_developer: "Aktifkan program pembangun anda dan dapatkan kelayakan untuk mengakses perkhidmatan API",
        SSO_Title: "Single Sign-On (SSO)",
        SSO_Desc: "Dayakan SSO sebagai kaedah pengesahan dan peruntukan akaun ahli",
        Directory_Sync: "Directory Sync",
        Endpoint: "Endpoint",
        Enable_Directory_Sync: "Dayakan Directory Sync",
        Directory_Sync_Desc: "Sebarang data yang dihantar oleh directory anda akan disegerakkan dengan akaun Happily anda",
        slack: {
            loadingConfig: "Memuatkan konfigurasi Slack...",
            connectTitle: "Sambungkan Happily ke Slack",
            connectDescription: "Bawa pengiktirafan, cerapan dan penglibatan terus ke Slack workspace pasukan anda.",
            feature: {
                recognitionTitle: "Siaran Pengiktirafan",
                recognitionDesc: "Kongsi pengiktirafan di saluran Slack secara automatik",
                reportsTitle: "Petikan Laporan Pengurus",
                reportsDesc: "Cerapan harian dan mingguan dihantar melalui DM",
                nudgesTitle: "Peringatan Check-in",
                nudgesDesc: "Peringatan lembut untuk menggalakkan penglibatan",
                reactionTitle: "Sync Reaction",
                reactionDesc: "Reaction Slack disegerakkan semula ke Happily",
            },
            connecting: "Menyambung...",
            connectButton: "Sambung ke Slack",
            redirectNote: "Anda akan diarahkan ke Slack untuk membenarkan Happily",
            comingSoon: "Backend integrasi Slack sedang disediakan. Sila semak semula kemudian!",
            connectedTo: "Disambungkan ke",
            connectedOn: "Disambungkan",
            byUser: "oleh",
            test: "Uji",
            disconnect: "Putuskan Sambungan",
            featuresSection: "Ciri",
            toggle: {
                recognitionDesc: "Siarkan pengiktirafan ke saluran Slack",
                dailyReportTitle: "Petikan Laporan Harian",
                dailyReportDesc: "Cerapan pagi untuk pengurus",
                weeklyReportTitle: "Petikan Laporan Mingguan",
                weeklyReportDesc: "Ringkasan mingguan setiap Isnin",
                nudgesDesc: "Galakkan penglibatan dengan peringatan lembut",
                reactionDesc: "Jejak reaction Slack dalam Happily",
            },
            channelSettings: "Tetapan Saluran",
            recognitionChannel: "Saluran Pengiktirafan",
            selectChannel: "Pilih saluran",
            teamChannels: "Siarkan juga ke saluran khusus pasukan",
            dmRecipients: "DM penerima secara terus",
            nudgeSettings: "Tetapan Peringatan",
            triggerAfter: "Picu selepas",
            daysWithoutCheckin: "hari tanpa check-in",
            maxPerWeek: "Maksimum seminggu",
            nudgesPerPerson: "peringatan seorang",
            saving: "Menyimpan...",
        },
        sso: {
            selectMethod: "PILIH KAEDAH SSO",
            general: "UMUM",
            providerId: "SSO Provider ID",
            providerIdPlaceholder: "Provider ID",
            connectionName: "Nama sambungan",
            connectionNamePlaceholder: "Pengecam logik bagi sambungan",
            entityId: "Entity ID",
            signInUrl: "Sign In URL",
            certificate: "Sijil",
            certificatePlaceholder: "Public key pelayan SAMLP dalam format PEM atau CER",
            syncProfileAttributes: "Sync Atribut Profil",
            syncAtLogin: "Sync atribut profil pengguna pada setiap log masuk",
            syncAtLoginDesc: "Kemaskini nama pertama, nama akhir dan foto profil pada setiap log masuk",
            setupInfo: "MAKLUMAT PERSEDIAAN",
            authCallbackUrl: "Auth Callback URL",
            on: "HIDUP",
            off: "MATI",
            ssoEnabledLabel: "SSO didayakan sebagai kaedah log masuk",
            dangerZone: "ZON BAHAYA",
            deleteConnection: "Padam Sambungan",
            deleteConnectionDesc: "Setelah disahkan, operasi ini tidak boleh dibatalkan! Log masuk ahli akan kembali kepada OTP.",
            removeConnection: "Buang sambungan ini",
        },
    },
    login: {
        sign_in_to: "Log masuk ke",
        please_enter_your: "Sila masukkan alamat e-mel anda",
        keep_me_logged: "Kekalkan saya log masuk",
        terms_and_Conditions: "Terma & Syarat",
        sign_in: "Log masuk",
        your_account_access: "Akses akaun anda disekat, di luar parameter akses yang sah",
        your_IP: "IP anda",
    },
    members: {
        ORGANIZATION_CHART_VIEW: "PAPARAN CARTA ORGANISASI",
        the_org_chart: "Carta organisasi dalam paparan semasa terlalu besar untuk dieksport sebagai fail imej.",
        Members: "Ahli",
        incomplete_profiles: "profil tidak lengkap",
        Archived: "Diarkib",
        ADD_MEMBER: "TAMBAH AHLI",
        EXPORT_ALL: "EKSPORT SEMUA",
        REVIEW_UPDATES: "SEMAK KEMASKINI",
        members_selected: "ahli dipilih",
        RE_ASSIGN_MANAGER: "TUGASKAN SEMULA PENGURUS",
        EDIT_TEAM: "EDIT PASUKAN",
        ADD: "TAMBAH",
        EDIT: "EDIT",
        ARCHIVE: "ARKIB",
        SEND_INVITE: "HANTAR JEMPUTAN",
        RE_ASSIGN: "TUGAS SEMULA",
        IGNORE: "ABAIKAN",
        Invited: "Dijemput",
        Active: "Aktif",
        Inactive: "Tidak Aktif",
        All: "Semua",
        New: "Baharu",
        Team: "Pasukan",
        Member: "Ahli",
        Assign_Team: "Tugaskan Pasukan",
        Assign_Manager: "Tugaskan Pengurus",
        Coins: "Coins",
        Gems: "Gems",
        Permission: "Kebenaran",
        Status: "Status",
        results_from: "keputusan daripada",
        results: "keputusan",
        coins: "coins",
        gems: "gems",
        years: "tahun",
        months: "bulan",
        days_ago: "hari lalu",
        joined_after: "menyertai selepas",
        Joined: "Menyertai",
        Daily_Streak: "Daily Streak",
        Achievements: "Pencapaian",
        Super_Feedback: "Super Feedback",
        Problem_Areas: "Bidang Bermasalah",
        MOST_RECENT: "TERKINI",
        Powers: "Powers",
        Badges: "Badges",
        Knowledge: "Pengetahuan",
        Initiative: "Inisiatif",
        Contributor: "Penyumbang",
        Leadership: "Kepimpinan",
        Health: "Kesihatan",
        Org: "Organisasi",
        Relationships: "Hubungan",
        Are_you_sure_would: "Adakah anda pasti untuk mengarkibkan ahli ini?",
        Once_archived_the_member: "Setelah diarkibkan, ahli akan dilog keluar secara automatik daripada Happily dan tidak akan dapat log masuk semula.",
        Archived_members_can_be: "Ahli yang diarkibkan boleh dipulihkan kemudian.",
        CANCEL: "BATAL",
        First_Name: "Nama Pertama",
        Last_Name: "Nama Keluarga",
        Email: "E-mel",
        Manager: "Pengurus",
        Select_a_Manager: "Pilih Pengurus",
        Select_a_Team: "Pilih Pasukan",
        will_be_created_as_a: "akan dicipta sebagai pasukan baharu",
        User_role: "Peranan pengguna",
        emoji_Member: "👩🏻 Ahli",
        Limited_Access: "Akses Terhad",
        emoji_Admin: "✍🏻  Admin",
        integrations: "Integrasi",
        Manage_Account_Email_Notifications: "Urus Akaun, Pemberitahuan E-mel",
        emoji_HR: "👩🏻‍💻  HR",
        Manage_Account_Insights: "Urus Akaun, Insights",
        emoji_Leader: "👩🏻‍💼 Leader",
        Insights_Medals: "Insights, Pingat",
        emoji_Super_Leader: "🦸🏻‍♀️ Super Leader",
        Manage_Account_Insights_Medals: "Urus Akaun, Insights, Pingat",
        emoji_Super_Admin: "🙆🏻‍♀️ Super Admin",
        Manage_Account_Insights_Email: "Urus Akaun, Insights, Pemberitahuan E-mel",
        Language: "Bahasa",
        Country: "Negara",
        English: "Inggeris",
        Thai: "Thai",
        BahasaMalay: "Bahasa Melayu",
        ChineseHK: "Cina (Tradisional, Hong Kong)",
        BrazilianPortuguese: "Portugis Brazil",
        Burmese: "Burma",
        SAVE_CHANGES: "SIMPAN",
        Automatically_send_an: "Hantar e-mel jemputan secara automatik kepada ahli baharu",
        Archive_employee: "Arkib pekerja",
        Archived_Type: "Jenis Arkib",
        Direct_Reports: "Laporan Terus",
        Re_Assign_Manager: "Tugaskan Semula Pengurus",
        Search_manager_name: "Cari nama pengurus",
        Suggestions_based_on_member: "Cadangan berdasarkan pemilihan ahli atau medan carian",
        SUBMIT: "HANTAR",
        Archived_Employee: "Pekerja Diarkib",
        Edit_Team: "Edit Pasukan",
        Edit_Manager: "Edit Pengurus",
        members: "ahli",
        Top_Most: "Teratas",
        UNARCHIVE: "NYAHARKIB",
        DELETE: "PADAM",
        delete_all: "padam semua",
        Unarchive: "Nyaharkib",
        Delete: "Padam",
        Search_team_name: "Cari nama pasukan",
        Complete_manager_assignment: ">Lengkapkan tugasan pengurus",
        is_missing_a_direct: "tidak mempunyai pengurus terus. Sila pilih pengurus untuk mengukuhkan rangkaian pengurusan.",
        SELECT_DIRECT_MANAGER: "PILIH PENGURUS TERUS",
        Re_assign_a_manager: "Tugaskan semula pengurus untuk menggantikan",
        the_archived_manager: "pengurus yang diarkibkan",
        has_been_archived_leaving: "telah diarkibkan, meninggalkan",
        members_without_a_direct: "ahli tanpa pengurus terus. Sila tugaskan semula pengurus untuk mengukuhkan rangkaian pengurusan.",
        Teams: "Pasukan",
        powers: "powers",
        CREATE_TEAM: "CIPTA PASUKAN",
        badges: "badges",
        Information: "Maklumat",
        Sort_by_Direct_Reports: "Susun ikut Laporan Terus",
        duplicate_teams: "pasukan pendua",
        Sort_by_Name: "Susun ikut Nama",
        ADD_TEAM: "TAMBAH PASUKAN",
        Sort_by_Parent: "Susun ikut Induk",
        Team_Manager: "Pengurus Pasukan",
        Parent_Team: "Pasukan Induk",
        Team_Name: "Nama Pasukan",
        Auto_assignment: "Tugasan Automatik",
        Color_Tag: "Tag Warna",
        A_unique_team_name: "Nama pasukan yang unik diperlukan",
        A_parent_team_and: "Pasukan induk dan pengurus akan ditugaskan secara automatik berdasarkan hubungan ahli pasukan dengan pengurus",
        Select_a_color_tag: "Pilih tag warna untuk menyusun pasukan anda secara visual, contohnya mengikut unit perniagaan/vertikal",
        No_team_members: "Tiada ahli pasukan",
        Managers: "Pengurus",
        Search: "Cari",
        managers_selected: "pengurus dipilih",
        Cohorts: "Kohort",
        CREATE: "CIPTA",
        duplicate_cohorts: "kohort pendua",
        ADD_COHORT: "TAMBAH KOHORT",
        Cohort_Name: "Nama Kohort",
        Select_Member: "Tambah ikut nama, e-mel, atau pasukan",
        Select_Leaders: "Tetapkan ketua ikut nama (pilihan)",
        Auto_generated: "Dijana Automatik",
        Bulk_add_by_inputing: "Tambah pukal dengan memasukkan alamat e-mel dipisahkan koma",
        Add_members_to_this: "Tambah ahli ke kohort ini",
        No_Cohort_members: "Tiada ahli Kohort",
        Cohort_Leader: "Ketua Kohort",
        Leader_description: "Ketua kohort menerima cerapan harian dan mingguan",
        Cohort_Type: "Jenis Kohort",
        Manual: "Manual",
        Dynamic: "Dinamik",
        Configure_Dynamic_Rules: "Konfigurasi Peraturan Dinamik",
        Dynamic_cohort_description: "Ahli akan ditambah atau dibuang secara automatik berdasarkan peraturan yang anda konfigurasi di bawah.",
        Preview: "Pratonton",
        Please_add_at_least_one_valid_rule: "Sila tambah sekurang-kurangnya satu peraturan sah untuk kohort dinamik.",
        Error_previewing_cohort: "Ralat semasa pratonton kohort. Sila cuba lagi.",
        No_members_match: "Tiada ahli yang sepadan dengan peraturan semasa",
        team_audit: {
            title: "Audit Hubungan Pasukan",
            teams_analyzed: "pasukan dianalisis",
            discrepancies_found: "percanggahan ditemui",
            analyzing: "Menganalisis hubungan pasukan...",
            all_valid: "Semua hubungan induk-anak pasukan adalah sah!",
            fix: "Baiki",
            manual_review_tooltip: "Tidak boleh dibaiki secara automatik - memerlukan semakan manual",
            manual_review: "Semakan Manual",
            team_manager: "Pengurus Pasukan",
            multiple_managers: "Pelbagai Pengurus",
            unassigned: "Belum Ditugaskan",
            managers_boss: "Bos Pengurus",
            no_boss_top_level: "Tiada Bos (Peringkat Atasan)",
            team_hierarchy: "Hierarki Pasukan",
            current_structure: "Struktur Semasa",
            recommended: "Disyorkan",
            no_parent_team: "Tiada pasukan induk",
            should_have_no_parent: "Sepatutnya tiada induk",
            new_badge: "BAHARU",
            fix_all_issues: "Baiki Semua Isu",
            rerun_audit: "Jalankan Audit Semula",
            failed_run: "Gagal menjalankan audit",
            fixed_relationship_for: "Hubungan induk dibaiki untuk",
            failed_fix: "Gagal membaiki",
            fixed_prefix: "Dibaiki",
            fixed_suffix: "hubungan pasukan",
            some_failed: "Sebahagian hubungan tidak dapat dibaiki",
        },
        search_by_name_or_team: "Cari ikut nama atau pasukan",
        preparing_org_chart_download: "Menyediakan carta organisasi untuk muat turun, sila tunggu...",
        cohorts: {
            main_conditions: "Syarat Utama",
            nested_group: "Kumpulan Bersarang",
            members_must_match: "Ahli mesti memenuhi",
            add_rules_or_groups_below: "Tambah peraturan atau kumpulan di bawah",
            add_rule: "Tambah Peraturan",
            add_group: "Tambah Kumpulan",
            select_attribute: "Pilih atribut",
            select_operator: "Pilih pengendali",
            select_value: "Pilih nilai",
            select_values: "Pilih nilai",
            type_to_search: "Taip untuk mencari",
            min: "Min",
            max: "Maks",
            and: "dan",
        },
        relationship_mapping: {
            outer_network: "Rangkaian Luar",
            inner_network: "Rangkaian Dalam",
        },
        profile: {
            view_personal_context: "Lihat Konteks Peribadi",
            download_photo: "Muat Turun Foto",
            personal_context_suffix: " — Konteks Peribadi",
            personal_context_subtitle: "Analisis daripada corak komunikasi dan maklum balas untuk memahami mereka secara lebih mendalam.",
            personal_values: "Nilai Peribadi",
            skills_competencies: "Kemahiran & Kompetensi",
            personality_communication: "Personaliti & Komunikasi",
            personality_traits: "CIRI PERSONALITI",
            communication_style: "GAYA KOMUNIKASI",
            role_focus: "Fokus Peranan",
            recent_challenges: "Cabaran Terkini",
            activity_timeline: "Garis Masa Aktiviti",
            loading_happiness_data: "Memuatkan data kegembiraan...",
            happiness_history_90d: "Sejarah Kegembiraan 90 Hari",
            recent_happiness_suffix: " — kegembiraan terkini",
            happy_label: "Gembira:",
            okay_label: "Okey:",
            not_great_label: "Kurang Baik:",
            recovery_progress: "Kemajuan Pemulihan",
            risk_flags_summary: "Ringkasan Penanda Risiko",
            recent_timeline_label: "Garis Masa Terkini (lama ke baharu):",
            no_response: "Tiada jawapan",
            happy: "Gembira",
            okay: "Okey",
            not_great: "Kurang Baik",
            hover_load_happiness: "Tuding untuk memuatkan data kegembiraan",
            happiness_icon_title: "Lihat perjalanan kegembiraan 90 hari dengan cerapan risiko & pemulihan",
            star_performance_tooltip: "Prestasi cemerlang kerana berada dalam 15% teratas yang menerima pengiktirafan minggu itu",
            no_recent_data: "Tiada data terkini",
            top_skills: "Kemahiran Teratas",
            top_skills_subtitle: "pengesahan maklum balas rakan sebaya yang unik",
            culture_add: "Sumbangan Budaya",
            culture_add_subtitle: "sumbangan kepada pengiktirafan #values",
            view_all: "Lihat Semua",
            recognition_given: "Pengiktirafan Diberi",
            recognition_received: "Pengiktirafan Diterima",
            give_to_receive_ratio: "Nisbah Beri-kepada-Terima",
            alignment_rating_score: "Skor Penarafan Penjajaran",
            is_a_top: "ialah antara teratas",
            culture_add_contributor_suffix: "% penyumbang budaya",
        },
    },
    pincode: {
        your_verification: "Pengesahan anda",
        enter_the_four: "Masukkan kod 4 digit yang dihantar ke peti masuk anda",
        your_code_is: "Kod anda salah. Sila cuba lagi…",
        you_have: "Anda ada",
        attempts_remaining: "percubaan berbaki",
    },
    powerUp: {
        EXPORT: "EKSPORT",
        Recognition_trends: "Trend pengiktirafan",
        PARTICIPATION_RATE: "KADAR PENYERTAAN",
        No_Filter: "Tiada Tapisan",
        Select_all: "Pilih Semua",
        Clear: "Kosongkan",
        Filter_power_up: "Tapis aktiviti power-up berdasarkan nilai pengiktirafan",
        Cancel: "Batal",
        Okay: "Okay",
        results_from: "hasil daripada",
        results: "hasil",
        Export_Power_up_Activity: "Eksport Aktiviti Power-up",
        Date_Range: "Pilih Tarikh Mula dan Tamat",
        Start_Date: "Tarikh Mula",
        End_Date: "Tarikh Tamat",
        Recipient: "Penerima",
        From: "Daripada",
        For: "Untuk",
        Reward: "Ganjaran",
        Sent_on: "Dihantar pada",
        Automations: "Automasi",
        Preset_Library: "Pustaka Preset",
        By_Month: "Mengikut Bulan",
        Automate: "Automasikan",
        By_Quarter: "Mengikut Suku",
        By_Year: "Mengikut Tahun",
        Create_your_own: "Cipta sendiri",
        Recognition: "Pengiktirafan",
        Power_up_Recipients: "Penerima Power-up",
        based_on_your_selection: "berdasarkan pilihan anda",
        Preview_on_Mobile_Layout: "Pratonton pada Paparan Mobile",
        got: "dapat",
        for: "untuk",
        This_power_up_automation_has: "Automasi power-up ini belum diaktifkan",
        This_power_up_automation_has_been: "Automasi power-up ini telah diaktifkan",
        Recipients: "Penerima",
        recipients: "penerima",
        Autogenerated: "Dijana Automatik",
        for_showing_time_period: "untuk memaparkan tempoh masa",
        Add: "Tambah",
        Values_optional: "Nilai (pilihan)",
        Select_values_optional: "Pilih nilai (pilihan)",
        Schedule: "Jadual",
        Following_work_day: "Hari bekerja berikutnya",
        Time: "Masa",
        Select_time: "Pilih masa",
        Now: "Sekarang",
        Name_of_Recipient: "Nama Penerima",
        Name_of_Recipient_s: "Nama Penerima",
        Reason_for_recognition: "Sebab pengiktirafan",
        Reward_Type: "Jenis Ganjaran",
        Medal_Design: "Reka Bentuk Pingat",
        Coin_Medal_or_Gem: "Coins, Pingat atau Gems",
        Amount: "Jumlah",
        Number_of_coins: "Bilangan coins",
        Number_of_gems: "Bilangan gems",
        Share_on_Activity_Feed: "Kongsi di Activity Feed",
        SAVE_CHANGES: "SIMPAN",
        DE_ACTIVATE_AUTOMATION: "NYAHAKTIFKAN AUTOMASI",
        ACTIVATE_AUTOMATION: "AKTIFKAN AUTOMASI",
        SEND: "HANTAR",
        RESET: "SET SEMULA",
        Duplicate: "Salin",
        Delete: "Padam",
        performance: {
            select_teams: "Pilih Pasukan",
            select_time_period: "Pilih Tempoh Masa",
            performance_presets: "Preset Prestasi",
            performance_tracker: "Penjejak Prestasi",
            boosts_status: "Status Boosts",
            culture_add: "Culture Add",
            goal_progress: "Kemajuan Matlamat",
            active_filter: "Tapisan Aktif",
            clear_filter: "Kosongkan Tapisan",
            export: "Eksport",
            no_matching_results: "Tiada hasil yang sepadan",
            no_matching_results_desc: "Kami tidak menemui data yang sepadan dengan tapisan semasa anda.",
            try_one_of_these: "Cuba salah satu daripada ini:",
            clear_all_filters: "Kosongkan Semua Tapisan",
            manager: "Pengurus",
            boosts_on_track: "Boosts Mengikut Jadual",
            both: "Kedua-dua",
            team_member: "Ahli Pasukan",
            goal_follow_up: "Susulan Matlamat",
            per_goal_ratings: "Penarafan Setiap Matlamat",
            culture_follow_up: "Susulan Budaya",
            preset_name: "Nama Preset",
            review_questions: "Soalan Semakan",
            goal_performance: "Prestasi Matlamat",
            culture_contribution: "Sumbangan Budaya",
            scheduling: "Penjadualan",
            next_review_period: "Tempoh Semakan Seterusnya",
            assignments: "Tugasan",
            assign_to_teams: "Tugaskan kepada Pasukan",
            assign_members: "Tugaskan Ahli",
            boost_preview: "Pratonton Boost",
        },
        activity: {
            total_recognition: "Jumlah Pengiktirafan",
            value_aligned: "Selari Nilai",
            pct_value_aligned: "% Selari Nilai",
            participation_rate: "Kadar Penyertaan",
            recognition_trends: "Trend pengiktirafan",
            last_12_months: "12 bulan lepas",
            total: "Jumlah",
            values_aligned_hash: "#Selari-Nilai",
            values_heatmap: "Heatmap Nilai",
            show_all: "Lihat Semua",
            use: "Guna",
            window: "tetingkap",
            values: "Nilai",
            recognition_trends_data: "Data Trend Pengiktirafan",
            month: "Bulan",
            values_aligned: "Selari Nilai",
            pct_values_aligned: "% Selari Nilai",
            export_csv: "Eksport CSV",
        },
        outbox_multiple: "Berbilang",
        leaderboards: {
            all_recognition: "Semua Pengiktirafan",
            recognition_metrics: "Metrik Pengiktirafan",
            recognition_metrics_sub: "Aktiviti pengiktirafan antara rakan",
            most_recognition_given: "Paling Banyak Memberi Pengiktirafan",
            most_recognition_given_sub: "Pemberi pengiktirafan rakan tertinggi",
            most_recognition_received: "Paling Banyak Menerima Pengiktirafan",
            most_recognition_received_sub: "Penerima pengiktirafan rakan tertinggi",
            give_receive_ratio: "Nisbah Beri-Terima Tertinggi",
            give_receive_ratio_sub: "Paling banyak memberi pengiktirafan berbanding menerima",
            alignment_metrics: "Metrik Keselarasan",
            alignment_metrics_sub: "Prestasi keselarasan dengan nilai",
            alignment_given: "Keselarasan Terkuat Diberi",
            alignment_given_sub: "Paling berkesan mengukuhkan nilai anda",
            alignment_received: "Keselarasan Terkuat Diterima",
            alignment_received_sub: "Tindakan paling selari dengan nilai anda",
            alignment_overall: "Keselarasan Terkuat Keseluruhan",
            alignment_overall_sub: "Duta budaya & nilai teratas",
            see_full_list: "Lihat senarai penuh",
        },
    },
    questions: {
        add_a_question: "Tambah Soalan",
        preview_of_daily: "Pratonton Cerapan Harian untuk Pengurus",
        summary_of_insights: "Ringkasan cerapan daripada laporan terus anda",
        of_ten_direct: "daripada 10 laporan terus",
        responded: "menjawab",
        yes: "ya",
        average_rating_out: "purata penarafan daripada 10",
        english: "English",
        thai: "Thai",
        add_option: "Tambah Pilihan",
        open_ended: "Terbuka",
        yes_or_no: "Ya/Tidak",
        multiple_choice: "Pelbagai Pilihan",
        question: "Soalan",
        option: "Pilihan",
        positive: "Positif",
        neutral: "Neutral",
        negative: "Negatif",
        min_label: "Label Min.",
        max_label: "Label Maks.",
        reward: "Ganjaran",
        power_skill: "Power Skill",
        frequency: "Kekerapan",
        day_of_week: "Hari dalam Minggu",
        schedule: "Jadual",
        please_select_frequency: "Sila pilih kekerapan",
        and_when: "dan bila?",
        more: "lagi",
        assign_a_sentiment: "Tetapkan Sentimen",
        coins: "Coins",
        select_power_skill: "Pilih power skill (pilihan)",
        how_often_do: "Berapa kerap anda mahu bertanya soalan ini?",
        what_day_of: "Pada hari apa anda mahu bertanya soalan ini?",
        CALENDAR_VIEW: "Paparan Kalendar",
        Audience: "Audiens",
        Active: "Aktif",
        Inactive: "Tidak Aktif",
        Show_All: "Lihat Semua",
        View: "Lihat",
        Preview_of_Daily_Insights: "Pratonton Cerapan Harian untuk Pengurus",
        Summary_of_insights_from: "Ringkasan cerapan daripada laporan terus anda",
        of_ten_direct_reports: "daripada 10 laporan terus",
        responded_Yes: "menjawab “Ya”",
        average_rating_out_of: "purata penarafan daripada 10",
        of_fifty_overal: "daripada 50 keseluruhan",
        English: "English",
        Thai: "Thai",
        Positive: "Positif",
        Neutral: "Neutral",
        Negative: "Negatif",
        Add_Option: "Tambah Pilihan",
        Min_label: "Label Min.",
        Max_label: "Label Maks.",
        Reward: "Ganjaran",
        Power_Skill: "Power Skill",
        Select_power_skill: "Pilih power skill (pilihan)",
        Day_of_Week: "Hari dalam Minggu",
        Please_select_frequency: "Sila pilih kekerapan",
        Schedule: "Jadual",
        Type: "Jenis",
        Select_Dimension: "Pilih Dimensi",
        Question_Format: "Format Soalan",
        Open_ended: "Terbuka",
        Yes_or_No: "Ya/Tidak",
        Multiple_Choice: "Pelbagai Pilihan",
        Scale: "Skala",
        Question: "Soalan",
        Option: "Pilihan",
        Frequency: "Kekerapan",
        Very_important: "Sangat penting",
        Coins: "Coins",
        Status: "Status",
        Action: "Tindakan",
        How_often__you: "Berapa kerap anda mahu bertanya soalan ini?",
        What_day_of_week: "Pada hari apa anda mahu bertanya soalan ini?",
        Not_at_all: "Tidak sama sekali",
        QUESTION_DETAILS: "BUTIRAN SOALAN",
        Search: "Cari",
        Assign_a_Sentiment: "Tetapkan Sentimen",
        Category: "Kategori",
        Row_Header: "Tajuk Baris",
        Row_Header_Placeholder: "Tajuk yang mewakili cerapan daripada soalan ini",
        preview_for_managers: "Pratonton untuk pengurus",
        email_subject_today: "Cerapan pasukan anda untuk hari ini",
        today: "Hari Ini",
        three_insights: "3 cerapan",
        email_intro_shared: "Inilah perkara yang pasukan anda kongsi hari ini.",
        caption_of_four_direct: "daripada 4 laporan terus",
        caption_of_fourteen_overall: "daripada 14 keseluruhan",
        responded_word: "menjawab",
        view_details: "lihat butiran",
        sample_response_placeholder: "Contoh jawapan daripada ahli pasukan akan muncul di sini apabila jawapan diterima.",
        youve_replied: "Anda telah membalas",
        view_full_daily_report: "Lihat laporan harian penuh",
        generate_placeholder: "Saya mahu memahami sejauh mana orang memahami nilai #excellence kami",
        generate_question: "Jana Soalan",
        send_to: "Hantar kepada",
        follow_up: "Susulan",
        program_only: "Program only",
        response_settings: "Tetapan Jawapan",
        rolling_response: "Jawapan Berterusan",
        rolling_response_tooltip: "Kekalkan sehingga kejadian soalan berikutnya, menghantarnya sehingga jawapan diberikan",
        submit_responses_to_managers: "Hantar Jawapan kepada Pengurus",
        private_feedback_mode: "Mod Maklum Balas Peribadi",
        private_feedback_hint: "Jawapan disembunyikan daripada pengurus dan hanya boleh dilihat sebagai maklum balas tanpa nama",
        report_card_analytics: "Analitik Report Card",
        include_in_report_card: "Sertakan dalam Insights → Report Card",
        include_in_culture_index: "Sertakan dalam Culture Index",
        culture_index_tooltip: "Sertakan soalan ini dalam pengiraan Culture Index yang ditunjukkan pada Papan Pemuka Cerapan",
        refreshing: "Menyegarkan...",
        refresh_calendar_title: "Segar semula kalendar dan pilih hari ini",
        legend_heavy_load: "Beban berat (>5 soalan)",
        legend_light_load: "Beban ringan (<4 soalan)",
        legend_open_ended_questions: "Soalan terbuka",
        dimension: "Dimensi",
        delivery: "Penghantaran",
        essential_question_tooltip: "Ini ialah soalan penting untuk analitik dan laporan kami. Ia boleh dinyahaktifkan dalam paparan Senarai Soalan tetapi memerlukan pengesahan.",
        toggle_off_tooltip: "Matikan untuk membuang soalan ini daripada set soalan harian (akan menjejaskan yang berulang)",
        bi_weekly: "Dua minggu sekali",
        question_recipients: "Penerima Soalan",
        team_label: "Pasukan",
        includes_child_teams: "Termasuk jawapan daripada pasukan kecil",
        all_teams: "Semua Pasukan",
        filter_by_team: "Tapis Mengikut Pasukan",
        search_teams_placeholder: "Cari pasukan...",
        no_teams_found: "Tiada pasukan ditemui",
        combined_responses_prefix: "Memaparkan jawapan gabungan daripada",
        combined_responses_suffix: "dan sub-pasukannya",
        no_responses_available: "Tiada jawapan tersedia",
        no_responses_for_team: "Tiada jawapan tersedia untuk pasukan yang dipilih",
        summary: "Ringkasan",
        ai_generated_note: "Dijana oleh AI daripada maklum balas yang dikongsi dalam tempoh 3 bulan dari tarikh yang dipilih",
        responses_label: "jawapan",
        add_follow_up_question: "Tambah Soalan Susulan",
        select_placeholder: "Pilih",
        SUBMIT: "HANTAR",
        toast_include_row_header: "Sila sertakan Tajuk Baris untuk soalan anda",
        toast_input_option_prefix: "Sila masukkan Pilihan",
        toast_include_version_prefix: "Sila sertakan versi",
        toast_include_version_suffix: "untuk soalan anda",
        toast_select_dimension: "Sila pilih Dimensi",
        toast_select_question_format: "Sila pilih Format Soalan",
        toast_input_coins: "Sila masukkan Coins",
        toast_select_frequency: "Sila pilih Kekerapan",
        toast_select_day_of_week: "Sila pilih Hari dalam Minggu",
        toast_select_schedule: "Sila pilih Jadual",
        toast_custom_question_created: "Soalan tersuai anda telah dicipta",
        question_saved: "Soalan disimpan",
        saved_follow_up_question: "Soalan susulan disimpan",
        saved_question_calendar_hint: "Kalendar telah dikemas kini dengan soalan ini. Anda boleh semak di mana ia akan muncul, tambah soalan lain, atau tutup tetingkap ini.",
        saved_follow_up_question_hint: "Ini disimpan sebagai soalan susulan, jadi ia akan muncul apabila dipautkan daripada pilihan jawapan induk dan bukan pada kalendar.",
        saved_program_only_question: "Program-only question saved",
        saved_program_only_question_hint: "This was saved as a program-only question, so it will only fire when a program references it — not on the calendar.",
        view_in_calendar: "Lihat dalam Kalendar",
        add_another_question: "Tambah soalan lain",
        done: "Selesai",
        saving_question: "Menyimpan...",
        toast_custom_question_create_failed: "Kami tidak dapat menyimpan soalan ini. Sila cuba lagi.",
        toast_open_calendar_failed: "Kami tidak dapat membuka kalendar untuk soalan ini. Sila cuba lagi.",
        every: "Setiap",
        of_each_month: "setiap bulan",
        first: "Pertama",
        second: "Kedua",
        third: "Ketiga",
        fourth: "Keempat",
        fifth: "Kelima",
        toast_yes_no_assignment_required: "Soalan Ya atau Tidak mesti mempunyai tetapan Positif & Negatif untuk pilihan \"Ya\" atau \"Tidak\" ATAU tetapan Neutral untuk kedua-dua pilihan.",
        toast_multi_choice_assignment_required: "Soalan pelbagai pilihan mesti mempunyai sekurang-kurangnya satu tetapan Positif & satu Negatif ATAU tetapan Neutral untuk semua pilihan.",
        toast_input_min_max_label: "Sila masukkan Label min/maks",
    },
    register: {
        get_started_with: "Mulakan dengan Happily",
        set_up_one: "Sediakan 1 pasukan",
        FREE: "PERCUMA",
        BOOK_A_TIME: "TEMPAH MASA",
        set_up_a: "Sediakan percubaan percuma 21 hari untuk satu pasukan dengan",
        up_to_twenty: "sehingga 20 pengguna",
        set_up_many: "Sediakan banyak pasukan",
        schedule_a_one: "Jadualkan sesi 1:1 dengan",
        team_who_will: "pasukan kami yang akan memastikan anda mendapat",
        the_most_out: "manfaat paling banyak daripada Happily",
        Setting_up_your: "Menyediakan akaun anda",
        help_us_get: "Bantu kami mengenali anda dan syarikat anda dengan lebih baik",
        your_name: "Nama Anda",
        please_input_your_name: "Sila masukkan nama anda",
        your_work_email: "E-mel kerja anda",
        please_input_your_work: "Sila masukkan e-mel kerja anda",
        please_input_correct_email: "Sila masukkan e-mel yang betul",
        your_phone_number: "Nombor telefon anda",
        please_input_your_phone: "Sila masukkan nombor telefon anda",
        please_input_only_number: "Sila masukkan nombor sahaja",
        company_name: "Nama Syarikat",
        please_input_company: "Sila masukkan nama syarikat",
        Location: "Lokasi",
        please_input_Location: "Sila masukkan lokasi",
        Time_Zone: "Zon Masa",
        please_input_Time_Zonen: "Sila masukkan zon masa",
        language_preference: "Pilihan Bahasa",
        how_many_people: "Berapa ramai orang",
        please_input_number_of: "Sila masukkan bilangan pekerja",
        please_input_language: "Sila masukkan pilihan bahasa",
        what_would_you_like: "Apa yang anda ingin capai dengan Happily",
        please_input_your_achieve: "Sila masukkan pencapaian anda",
        i_agree_to: "Saya bersetuju dengan",
        terms_and_conditions: "Terma & Syarat",
        verify_my_email: "Sahkan e-mel saya",
        confirm_your_email: "Sahkan e-mel anda",
        we_sent_you: "Kami telah menghantar kod pengesahan e-mel kepada anda ke ",
        the_email_may: "E-mel mungkin mengambil masa 15-20 saat untuk sampai kepada anda dan akan tamat tempoh dalam 15 minit akan datang",
        resend_code: "Hantar Semula Kod",
        go_back: "Kembali",
        book_a_meeting: "Tempah Mesyuarat",
        i_want_to: "Saya mahu mencipta tempat kerja yang lebih gembira.",
        Schedule_a_time_with: "Jadualkan masa dengan kami",
        Setting_up_multiple_teams: "Menyediakan berbilang pasukan akan lebih mudah melalui proses import yang boleh dibimbing oleh pasukan kami. Tempah mesyuarat dengan kami dan kami akan menghubungi anda kembali (biasanya dalam satu jam, sehingga 24 jam) untuk membantu anda bermula dengan cepat!",
    },
    reports: {
        DAILY_REPORT_PREVIEW: "PRATONTON LAPORAN HARIAN",
        Select_a_Manager: "Pilih Pengurus",
        Select_date: "Pilih tarikh",
        Delivery_Status: "Status Penghantaran",
        Undelivered: "Belum Dihantar",
        Delivered: "Dihantar",
        Issue: "Isu",
        Read_Status: "Status Dibaca",
        Preview_a_report_by: "Pratonton laporan dengan memilih pengurus dan tarikh",
        from_the_above_menu: "dari menu di atas",
        Loading: "Memuatkan",
        Unable_to_preview_this: "Tidak dapat memaparkan laporan ini kerana data tidak mencukupi",
        MONTHLY_REPORT_PREVIEW: "PRATONTON LAPORAN BULANAN",
        Select_a_Person: "Pilih Seseorang",
        Select_month: "Pilih bulan",
        WEEKLY_REPORT_PREVIEW: "PRATONTON LAPORAN MINGGUAN",
        quarterly: {
            main: {
                report_generator: "Penjana Laporan",
                scope_label: "Skop",
                scope_placeholder: "Pilih Skop",
                company_wide: "Seluruh Syarikat",
                quarter_label: "Suku",
                quarter_placeholder: "Pilih Suku",
                generate_report: "Jana Laporan",
                generating: "Menjana...",
                loading_title: "Menjana Laporan Anda",
                empty_title: "Cipta Persembahan Slaid",
                empty_text: "Pilih skop dan suku di atas, kemudian klik Jana Laporan untuk mencipta dek slaid eksekutif.",
                generated_reports: "Laporan Dijana",
                search_placeholder: "Cari laporan...",
                loading_reports: "Memuatkan laporan...",
                col_report_name: "Nama Laporan",
                col_quarter: "Suku",
                col_created: "Dicipta",
                col_updated: "Dikemaskini",
                col_actions: "Tindakan",
                view: "Lihat",
                regenerate: "Jana Semula",
                delete: "Padam",
                no_search_results: "Tiada laporan sepadan dengan carian anda.",
                no_reports_yet: "Belum ada laporan dijana. Cipta satu di atas!",
                back_to_config: "Kembali ke Konfigurasi",
                pdf_title: "Menyediakan PDF Anda",
                pdf_tip: "Ini mungkin mengambil masa untuk laporan besar",
            },
            controls: {
                previous_slide: "Slaid sebelumnya",
                next_slide: "Slaid seterusnya",
                go_to_slide: "Pergi ke slaid",
                generating_pdf: "Menjana PDF...",
                download_pdf: "Muat Turun sebagai PDF",
                enter_fullscreen: "Masuk skrin penuh",
                exit_fullscreen: "Keluar skrin penuh",
            },
            viewer: {
                navigate: "Navigasi",
                fullscreen: "Skrin Penuh",
                exit: "Keluar",
            },
            title_cover: {
                badge: "PENGLIBATAN PEKERJA",
                title: "Laporan Suku Tahunan",
            },
            closing: {
                contact_label: "Soalan atau maklum balas?",
                contact_text: "Hubungi pasukan HR anda",
                next_steps: "LANGKAH SETERUSNYA",
                generated: "Dijana",
            },
            key_metric: {
                vs_last_quarter: "vs suku lalu",
            },
            highlights: {
                strengths_title: "Kekuatan",
                strengths_subtitle: "Bidang yang berprestasi baik",
                challenges_title: "Cabaran",
                challenges_subtitle: "Bidang yang memerlukan perhatian",
                priorities_title: "Keutamaan",
                priorities_subtitle: "Bidang fokus yang disyorkan",
                empty_strengths: "Tiada kekuatan dikenal pasti",
                empty_challenges: "Tiada cabaran dikenal pasti",
                empty_priorities: "Tiada keutamaan dikenal pasti",
            },
            chart_callouts: {
                key_insights: "CERAPAN UTAMA",
                improvements: "Penambahbaikan",
                areas_of_concern: "Bidang Membimbangkan",
            },
            focus_alignment: {
                default_title: "Fokus ikut Matlamat",
                default_subtitle: "Cara pasukan menjajarkan fokus dengan matlamat organisasi",
                items: "item",
                done: "selesai",
                open: "terbuka",
                people: "orang",
                unmatched_items: "Item Tidak Sepadan",
                not_linked: "Tidak dipautkan ke mana-mana matlamat",
                consider_linking: "Pertimbangkan untuk memautkan ini ke matlamat",
                unknown_items: "Penjajaran Tidak Diketahui",
                no_goals_set: "Tiada matlamat ditetapkan untuk skop ini",
                set_goals_to_assess: "Tetapkan matlamat untuk menilai penjajaran",
                empty_text: "Tiada matlamat dengan fokus aktif suku ini",
            },
            goal_distribution: {
                items: "item",
                done_suffix: "% selesai",
                legend_completed: "Selesai",
                legend_in_progress: "Dalam Proses",
                empty_text: "Tiada matlamat dengan fokus aktif suku ini",
            },
            leaderboard: {
                empty_text: "Tiada data tersedia untuk tempoh ini",
            },
            question_scores: {
                legend_excellent: "70%+ Cemerlang",
                legend_moderate: "50-69% Sederhana",
                legend_attention: "<50% Perlu Perhatian",
            },
            recommendations: {
                ai_badge: "CERAPAN DIKUASAKAN AI",
                default_title: "Cadangan Utama",
                default_subtitle: "Tindakan strategik untuk memacu penglibatan dan prestasi",
                high_priority: "KEUTAMAAN TINGGI",
                medium: "SEDERHANA",
                low: "RENDAH",
                high_impact: "Impak Tinggi",
                generated_by: "Dijana oleh Happily.ai",
            },
            who5: {
                label_poor: "Lemah",
                label_good: "Baik",
                legend_0: "0 - Tidak pernah",
                legend_1: "1 - Sesetengah masa",
                legend_2: "2 - Kurang separuh",
                legend_3: "3 - Lebih separuh",
                legend_4: "4 - Kebanyakan masa",
                legend_5: "5 - Sepanjang masa",
            },
        },
    },
    rewards: {
        redeemed: "Ditebus",
        add_a_reward: "Tambah Ganjaran",
        active: "Aktif",
        inactive: "Tidak Aktif",
        show_all: "Lihat Semua",
        status: "Status",
        coins: "Coins",
        gems: "Gems",
        edit: "Edit",
        Reward: "Ganjaran",
        Activity: "Aktiviti",
        preview_on_mobile: "Pratonton pada Paparan Mobile",
        REDEEM: "TEBUS",
        REQUEST: "MINTA",
        english: "English",
        thai: "Thai",
        name: "Nama",
        name_of_reward: "Nama Ganjaran",
        mame_of_reward_Thai: "Nama Ganjaran (Thai)",
        description: "Keterangan",
        description_Thai: "Keterangan (Thai)",
        cost: "Kos",
        duration: "Tempoh",
        start_date: "Tarikh Mula",
        end_date: "Tarikh Tamat",
        gift_cards: "Kad Hadiah",
        perks: "Faedah",
        team_building: "Team Building",
        doing_good: "Buat Kebaikan",
        settings: "Tetapan",
        country: "Negara",
        all_countries: "Semua Negara",
        limited_qty: "Kuantiti Terhad",
        available: "Tersedia",
        no_limit: "Tiada had",
        Require_Approval: "Memerlukan Kelulusan",
        On: "Hidup",
        Off: "Mati",
        image: "Imej",
        upload: "Muat Naik",
        file_size_should: "Saiz fail hendaklah 600 x 320 px. Lakaran ganjaran dijana automatik kepada petak tengah.",
        reward: "Ganjaran",
        processing: "Memproses",
        sent: "Dihantar",
        cancel: "Batal",
        confirm_cancellation: "Sahkan Pembatalan",
        are_you_sure: "Adakah anda pasti mahu membatalkan",
        redeemed_by: "ditebus oleh (Dihadiahkan kepada)",
        Recipient: "Penerima",
        Value: "Nilai",
        Type: "Jenis",
        Date_and_Time: "Tarikh dan Masa",
        Delivered: "Dihantar",
        no: "Tidak",
        yes_and_refund: "Ya & Bayar Balik",
        yes_and_do: "Ya & Jangan Bayar Balik",
        refund: "Batal & Bayar Balik",
        all_countries_label: "Semua Negara",
        member_countries_only: "Negara Ahli Sahaja",
        enabled: "Didayakan",
        disabled: "Dilumpuhkan",
        show_all_status: "Lihat Semua Status",
        bulk_update_rates: "Kemaskini Kadar Secara Pukal",
        bulk_update_coin_rates: "Kemaskini Kadar Coins Secara Pukal",
        gem_exchange: "Gem Exchange",
        gem_exchange_editor: {
            title: "Gem Exchange",
            subtitle: "Benarkan pekerja menukar gems kepada coins.",
            enabled: "Didayakan",
            disabled: "Dilumpuhkan",
            shared_metadata: "Metadata dikongsi",
            display_name: "Nama paparan",
            display_name_hint: "Dijana automatik — edit untuk menyesuaikan.",
            image: "Imej",
            image_default_hint: "Menggunakan lalai — muat naik untuk menyesuaikan.",
            upload_image: "Muat naik imej",
            replace_image: "Gantikan imej",
            use_default: "Guna lalai",
            image_hint: "JPG atau PNG, maksimum 2MB.",
            duration: "Tempoh",
            templates: "Templat",
            templates_hint_prefix: "Guna",
            templates_hint_and: "dan",
            templates_hint_suffix: "untuk memasukkan nilai tier.",
            exchange_tiers: "Tier pertukaran",
            exchange_tiers_hint: "Setiap tier menjadi satu ganjaran dalam tab Faedah.",
            col_gems: "Gems",
            col_coins: "Coins",
            col_rate: "Kadar",
            per_gem: "setiap gem",
            best_value: "Nilai terbaik",
            add_another_tier: "Tambah tier lain",
            employee_preview: "Pratonton pekerja",
            employee_preview_hint: "Bagaimana tier 1 kelihatan semasa penebusan.",
            save_changes: "Simpan",
        },
        tiers_active: "tier aktif",
        tier_active: "tier aktif",
        no_tiers_yet: "Belum ada tier",
        off: "Mati",
        gem_exchange_on_add_tiers: "Gem Exchange dihidupkan. Tambah tier untuk membolehkan pekerja menebus.",
        gem_exchange_intro: "Benarkan pekerja menukar gems kepada coins dengan tier yang boleh dikonfigurasikan.",
        edit_tiers: "Edit tier",
        configure_arrow: "Konfigurasi →",
        set_up_arrow: "Sediakan →",
        new_badge: "BARU",
        expired_badge: "TAMAT TEMPOH",
        managed: "Diurus",
        managed_by_gem_exchange: "Diurus oleh Gem Exchange",
        edit_a_reward: "Edit Ganjaran",
        linked_gem_variant: {
            create_title: "Cipta versi gem", edit_title: "Edit versi gem",
            subtitle: "Tambah harga gem sambil mengekalkan versi syiling.",
            provider_linked: "Dipautkan kepada pembekal", coin_version_kept: "Versi syiling kekal aktif", gem_version: "Versi gem",
            gem_cost: "Kos gem", gem_cost_placeholder: "Masukkan gem yang diperlukan",
            gem_cost_help: "Ahli menggunakan gem. Pengebilan masih menggunakan nilai kad dan pembekal asal.",
            create_action: "Cipta versi gem", add_action: "Tambah versi gem", edit_action: "Edit versi gem",
            keep_coin_help: "Versi syiling sedia ada kekal tersedia.", created: "Versi gem dicipta. Versi syiling tidak berubah.", updated: "Versi gem dikemas kini.", save_failed: "Versi gem tidak dapat disimpan.",
            errors: {
                missing_source_reward: "Ganjaran syarikat tidak ditemui.", missing_master_reward: "Ganjaran pembekal asal tidak ditemui.",
                invalid_gem_cost: "Masukkan kos gem dalam nombor bulat yang lebih besar daripada sifar.", inactive_master_reward: "Ganjaran pembekal asal tidak aktif.",
                missing_reward_name: "Ganjaran asal tiada nama.", missing_reward_type: "Ganjaran asal tiada jenis pemenuhan.",
                missing_face_value: "Ganjaran asal tiada nilai boleh bil.", missing_reward_currency: "Ganjaran asal tiada mata wang.",
                missing_provider_product_id: "ID produk pembekal tiada.", unable_to_create_variant_id: "ID ganjaran selamat tidak dapat dicipta."
            }
        },
        type_placeholder: "Jenis",
        reward_activity: "Aktiviti Ganjaran",
        reward_activity_view: "Paparan aktiviti ganjaran",
        loading_activity: "Memuatkan aktiviti ganjaran",
        updating_activity: "Mengemas kini aktiviti…",
        loading_activity_hint: "Julat tarikh yang panjang mungkin mengambil sedikit masa. Anda boleh menutup tetingkap ini sementara data dimuatkan.",
        activity_load_error: "Aktiviti ganjaran tidak dapat dimuatkan",
        activity_load_error_hint: "Sila semak sambungan anda dan cuba lagi. Data ganjaran anda tidak diubah.",
        activity_empty: "Tiada aktiviti ganjaran untuk tempoh ini.",
        delivered: "Dihantar",
        recipients: "Penerima",
        members: "Ahli",
        pending: "Belum Selesai",
        transactions: "Transaksi",
        member_spend: "Perbelanjaan ahli",
        member: "Ahli",
        redeemed_by_member: "Ditebus oleh",
        redemptions: "Penebusan",
        reward_spend: "Perbelanjaan ganjaran",
        share_of_currency_spend: "Bahagian perbelanjaan mata wang",
        last_activity: "Aktiviti terakhir",
        member_spend_hint: "Perbelanjaan ganjaran yang dihantar dikaitkan dengan ahli yang menebusnya, termasuk hadiah untuk orang lain.",
        member_spend_empty: "Tiada perbelanjaan ganjaran yang dihantar untuk tempoh ini.",
        currency_totals_separate: "Mata wang diasingkan supaya jumlah kekal tepat.",
        currency_count: "{count} mata wang",
        delivered_reward_spend: "Perbelanjaan ganjaran yang dihantar",
        delivered_reward_spend_period: "Perbelanjaan ganjaran yang dihantar · {period}",
        custom_date_range: "Julat Tarikh Tersuai",
        export: "Eksport",
        value: "Nilai",
        type: "Jenis",
        date_and_time: "Tarikh & Masa",
        date_range: "Julat Tarikh",
        to: "Hingga",
        start_date_placeholder: "Tarikh mula",
        end_date_placeholder: "Tarikh tamat",
        confirm_and_filter: "Sahkan & Tapis",
        currency: "Mata Wang",
        select_currency: "Pilih mata wang",
        current_rate: "Kadar Semasa",
        new_rate: "Kadar Baharu",
        preview_changes: "Pratonton Perubahan",
        show_only_changes: "Tunjukkan perubahan sahaja",
        reward_name: "Nama Ganjaran",
        current: "Semasa",
        new_coins: "Coins Baharu",
        change: "Perubahan",
        no_rewards_for_currency: "Tiada ganjaran ditemui untuk mata wang yang dipilih.",
        select_currency_hint: "Pilih mata wang untuk melihat dan mengemaskini ganjaran.",
        apply: "Guna",
        changes_suffix: "Perubahan",
        change_singular: "Perubahan",
        of: "daripada",
        toast_managed_by_gem_exchange: "Diurus oleh Gem Exchange — guna Edit tier untuk dayakan/lumpuhkan.",
        toast_confirm_activate: "Adakah anda pasti mahu mengaktifkan ganjaran ini?",
        toast_reward_activated: "Ganjaran diaktifkan",
        toast_canceled: "Dibatalkan",
        toast_confirm_disable: "Adakah anda pasti mahu melumpuhkan ganjaran ini?",
        toast_reward_disabled: "Ganjaran dilumpuhkan",
        toast_select_valid_date_range: "Sila pilih julat tarikh yang sah",
        toast_confirm_cancel_transaction: "Adakah anda pasti mahu membatalkan transaksi ganjaran ini?",
        toast_transaction_canceled: "Ganjaran berjaya dibatalkan",
        toast_coins_gems_refunded_prefix: "Coins atau gems akan dibayar balik kepada",
        toast_confirm_status_change: "Adakah anda pasti mahu mengubah status item?",
        toast_status_updated: "Status dikemaskini",
        toast_select_image: "Sila pilih imej",
        toast_confirm_delete: "Adakah anda pasti mahu memadam ganjaran ini?",
        toast_reward_deleted: "Ganjaran Dipadam",
        toast_reward_added: "Ganjaran berjaya ditambah",
        toast_reward_updated: "Ganjaran dikemaskini",
        toast_avatar_format_error: "Gambar avatar mesti dalam format JPG!",
        toast_avatar_size_error: "Saiz gambar avatar tidak boleh melebihi 2MB!",
    },
    sparks: {
        custom_sparks: "sparks tersuai",
        program_only: "Program only",
        Create_a_Set: "Cipta Set",
        Set: "Set",
        HAPPILY_S_SPARKS: "SPARKS HAPPILY",
        Name_of_Spark_Set: "Nama Set Spark",
        Please_input_Set_Name: "Sila masukkan nama Set",
        Display_After: "Papar Selepas",
        Before_Set_one: "Sebelum Set 1",
        Audience: "Audiens",
        Set_name: "Nama set",
        Select: "Pilih",
        SAVE_CHANGES: "SIMPAN",
        CANCEL: "BATAL",
        DELETE_SPARK_SET: "PADAM SET SPARK",
        CREATE_SET: "CIPTA SET",
        Title: "Tajuk",
        Edit: "Edit",
        Draft: "Draf",
        Create_a_New_Card: "Cipta Kad Baharu",
        Spark_Title: "Tajuk Spark",
        Please_input_Spark_Title: "Sila masukkan Tajuk Spark",
        Spark_Icon: "Ikon Spark",
        Spark_Content_English: "Kandungan Spark - Inggeris",
        Spark_Content_Thai: "Kandungan Spark - Thai",
        SAVE_SPARK: "SIMPAN SPARK",
        DELETE: "PADAM",
        nudges: "Nudges",
        nudges_col_dimension: "Dimensi",
        nudges_col_nudge: "Nudge",
        nudges_col_recipient: "Penerima",
        nudges_col_date_time: "Tarikh & Masa",
        nudges_expand_all: "Kembangkan semua dalam set",
        nudges_hide_all: "Sembunyikan semua dalam set",
        nudges_load_more: "Muat lebih banyak",
        new_spark_set: "Set Spark Baharu",
        ai_placeholder: "Kemahiran atau pengetahuan apa yang anda mahu bangunkan micro learning tentangnya?",
        generate_spark_set: "Jana Set Spark",
        untitled: "TANPA TAJUK",
        spark_content_prefix: "Kandungan Spark -",
    },
    demomode: {
        demo_on: "Mod Demo Dihidupkan",
        demo_tooltip: "Nama pengguna dan nama pasukan akan disensor. Pergi ke Tetapan untuk maklumat lanjut.",
        detected_title: "Kami mengesan bahawa anda telah membiarkan mod demo hidup sejak log masuk terakhir anda.",
        detected_sub: "Jangan risau, kami akan mengekalkannya hidup antara muat semula halaman.",
        warning: "AMARAN: NAMA DAN BUTIRAN YANG DIPAPARKAN DALAM LAPORAN TIDAK AKAN DISENSOR",
    },
    sso: {
        your: "Anda",
        this_account: "Akaun ini",
        has_been_set: "telah ditetapkan untuk menggunakan single sign-on",
        google_sign_In: "Google Sign-In",
        sign_In: "Log Masuk",
        sign_Out: "Log Keluar",
        mobile_welcome_to: "Selamat datang ke",
        mobile_account_set_to_login: "Akaun anda ditetapkan untuk log masuk melalui SSO",
    },
    performance: {
        focus_areas: {
            select_team: "Pilih Pasukan",
            all_teams: "Semua Pasukan",
            search: "Cari",
            without_focus: "Tanpa Fokus",
            with_partners: "Dengan Rakan",
            goal_alignment: "Penjajaran Matlamat",
            all_items: "Semua Item",
            with_goal: "Dengan Matlamat",
            without_goal: "Tanpa Matlamat",
            people: "Orang",
            total: "jumlah",
            with_focus: "dengan fokus",
            no_focus: "tiada fokus",
            focus_coverage_trend: "Trend Liputan Fokus",
            last: "Terkini",
            weeks: "minggu",
            days: "hari",
            focus_items: "Item Fokus",
            unique: "unik",
            open: "terbuka",
            done: "selesai",
            focus_insights: "Cerapan Fokus",
            focus_distribution: "Taburan Fokus",
            in_progress: "Dalam Proses",
            completed: "Selesai",
            team_metrics: "Metrik Pasukan",
            team: "Pasukan",
            tooltip_total_people: "Jumlah orang dalam pasukan ini",
            tooltip_focusing: "Peratusan orang dengan sekurang-kurangnya satu item fokus",
            focusing: "Memfokus",
            tooltip_items_open_done: "Bilangan item dalam proses / item selesai",
            items_open_done: "Item (Buka / Selesai)",
            tooltip_completion: "Peratusan item fokus yang ditanda selesai",
            completion: "Penyiapan",
            tooltip_partnership: "Peratusan item fokus yang mempunyai sekurang-kurangnya satu rakan",
            partnership: "Perkongsian",
            no_results_found: "Tiada Keputusan Ditemui",
            no_focus_data_available: "Tiada Data Fokus",
            adjust_filters_hint: "Cuba laraskan penapis atau kata carian anda",
            empty_state_hint: "Bidang fokus akan muncul di sini setelah orang mula menetapkannya",
            no_focus_items: "Tiada item fokus",
            no_items_in_progress: "Tiada item dalam proses",
            no_completed_items: "Tiada item selesai",
            focus_item_details: "Butiran Item Fokus",
            focus_item_label: "ITEM FOKUS",
            description_label: "PENERANGAN",
            status_label: "STATUS",
            focus_partners: "Rakan Fokus",
            no_partners_for_item: "Tiada rakan untuk item fokus ini",
            partners_view: "Pandangan Rakan:",
            your_view: "Pandangan Anda:",
        },
        emergent_goals: {
            discover_goals: "Temui Matlamat",
            header_subtitle: "Cadangan dikuasakan AI daripada kerja tidak sepadan",
            run_fresh_analysis: "Jalankan analisis AI baharu",
            refresh: "Segar Semula",
            close: "Tutup",
            loading_hint: "Biasanya mengambil masa 30-60 saat",
            try_again: "Cuba Lagi",
            all_caught_up: "Semua Telah Dikemas Kini",
            all_caught_up_desc: "Tiada corak jelas ditemui dalam item fokus yang tidak sepadan. Kerja pasukan anda mungkin sudah sejajar dengan matlamat sedia ada.",
            auto_matched_desc: "item fokus dipadankan secara automatik dengan matlamat sedia ada",
            hide: "Sembunyi",
            show: "Tunjuk",
            review_matches: "Semak Padanan",
            matches_need_confirmation: "Padanan ini memerlukan pengesahan anda",
            focus_item: "Item Fokus",
            suggested_goal: "Matlamat Dicadangkan",
            accept: "Terima",
            skip: "Langkau",
            matched: "Dipadankan",
            skipped: "Dilangkau",
            suggested_new_goals: "Matlamat Baharu Dicadangkan",
            new_goals_desc: "Matlamat baharu ditemui daripada corak dalam kerja yang tidak sepadan",
            team: "Pasukan",
            recommended: "Disyorkan",
            select_team: "Pilih pasukan",
            link_to_parent: "Pautkan kepada Matlamat Induk",
            optional: "Pilihan",
            select_parent_goal: "Pilih matlamat induk",
            no_ancestor_goals: "Tiada matlamat pasukan induk tersedia",
            create_goal: "Cipta Matlamat",
            created: "Dicipta",
            done: "Selesai",
        },
        talent_matrix: {
            select_team: "Pilih Pasukan",
            all_teams: "Semua Pasukan",
            x_axis: "Paksi X",
            y_axis: "Paksi Y",
            swap_axes: "Tukar paksi",
            color_by_talent_type: "Warna ikut Jenis Bakat",
            color_by_team: "Warna ikut Pasukan",
            no_coloring: "Tanpa Warna",
            export_csv: "Eksport CSV",
            higher_is_better: "Lebih tinggi lebih baik",
            lower_is_better: "Lebih rendah lebih baik",
            employee_details: "Butiran Pekerja",
            employees: "pekerja",
            employee: "Pekerja",
            network: "Rangkaian",
            talent_type: "Jenis Bakat",
            quadrant: "Kuadran",
            engagement_wellbeing: "Penglibatan & Kesejahteraan",
            happiness_score: "Skor Kegembiraan",
            engagement_score: "Skor Penglibatan",
            flight_risk: "Risiko Berhenti",
            performance_growth: "Prestasi & Pertumbuhan",
            impact_rating: "Penarafan Impak",
            performance_score: "Skor Prestasi",
            focus_score: "Skor Fokus",
            goal_alignment: "Penjajaran Matlamat",
            recognition_trust: "Pengiktirafan & Kepercayaan",
            trust_score: "Skor Kepercayaan",
            peer_trust_count: "Jumlah Kepercayaan Rakan",
            giving_recognition: "Memberi Pengiktirafan",
            receiving_recognition: "Menerima Pengiktirafan",
            medals: "Pingat",
            power_skills_eq: "Power Skills (EQ)",
        },
        goals: {
            search_members: "Cari ahli",
            include_subteams: "Termasuk Sub-pasukan",
            include_subteams_tooltip: "Apabila didayakan, statistik penjajaran fokus merangkumi semua sub-pasukan",
            show_archived: "Tunjuk Arkib",
            show_archived_tooltip: "Tunjukkan matlamat diarkib yang telah dipadam lembut",
            krs_by_team: "KR ikut Pasukan",
            krs_by_individual: "KR ikut Individu",
            goal_alignment_tooltip: "Peratusan item fokus yang dipautkan kepada matlamat pasukan",
            expand_teams_to_load: "Kembangkan pasukan untuk memuatkan",
            aligned: "sejajar",
            unaligned: "tidak sejajar",
            unknown: "Tidak diketahui",
            unknown_items: "item fokus dengan penjajaran tidak diketahui",
            focus_items_alignment_unknown: "item fokus mempunyai penjajaran yang tidak diketahui kerana tiada matlamat ditetapkan",
            focus_items_not_aligned: "item fokus tidak sejajar dengan mana-mana matlamat",
            no_goals_to_map: "Tiada matlamat untuk dipetakan",
            members_with_krs: "Ahli dengan KR",
            total_krs: "Jumlah KR",
            assigned: "ditugaskan",
            avg_progress: "Purata Kemajuan",
            kr_status: "Status KR",
            on_track: "dalam landasan",
            at_risk: "berisiko",
            off_track: "luar landasan",
            goal_focus_trends: "Trend Fokus Matlamat",
            hide_items: "Sembunyi item",
            view_items: "Lihat item",
            has_value: "Ada Nilai",
            no_value: "Tiada Nilai",
            no_teams_found: "Tiada Pasukan Ditemui",
            no_teams_available: "Tiada Pasukan Tersedia",
            no_teams_adjust_filters: "Cuba laraskan kata carian atau penapis anda",
            no_teams_empty_hint: "Pasukan akan muncul di sini setelah dicipta",
            col_team: "PASUKAN",
            col_goals: "MATLAMAT",
            goal_name_placeholder: "Nama matlamat",
            save_changes: "Simpan",
            archived: "Diarkib",
            edit_goal: "Edit matlamat",
            archive_goal: "Arkib matlamat",
            restore_goal: "Pulihkan matlamat",
            delete_permanently: "Padam kekal",
            no_focus_on_goal_tooltip: "Tiada sesiapa memfokus matlamat ini",
            linked_to_parent_goals: "Dipautkan ke matlamat induk:",
            goal_description_placeholder: "Penerangan matlamat",
            goal_edit_hint: "Edit penerangan matlamat di atas. Gunakan butang Simpan di pengepala untuk mengesahkan perubahan.",
            key_results: "Hasil Utama",
            ai_suggest_krs_tooltip: "AI cadangkan hasil utama yang boleh diukur",
            add_kr_manually_tooltip: "Tambah hasil utama secara manual",
            no_kr_empty_hint: "Tambah hasil utama yang boleh diukur untuk menjejaki kemajuan",
            new_key_result: "Hasil Utama Baharu",
            kr_title_placeholder: "Tajuk hasil utama",
            start: "Mula",
            target: "Sasaran",
            unit: "Unit",
            unit_placeholder: "cth. %",
            owners: "Pemilik",
            assign_members_placeholder: "Tugaskan ahli pasukan",
            teams_group_label: "Pasukan",
            people_group_label: "Orang",
            tracking_mode: "Mod Penjejakan",
            tracking_collaborative: "Kolaboratif — kemajuan dikongsi",
            tracking_individual: "Individu — setiap orang",
            tracking_collaborative_hint: "Semua orang menyumbang kepada satu nombor",
            tracking_individual_hint: "Setiap orang menjejak kemajuan sendiri",
            tracking_individual_decreasing_warning: "Penjejakan individu menjumlahkan nilai setiap pemilik, yang tidak sesuai apabila sasaran lebih rendah daripada permulaan.",
            tracking_decreasing_reframe_hint: "Pertimbangkan untuk merangka semula sebagai metrik yang meningkat — cth., \"Tingkatkan pengekalan kepada 80%\" dan bukan \"Kurangkan pengurangan kepada 20%\".",
            targets_per_owner: "Sasaran setiap pemilik",
            owner_targets_match: "Sasaran individu berjumlah {sum} / sasaran pasukan {team}",
            owner_targets_short: "Sasaran individu berjumlah {sum} — sasaran pasukan ialah {team} (kurang {delta})",
            owner_targets_over: "Sasaran individu berjumlah {sum} — sasaran pasukan ialah {team} (lebih {delta})",
            owner_target_reset_tooltip: "Set semula kepada bahagian lalai",
            owner_target_customized_hint: "Sasaran tersuai",
            owner_target_customized_tag: "Tersuai",
            owner_targets_match_action: "Padankan sasaran pasukan kepada {sum}",
            cycle: "Kitaran",
            cycle_placeholder: "Berterusan (tiada kitaran)",
            add_key_result: "Tambah Hasil Utama",
            parent_goal_links: "Pautan Matlamat Induk",
            edit_links: "Edit Pautan",
            add_links: "Tambah Pautan",
            no_parent_links_yet: "Belum ada matlamat induk dipautkan",
            people_focusing_on_goal: "Orang yang memfokus matlamat ini:",
            no_members_found: "Tiada Ahli Ditemui",
            no_members_available: "Tiada Ahli Tersedia",
            select_team_to_view: "Pilih pasukan untuk melihat KR ahli",
            krs_label: "KR",
            no_krs_assigned: "Tiada KR ditugaskan",
            tab_freeform: "Bebas",
            tab_advanced: "Lanjutan",
            freeform_description: "Masukkan matlamat sebagai teks bebas. AI akan menstrukturkannya kepada matlamat individu dengan penerangan.",
            advanced_description_existing: "Edit matlamat sedia ada atau tambah yang baharu.",
            advanced_description_new: "Tambah matlamat terus dengan tajuk dan penerangan. Tiada transformasi AI diperlukan.",
            goal_label: "Matlamat",
            existing: "Sedia Ada",
            new: "Baharu",
            goal_title_placeholder: "Tajuk matlamat (cth., Tingkatkan kepuasan pelanggan)",
            goal_description_optional_placeholder: "Penerangan (pilihan - berikan butiran lanjut mengenai matlamat ini)",
            link_to_parent_goals: "Pautkan kepada Matlamat Induk",
            linked: "dipautkan",
            select_parent_goals_placeholder: "Pilih matlamat induk untuk dijajarkan...",
            no_parent_team_goals: "Tiada matlamat pasukan induk untuk dipautkan",
            add_another_goal: "Tambah matlamat lain",
            link_subtitle: "Jajarkan matlamat ini dengan objektif peringkat lebih tinggi",
            current_goal: "Matlamat Semasa",
            no_parent_goals_available: "Tiada Matlamat Induk Tersedia",
            no_parent_goals_desc: "Pasukan induk perlu mempunyai matlamat sebelum anda boleh mencipta pautan penjajaran.",
            select_parent_goals: "Pilih Matlamat Induk",
            links: "Pautan",
            link_noun: "Pautan",
            remove_all_links: "Buang Semua Pautan",
            toast_updated: "Matlamat berjaya dikemaskini",
            toast_update_failed: "Gagal mengemaskini matlamat",
            toast_archived: "Matlamat berjaya diarkib",
            toast_archive_failed: "Gagal mengarkib matlamat",
            toast_restored: "Matlamat berjaya dipulihkan",
            toast_restore_failed: "Gagal memulihkan matlamat",
            toast_deleted: "Matlamat dipadam kekal",
            toast_delete_failed: "Gagal memadam matlamat",
            kr_cycle: "KITARAN",
            kr_cycle_placeholder: "Berterusan",
            kr_start: "MULA",
            kr_target: "SASARAN",
            kr_unit: "UNIT",
            kr_collaborative: "Kolaboratif",
            kr_individual: "Individu",
            kr_status_on_track: "Dalam Landasan",
            kr_status_at_risk: "Berisiko",
            kr_status_off_track: "Luar Landasan",
            kr_status_completed: "Selesai",
            kr_search_team_or_member: "Cari pasukan atau ahli",
            kr_teams_section: "Pasukan",
            kr_people_section: "Orang",
            kr_no_members_found: "Tiada ahli ditemui",
            kr_clear_all: "Kosongkan semua",
            kr_note_placeholder: "Nota (pilihan)",
            kr_status_auto: "Auto (berdasarkan kemajuan)",
            kr_status_manual_dot_tooltip: "Status ditetapkan secara manual oleh {name}",
            kr_status_manual_dot_tooltip_unknown: "Status ditetapkan secara manual",
            kr_meta_updated_by: "Dikemas kini {time} oleh {name}",
            kr_meta_updated_auto: "Dikemas kini {time} secara automatik",
            kr_meta_updated: "Dikemas kini {time}",
            kr_history_title: "Sejarah kemas kini",
            kr_history_empty: "Tiada kemas kini lagi",
            kr_history_show_all: "Tunjukkan semua {count} kemas kini",
            kr_history_automation_actor: "Automasi",
            kr_history_team_total: "Jumlah pasukan {value}",
            kr_history_unknown_actor: "Tidak diketahui",
            kr_detail_eyebrow: "Hasil Utama",
            kr_detail_of_target: "daripada sasaran",
            kr_detail_delta_since: "{delta} sejak kemas kini terakhir",
            kr_detail_chart_title: "Kemajuan mengikut masa",
            kr_detail_chart_empty: "Belum cukup kemas kini untuk carta — setiap kemas kini kemajuan akan dipaparkan di sini.",
            kr_detail_target_label: "Sasaran",
            kr_detail_owners: "Pemilik",
            kr_detail_no_owners: "Belum ada pemilik ditugaskan",
            kr_detail_automation: "Automasi",
            kr_detail_last_synced: "Disegerak terakhir {time}",
            kr_detail_last_checked: "Disemak terakhir {time}",
            kr_detail_awaiting_sync: "Menunggu penyegerakan pertama",
            kr_detail_automation_paused: "Automasi dijeda",
            kr_detail_cadence_daily: "berjalan setiap hari pada {time}",
            kr_detail_cadence_weekly: "berjalan setiap minggu pada hari {day} pada {time}",
            kr_detail_cadence_monthly: "berjalan setiap bulan pada hari {dayOfMonth} pada {time}",
            kr_detail_reconnect: "Sambung semula",
            kr_detail_edit_automation: "Edit automasi",
            kr_detail_pause_automation: "Jeda",
            kr_detail_resume_automation: "Sambung",
            kr_detail_delete_automation: "Padam",
            kr_detail_update_progress: "Kemas kini kemajuan",
            kr_detail_edit_kr: "Edit hasil utama",
            kr_detail_save_update: "Simpan kemas kini",
            suggest_kr_title: "Cadangkan Hasil Utama",
            suggest_kr_subtitle: "Hasil boleh diukur dikuasakan AI untuk matlamat anda",
            run_fresh_ai_analysis: "Jalankan analisis AI baharu",
            refresh: "Segar Semula",
            kr_loading_hint: "Biasanya mengambil masa 15-30 saat",
            try_again: "Cuba Lagi",
            no_suggestions_title: "Tiada Cadangan Tersedia",
            no_suggestions_desc: "Cuba tambah butiran lanjut pada penerangan matlamat atau jajarkan lebih banyak item fokus kepada matlamat ini.",
            goal_context: "Konteks Matlamat",
            kr_added: "Ditambah",
            kr_skipped: "Dilangkau",
            kr_confidence: "keyakinan",
            kr_ai_reasoning: "Penaakulan AI",
            kr_owner: "Pemilik",
            kr_assign_later: "Tugaskan kemudian",
            kr_skip: "Langkau",
            kr_accept: "Terima",
            toast_confirm_delete_kr: "Padam hasil utama ini? Tindakan ini tidak boleh dibatalkan.",
            toast_delete_kr_title: "Padam Hasil Utama",
            toast_confirm_delete_automation: "Padam automasi ini? Hasil Utama dan sejarah kemas kininya akan dikekalkan, tetapi kemas kini automatik akan berhenti.",
            toast_delete_automation_title: "Padam Automasi",
            toast_automation_paused: "Automasi dijeda",
            toast_automation_resumed: "Automasi disambung",
            toast_automation_deleted: "Automasi dipadam",
            toast_automation_update_failed: "Tidak dapat mengemas kini automasi",
            toast_automation_delete_failed: "Tidak dapat memadam automasi",
            toast_add_at_least_one_goal: "Sila tambah sekurang-kurangnya satu matlamat dengan tajuk",
            toast_goal_title_too_long: "Tajuk matlamat mestilah 30 aksara atau kurang",
            toast_goals_saved_successfully: "Matlamat berjaya disimpan",
            toast_no_data_to_export: "Tiada data untuk dieksport",
            toast_goal_title_too_long_single: "Tajuk matlamat mestilah 30 aksara atau kurang",
            toast_confirm_save_changes: "Adakah anda pasti untuk menyimpan perubahan pada matlamat ini?",
            toast_confirm_changes_title: "Sahkan Perubahan",
            toast_failed_to_update_goal: "Gagal mengemaskini matlamat",
            toast_confirm_archive: "Adakah anda pasti untuk mengarkibkan matlamat ini? Ia boleh dipulihkan kemudian dari pandangan \"Tunjuk Arkib\".",
            toast_archive_title: "Arkib Matlamat",
            toast_confirm_restore: "Adakah anda pasti untuk memulihkan matlamat ini? Ia akan kelihatan dalam senarai matlamat aktif.",
            toast_restore_title: "Pulihkan Matlamat",
            toast_confirm_delete_goal: "Adakah anda pasti untuk memadam matlamat ini secara kekal? Tindakan ini tidak boleh dibatalkan.",
            toast_delete_goal_title: "Padam Matlamat",
            toast_goal_linked_prefix: "Matlamat dipautkan kepada",
            toast_goal_linked_suffix: "matlamat induk",
            toast_parent_links_removed: "Pautan matlamat induk dibuang",
            toast_failed_update_goal_links: "Gagal mengemaskini pautan matlamat",
        },
    },
    settings: {
        page_title: "Tetapan",
        page_description: "Urus ciri, komunikasi dan pengalaman seluruh syarikat",
        save_changes: "Simpan",
        undo: "Buat Asal",
        changes_banner: "Anda telah membuat perubahan pada tetapan anda",
        tab_general: "Tetapan Umum",
        tab_performance: "Penilaian Prestasi",
        tab_values: "Kemahiran & Nilai",
        tab_village: "Happily Village",
        tab_email_notifications: "Pemberitahuan E-mel",
        section_general: "SYARIKAT & KOMUNIKASI",
        section_general_description: "Urus butiran syarikat, jadual penghantaran, cuti, keutamaan feed, privasi dan akses sokongan.",
        company_name: "Nama Syarikat",
        pulse_report_schedule: "Jadual Pulse & Laporan",
        pulse_report_schedule_description: "Tetapkan masa soalan dan laporan dihantar kepada pasukan anda",
        daily_pulse: "Daily Pulse",
        daily_insights: "Cerapan Harian",
        weekly_insights: "Cerapan Mingguan",
        monthly_insights: "Cerapan Bulanan",
        company_holidays: "Cuti Syarikat",
        company_holidays_description: "Soalan Daily Pulse dijeda pada cuti syarikat yang akan datang",
        add_holidays: "Tambah Cuti",
        personal_holiday_presets: "Pratetap Cuti Peribadi",
        personal_holiday_presets_description: "Cipta jadual cuti khusus pasukan atau ahli untuk menjeda soalan Daily Pulse pada hari cuti individu",
        set_personal_holiday: "Tetapkan Cuti Peribadi",
        activity_feed_names: "Nama dalam Activity Feed",
        activity_feed_names_description: "Apabila didayakan, baris Activity Feed memaparkan nama panggilan jika tersedia. Apabila dilumpuhkan, baris menggunakan nama pertama.",
        use_nicknames_in_activity_feed: "Gunakan nama panggilan dalam Activity Feed",
        activity_feed_rewards: "Aktiviti Ganjaran",
        activity_feed_rewards_description: "Apabila didayakan, penebusan ganjaran akan muncul dalam Activity Feed. Matikan untuk menyembunyikan aktiviti penebusan ganjaran daripada feed.",
        show_reward_redemptions_in_activity_feed: "Tunjukkan penebusan ganjaran dalam Activity Feed",
        allow_cross_location_gift_rewards: "Benarkan ganjaran hadiah merentas lokasi",
        allow_cross_location_gift_rewards_description: "Benarkan pekerja menghantar ganjaran hadiah kepada rakan sekerja di negara atau lokasi lain. Ganjaran tempatan mungkin masih memaparkan amaran jika penerima mungkin tidak dapat menebusnya.",
        happily_assistance: "Happily Assistance",
        happily_assistance_description: "Benarkan pasukan Happily mengakses konsol anda untuk membantu pengurusan akaun dan cadangan.",
        happily_assist_access: "Akses Happily Assist",
        demo_mode: "Mod Demo",
        demo_mode_description: "Nama pengguna, e-mel, pasukan dan imej profil yang dikaitkan dengan ahli sedia ada akan dikaburkan di semua halaman apabila mod demo dihidupkan. Gunakan dengan berhati-hati - sebahagian elemen mungkin tidak disensor sepenuhnya.",
        enable_demo_mode: "Dayakan Mod Demo",
        section_performance: "PENILAIAN & MAKLUM BALAS",
        section_performance_description: "Kawal alat penilaian pengurus, masa status penilaian dan gesaan refleksi.",
        enable_performance_boosts: "Dayakan Performance Boosts",
        enable_performance_boosts_description: "Performance Boosts membolehkan pengurus memberi maklum balas berstruktur dan pengiktirafan melalui anugerah Gems. Data ini menyumbang kepada Impact Ratings pekerja.",
        performance_boosts: "Performance Boosts",
        performance_boost_notice: "Notis Performance Boost",
        performance_boost_notice_description: "Tetapkan jadual penilaian optimum untuk pengurus memberi penilaian prestasi",
        pending_after: "Belum Selesai selepas",
        overdue_after: "Lewat selepas",
        ai_reviewed_feedback: "Maklum Balas Disemak AI",
        reset_monthly: "Tetap Semula Bulanan",
        section_values: "PENGIKTIRAFAN & MAKLUM BALAS RAKAN SEBAYA",
        section_values_description: "Tentukan nilai dan kemahiran yang digunakan untuk mengiktiraf rakan sekerja dan memberi maklum balas.",
        recognition_values: "Nilai Pengiktirafan",
        recognition_values_description: "Pengiktirafan dipacu oleh rakan sebaya dan pengurus boleh dipandu atau diselaraskan dengan nilai syarikat tertentu, diwakili sebagai hashtag dalam interaksi pengiktirafan",
        new_value: "Nilai Baharu",
        peer_feedback: "Maklum Balas Rakan Sebaya",
        peer_feedback_description: "Pada awal setiap bulan, setiap ahli boleh memilih sehingga 2 orang untuk menerima maklum balas daripadanya. Apabila memberi maklum balas, penilai boleh menetapkan tag berikut yang mewakili apa yang penerima \"kuasai\":",
        peer_feedback_interactions: "Interaksi Maklum Balas Rakan Sebaya",
        new_skill: "Kemahiran Baharu",
        section_village: "AKSES & PENYERTAAN",
        section_village_description: "Urus akses Village, pemarkahan House, kebenaran perbincangan dan topik janaan AI.",
        village_access: "Akses Village",
        village_access_description: "Semua ahli akan mempunyai akses ke Happily Village dengan interaksi yang menggalakkan kesejahteraan, pembelajaran, dan kerjasama dengan Running Track, University, Houses, dan banyak lagi!",
        happily_village_access: "Akses Happily Village",
        fair_play_boost: "Fair Play Boost Battle Stadium",
        fair_play_boost_description: "Seimbangkan Skor House apabila saiz House berbeza dengan ketara. XP peribadi dan papan kedudukan misi tidak diselaraskan.",
        fair_play_boost_enabled_note: "Diaktifkan. Saiz House akan diperiksa apabila misi Isnin seterusnya bermula. Misi aktif tidak akan berubah.",
        fair_play_boost_disabled_note: "Dilumpuhkan. Skor House akan menggunakan kaedah pemarkahan standard. Perubahan berkuat kuasa pada misi Isnin seterusnya.",
        topic_creation_permissions: "Kebenaran Penciptaan Topik",
        topic_creation_permissions_description: "Kawal siapa yang boleh memulakan perbincangan di Town Hall. Apabila dihadkan, hanya admin syarikat boleh mencipta topik baharu, manakala semua pekerja masih boleh menyertai perbincangan sedia ada.",
        allow_employee_topic_creation: "Benarkan Penciptaan Topik oleh Pekerja",
        town_hall_agent: "Town Hall Agent",
        town_hall_agent_description: "Tingkatkan perbincangan tempat kerja dengan pencetus perbualan berkuasa AI. Town Hall Agent mencipta topik dan undian yang menarik berdasarkan tema pilihan anda, memupuk dialog bermakna dan penglibatan pekerja dalam dataran maya anda.",
        performance_conversations: "Perbualan Prestasi",
        performance_conversations_description: "Selepas kemas kini key result, jemput refleksi ringkas yang memulakan perbualan dengan pengurus. Kata-kata hanya dihantar kepada pengurus. Garis masa memaparkan ringkasan neutral sahaja.",
        add_theme: "Tambah Tema",
        section_email_notifications: "E-MEL PENGURUS & HR",
        section_email_notifications_description: "Pilih amaran aktiviti, laporan berkala dan butiran maklum balas yang dihantar melalui e-mel.",
        cancel: "Batal",
        confirm: "Sahkan",
        toast_valid_data_required: "Data sah diperlukan.",
        toast_saving_changes: "Menyimpan perubahan...",
        toast_generated_attributes_prefix: "Dijana",
        toast_generated_attributes_middle: "atribut untuk",
        toast_generate_attributes_failed: "Gagal menjana atribut. Sila cuba lagi.",
        toast_this_value: "nilai ini",
        toast_recognition_delete_prefix: "Sebarang pengiktirafan yang dihantar dengan",
        toast_recognition_delete_suffix: "akan kehilangan kaitan dengan nilai ini. Tindakan ini tidak boleh diundur.",
        toast_delete_label: "Padam",
    },
    skills: {
        learning_journeys: {
            select_placeholder: "Pilih",
            overview: "Gambaran Keseluruhan",
            active_learning_journeys: "Learning Journey Aktif",
            completed_journeys: "Journey Selesai",
            members_upskilled: "Ahli Ditingkatkan Kemahiran",
            learning_time: "Masa Pembelajaran",
            activation_channel: "Saluran Pengaktifan",
            activation_channel_description: "Learning journey dimulakan oleh pengurus (fokus prestasi) atau dimulakan sendiri (pertumbuhan peribadi)",
            manager: "Pengurus",
            self: "Sendiri",
            top_learners: "Pelajar Teratas",
            top_learners_subtitle: "Ahli pasukan dengan paling banyak learning journey",
            view_all: "Lihat Semua",
            learning_journey_progress: "Kemajuan Learning Journey",
            view_skill_category_analytics: "Lihat Analitik Kategori Kemahiran",
            status: "Status",
            skill_set: "Set Kemahiran",
            progress: "Kemajuan",
            initiated_by: "Dimulakan oleh",
            assigned_to: "Ditugaskan Kepada",
            date_time: "Tarikh & masa",
            loading_more_items: "Memuatkan lebih banyak item...",
            end_of_list: "Akhir senarai",
            empty_state: "Tiada learning journey sepadan dengan penapis anda.",
            top_learners_explanation: "Ahli pasukan yang telah menyertai paling banyak learning journey dalam tempoh masa yang dipilih",
            search_member: "Cari ahli",
            no_learners_found: "Tiada pelajar ditemui sepadan dengan carian anda.",
            skill_category_analytics: "Analitik Kategori Kemahiran",
            skill_category_analytics_subtitle: "Taburan learning journey mengikut kategori kemahiran",
            time_period: "Tempoh Masa:",
            search_category: "Cari kategori",
            categories: "Kategori",
            total_journeys: "Jumlah Journey",
            active: "Aktif",
            completed: "Selesai",
            category: "Kategori",
            distribution: "Taburan",
            total: "Jumlah",
            no_categories_found: "Tiada kategori ditemui sepadan dengan carian anda.",
        },
        power_skills: {
            select_placeholder: "Pilih",
            all_teams: "Semua Pasukan",
            team: "Pasukan",
            progress_and_ratings: "Kemajuan & Penarafan Power Skills",
            progress_and_ratings_subtitle: "Skor usaha keseluruhan untuk mempraktikkan setiap kemahiran dengan trend penarafan dan leaderboard dari 6 bulan lalu",
            loading: "Memuatkan data Power Skills...",
            error_title: "Tidak dapat memuatkan data Power Skills",
            retry: "Cuba Semula",
            empty_title: "Tiada data Power Skills tersedia",
            empty_description: "Tiada data untuk dipaparkan bagi kriteria yang dipilih.",
            company_avg: "Purata Syarikat",
            percentile_75th: "75th",
            median: "Median",
            percentile_25th: "25th",
            leaderboard: "LEADERBOARD",
            sort_by: "Susun ikut",
            sort_all: "Semua",
            ascending_rating: "Penarafan Menaik",
            ascending_score: "Skor Menaik",
            descending_rating: "Penarafan Menurun",
            descending_score: "Skor Menurun",
        },
        development: {
            select_placeholder: "Select a team",
            all_teams: "All Teams",
            search: "Search members",
            members_label: "members",
            vs_prior: "vs prior",
            member: "Member",
            rating_trend: "Rating trend",
            top_strength: "Top strength",
            development_area: "Development area",
            journeys: "Journeys",
            summary: "Summary",
            fresh: "Fresh",
            stale: "Stale",
            needs_data: "Needs data",
            none: "Not generated",
            completed_short: "done",
            active_short: "active",
            evidence: "Evidence",
            peer_count: "{n} peer",
            peers_count: "{n} peers",
            manager_review_count: "{n} manager review",
            manager_reviews_count: "{n} manager reviews",
            no_manager_reviews_short: "No manager reviews",
            no_feedback_yet: "No feedback yet",
            what_changed: "Apa yang berubah",
            vs_previous_months: "berbanding {n} bulan sebelumnya",
            peer_rating: "Penilaian rakan",
            manager_goals: "Pengurus · Matlamat",
            manager_culture: "Pengurus · Budaya",
            mv_improved: "Bertambah baik",
            mv_new_strength: "Kekuatan baharu",
            mv_still_developing: "Masih berkembang",
            mv_watch: "Perlu diperhatikan",
            mv_growth_to_strength: "bidang perkembangan ×{was} dahulu, kini kekuatan ×{now}",
            mv_new_strength_detail: "kekuatan ×{now} tempoh ini, tidak disebut sebelum ini",
            mv_still_detail: "bidang perkembangan kedua-dua tempoh (×{was} → ×{now})",
            mv_watch_detail: "dahulu kekuatan, kini bidang perkembangan ×{now}",
            consistent_picture: "Gambaran konsisten. Tiada kemahiran bertukar bahagian.",
            recognized_for: "Diiktiraf untuk:",
            new_short: "baharu",
            volume_caption: "Berdasarkan {nowFb} maklum balas daripada {nowPeers} rakan dan {nowReviews} penilaian pengurus (berbanding {prevFb} daripada {prevPeers} rakan, {prevReviews} penilaian sebelumnya)",
            open_hint: "Click a member to open their development picture",
            back: "Back to roster",
            export: "Export",
            regenerate: "Regenerate",
            generated_on: "Generated",
            development_summary: "Development summary",
            provenance: "Generated from {feedback} feedback events, {journeys} journeys, {reviews} reviews",
            strengths_themes: "Strengths",
            development_areas: "Development areas",
            trajectory_statement: "Trajectory",
            suggested_focus: "Suggested focus",
            summary_unavailable: "Summary unavailable right now.",
            retry: "Retry",
            needs_data_hint: "Not enough feedback in this period to generate a summary. Evidence below shows what exists so far.",
            trajectory: "Trajectory",
            trajectory_hint: "Average peer-feedback rating received per month (1-4)",
            skills_title: "Strengths & development areas",
            skills_hint: "Peer feedback mentions in this period, with change vs the prior period",
            strengths: "Strengths",
            mentions: "mentions",
            evidence_journeys: "Learning journeys",
            evidence_recognition: "Recognition",
            evidence_behaviors: "Feedback behaviors",
            evidence_performance: "Performance",
            journeys_completed: "Completed",
            journeys_active: "In progress",
            learning_time: "Learning time",
            no_journeys: "No journeys in this period",
            received: "Received",
            given: "Given",
            no_recognition: "No recognition in this period",
            requested: "Requested",
            response_rate: "Response rate",
            no_feedback: "No feedback activity in this period",
            no_reviews: "No reviews",
            goal_rating: "Goals",
            culture_rating: "Culture",
            no_ratings: "No ratings yet",
            no_members: "No members match the current filters",
            member_not_found: "This member isn't in the current roster.",
            rating_truly: "Truly Outstanding",
            rating_exceeding: "Exceeding Expectations",
            rating_meeting: "Meeting Expectations",
            rating_needs: "Needs Improvement",
            holding: "holding",
            generate_report: "Generate report",
            generate_hint: "The AI development summary is generated on demand and cached for later visits.",
            generating: "Generating…",
            not_generated: "Not generated",
            deterministic_brief: "Development brief",
            strongest_signal: "Strongest signal",
            most_cited_growth: "Most-cited growth area",
            rating_label: "Rating",
            typically: "typically {label}",
            what_peers_said: "What peers said",
            mentions_count: "{n} mentions",
            mention_count: "{n} mention",
            new_label: "new",
            paraphrased_from: "Paraphrased from {n} comments",
            paraphrased_from_one: "Paraphrased from 1 comment",
            also_growth_note: "Also named a growth area by {n} peers",
            also_praised_note: "Also praised by {n} peers",
            privacy_quotes: "Quotes are AI-paraphrased and anonymous; original comments are never shown.",
            privacy_pre_ai: "Until the AI report is generated, this section lists cited behaviors and counts only.",
            self_reflection: "Self reflection · in their own words",
            own_answer_verbatim: "Their own answer, shown verbatim",
            reflection_source: "From {name}'s answers to Self Awareness reflection questions in this period ({n} total).",
            development_story: "Development story",
            feedback_loops: "Feedback loops — who, and when",
            peer_feedback_received: "Peer feedback received",
            manager_review_boost: "Manager review boost",
            manager_role: "manager",
            others_row: "{n} others",
            other_row: "1 other",
            growth_moments: "Growth moments",
            feedback_from: "Feedback from {names}",
            feedback_from_peers: "Feedback from {n} peers",
            baseline_title: "Baseline",
            now_title: "Now",
            manager_review_title: "Manager review boost",
            goals_label: "Goals",
            culture_label: "Culture",
            journeys_also: "Also this period: {done} journeys completed, {progress} in progress — {cats}.",
            journeys_also_none_progress: "Also this period: {done} journeys completed — {cats}.",
            manager_review_boosts: "Manager review boosts",
            no_manager_reviews: "No manager reviews in this period.",
            from_name: "from {name}",
            skill_balance: "Skill balance",
            activity_footnote: "Feedback activity this period: {received} received from {givers} givers · gave {given} — full activity lives in Proficiencies. Values recognition received: {tags} ({events} events).",
            strengths_cited: "Strengths cited: {names}.",
            growth_cited: "Growth: {names}.",
        },
        proficiencies: {
            select_placeholder: "Pilih",
            all_teams: "Semua Pasukan",
            all_time: "Sepanjang Masa",
            past_year: "Setahun Lalu",
            past_6_months: "6 Bulan Lalu",
            past_3_months: "3 Bulan Lalu",
            current_month: "Bulan ini",
            last_month: "Bulan lalu",
            overview: "Gambaran Keseluruhan",
            rating_overview: "Gambaran Penarafan",
            rating_overview_description: "Taburan penarafan terhadap matlamat syarikat daripada interaksi maklum balas rakan sebaya.",
            truly_outstanding: "Benar-benar Cemerlang",
            exceeding_expectations: "Melangkaui Jangkaan",
            meeting_expectations: "Memenuhi Jangkaan",
            needs_improvement: "Perlu Penambahbaikan",
            highest_rated: "Penarafan Tertinggi",
            highest_rated_description: "Individu dengan penarafan maklum balas rakan sebaya tertinggi, pada skala 1 hingga 4",
            lowest_rated: "Penarafan Terendah",
            lowest_rated_description: "Individu dengan penarafan maklum balas rakan sebaya terendah, pada skala 1 hingga 4",
            see_all: "lihat semua",
            skills_proficiency: "Kecekapan Kemahiran",
            skills_excel_at: "Kemahiran Yang Dikuasai",
            skills_improve_at: "Kemahiran Yang Boleh Diperbaiki",
            skill_selected_description: "Bilangan kali kemahiran dipilih (berbanding tempoh masa sebelumnya)",
            excels_at: "Cemerlang dalam",
            could_further_improve: "Boleh diperbaiki lagi",
            members_excel: "ahli cemerlang",
            members_could_improve: "ahli boleh diperbaiki lagi",
            peer_feedback_rating: "Penarafan Maklum Balas Rakan Sebaya",
            rank: "Kedudukan",
            average_rating: "Penarafan Purata",
            interactions: "Interaksi",
            peer_feedback: "Maklum Balas Rakan Sekerja",
            behaviors_title: "Tingkah laku maklum balas mengikut individu",
            behaviors_description: "Sejauh mana setiap individu terlibat dalam maklum balas rakan sekerja, daripada meminta hingga memberikannya kepada orang lain, berserta penarafan purata yang diterima",
            loading_behaviors: "Memuatkan aktiviti maklum balas...",
            requests_made: "Permintaan Dibuat",
            feedback_given: "Maklum Balas Diberi",
            participation: "Penyertaan",
            requested: "Meminta",
            received: "Diterima",
            given: "Diberi",
            no_behaviors: "Tiada aktiviti maklum balas dalam tempoh ini",
            strengths_title: "Kekuatan & bidang pembangunan",
            strengths_description: "Kemahiran yang diiktiraf rakan sekerja sebagai kekuatan dan bidang yang boleh dipertingkatkan, untuk membantu keutamaan pembelajaran dan pembangunan",
            strength_mentions: "Sebutan Kekuatan",
            development_mentions: "Sebutan Pembangunan",
            development_areas: "Bidang pembangunan",
            strengths: "Kekuatan",
            mentions_label: "sebutan",
            people_label: "orang",
            showing_top_skills: "Menunjukkan 10 kemahiran paling kerap disebut",
            members_label: "ahli",
            no_skill_mentions: "Tiada maklum balas kemahiran dalam tempoh ini",
            total_ratings: "Jumlah Penilaian",
            ratings_label: "penilaian",
            no_ratings: "Tiada penilaian maklum balas dalam tempoh ini",
            asked: "Diminta",
            receiving_feedback: "Menerima Maklum Balas",
            giving_feedback: "Memberi Maklum Balas",
            response_rate: "Respons %",
            response_rate_hint: "Daripada maklum balas yang diminta rakan sekerja, bahagian yang diberikannya semula",
            rating_short: "Penarafan",
            requested_hint: "Permintaan maklum balas yang dihantar oleh individu ini kepada rakan sekerja",
            received_hint: "Maklum balas yang diterima oleh individu ini daripada rakan sekerja",
            asked_hint: "Permintaan maklum balas yang dihantar oleh rakan sekerja kepada individu ini",
            given_hint: "Maklum balas yang diberikan oleh individu ini kepada rakan sekerja",
            average_rating_hint: "Penarafan purata rakan sebaya, dari 1 (Perlu Penambahbaikan) hingga 4 (Benar-benar Cemerlang)",
            participation_hint: "Bahagian ahli yang meminta atau memberi maklum balas dalam tempoh ini",
            skill_details: "Butiran kemahiran",
            by_attribute: "Mengikut atribut",
            attribute_hint: "Bahagian sebutan yang menonjolkan setiap atribut",
        },
    },
    focus: {
        last_7_days: "7 hari lepas",
        last_30_days: "30 hari lepas",
        last_60_days: "60 hari lepas",
        last_90_days: "90 hari lepas",
    },
    programs: {
        Completion_reward: "Reward",
        Add_completion_reward: "Add reward",
        Currency_coins: "Coins",
        Currency_gems: "Gems",
        Currency_xp: "XP",
        Reward_needs_value: "1 reward needs a value",
        Reward_reason_placeholder: "Why are they getting this?",
    },
};
